// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Assets/images/login-back.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Assets/icons/checked.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

nav {
  height: 80px;
  position: relative;
  z-index: 2;
  background-color: #fff;
}
nav .nav-wrapper {
  box-shadow: 0px 4px 10px -8px rgba(0, 0, 0, 0.75);
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
nav .mobile_nav_wrapper {
  display: none;
}
nav .left-menu {
  display: flex;
  align-items: center;
  gap: 8px;
}
nav .left-menu .nav_logo {
  width: 200px;
}
nav .ant-avatar {
  background-color: #f6f6f6;
}
nav .right-profile {
  display: flex;
  align-items: center;
}
nav .right-profile .notifications {
  margin-right: 40px;
  cursor: pointer;
}
nav .right-profile .profile {
  display: flex;
  gap: 7px;
  align-items: center;
  min-width: 150px;
}
nav .right-profile .profile .info h3 {
  font-weight: 500;
  font-size: 12px;
}
nav .right-profile .profile .info .pro_account {
  font-family: cursive;
}
nav .right-profile .profile .info span {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 5px;
  border-radius: 4px;
  background-color: #edf8fe;
  color: #517a9a;
  text-transform: uppercase;
  box-sizing: border-box;
  border: 1px solid #32b4fd;
}
nav .right-profile .profile .avatar {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
nav .right-profile .profile .my_image {
  width: 50px;
  height: 50px;
}
nav .right-profile .drop-down {
  margin-left: 20px;
  cursor: pointer;
}

.my_image_big {
  width: 200px;
  height: 200px;
  border-radius: 5px;
}

@media (max-width: 700px) {
  nav {
    box-shadow: 0px 2px 6px 0px rgba(13, 10, 44, 0.0784313725);
    display: flex;
    align-items: center;
    padding: 16px;
  }
  nav .nav-wrapper {
    display: none;
  }
  nav .mobile_nav_wrapper {
    display: flex;
    width: 100%;
  }
  nav .mobile_nav_wrapper .left-menu {
    width: 100%;
    justify-content: space-between;
  }
}
* {
  font-family: "Inter";
}

.ant-form-item-explain-error {
  position: absolute;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s; /* Smooth transition for background color */
  -webkit-text-fill-color: #333 !important; /* Custom text color */
  -webkit-box-shadow: 0 0 0px 1000px #fff inset; /* Change #fff to match your form's input background color */
}

/* For Firefox */
input:-moz-ui-autofill,
input:-moz-ui-autofill:hover,
input:-moz-ui-autofill:focus,
input:-moz-ui-autofill:active {
  background-color: transparent !important;
}

.ant-layout-sider-trigger {
  position: absolute;
  z-index: 5 !important;
  top: 0;
  background: transparent !important;
  max-width: 30px;
  height: 30px;
  top: 20px;
  left: 20px;
  display: none;
}
.ant-layout-sider-trigger svg {
  display: none;
}

.ant-layout-sider,
.ant-layout-sider-dark,
.ant-layout-sider-has-trigger {
  background-color: transparent !important;
}

.ant-menu {
  padding-bottom: 0;
  background: #fff;
  padding-top: 10px;
  border: none !important;
  padding-bottom: 20px;
}

.ant-layout-sider-children {
  background-color: #fff !important;
  flex-direction: column;
  justify-content: space-between !important;
  padding-right: 5px;
  padding-left: 5px;
  max-height: 100vh;
  overflow: auto;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.ant-layout-sider-children .sider_wrapper {
  max-height: calc(100vh - 80px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.ant-layout-sider-children .demo_logo {
  display: flex;
  justify-content: center;
  gap: 5px;
  align-items: center;
  height: 80px;
  padding: 30px;
  border-bottom: 1px solid #e2e2e2;
}
.ant-layout-sider-children .demo_logo .nav_logo {
  width: 140px;
}
.ant-layout-sider-children .demo_logo .logo_min {
  height: 50px;
}
.ant-layout-sider-children .demo_logo img {
  transition: all 0.3s ease;
}
.ant-layout-sider-children .demo_logo .nav_logo_min {
  width: 0;
  opacity: 0;
  pointer-events: none;
}
.ant-layout-sider-children .demo_logo .nav_logo_mini {
  height: 40px !important;
}
.ant-layout-sider-children::-webkit-scrollbar {
  display: none;
}

.demo-logo-vertical {
  display: none;
}

.secondary-menu {
  border-top: 1px solid #e2e2e2 !important;
}
.secondary-menu .ant-menu-item-selected {
  background-color: transparent !important;
}
.secondary-menu .ant-menu-item:last-child {
  color: #ED4C5C !important;
}

.ant-layout-sider,
.ant-layout-sider-dark {
  max-width: 240px !important;
  width: 240px !important;
  position: absolute;
  z-index: 3;
  min-width: 240px !important;
}

.ant-layout-sider-has-trigger {
  padding-bottom: 0 !important;
}

.ant-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.ant-layout-sider-collapsed {
  max-width: 64px !important;
  width: 64px !important;
  min-width: 64px !important;
}
.ant-layout-sider-collapsed .ant-menu-item,
.ant-layout-sider-collapsed .ant-menu-submenu-title {
  padding-left: 11px !important;
  padding-top: 5px;
}

.ant-menu-item-selected {
  background-color: #739BFF !important;
  color: #fff !important;
}

.ant-menu-sub {
  background: #fff !important;
}

.content {
  padding: 20px;
  position: relative;
  height: calc(100vh - 80px);
  overflow: auto;
}
.content::-webkit-scrollbar {
  display: none;
}

.ant-drawer {
  display: none;
}

@media (max-width: 1080px) {
  .menu_desktop {
    display: none;
  }
  .ant-drawer {
    display: block;
  }
  .ant-drawer .ant-drawer-header .ant-drawer-header-title {
    display: flex;
    justify-content: end;
  }
  .ant-drawer .ant-drawer-header .ant-drawer-header-title button {
    margin-right: 0;
  }
}
.login-page {
  height: 100vh;
  width: 100vw;
}
.login-page .login-page-wrapper {
  display: flex;
  height: 100%;
}
.login-page .login-page-wrapper .leftside {
  position: relative;
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.login-page .login-page-wrapper .leftside .header-logo {
  width: 580px;
  height: 200px;
  transform: translateY(-50px);
}
.login-page .login-page-wrapper .leftside .line {
  position: absolute;
  bottom: 0;
  left: 0;
}
.login-page .login-page-wrapper .rightside {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-page .login-page-wrapper .rightside .center {
  max-width: 435px;
  width: 100%;
  display: flex;
  transform: translateY(-50px);
  flex-direction: column;
}
.login-page .login-page-wrapper .rightside .center h1 {
  font-size: 24px;
  font-weight: 500;
  color: #131111;
}
.login-page .login-page-wrapper .rightside .center .ant-form-item-row {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.login-page .login-page-wrapper .rightside .center .single-item {
  margin-top: 40px;
  height: 110px;
  position: relative;
}
.login-page .login-page-wrapper .rightside .center .single-item p {
  font-size: 16px;
  color: #131111;
  margin-bottom: 10px;
}
.login-page .login-page-wrapper .rightside .center .single-item p span {
  color: #ED4C5C;
}
.login-page .login-page-wrapper .rightside .center .single-item input {
  height: 64px;
  width: 100%;
  border-radius: 20px;
  padding-left: 55px;
  font-size: 18px;
  background-color: #fff;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-outlined:hover {
  border-color: #37a141;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-outlined {
  border-color: #1953E9;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-outlined.ant-input-status-warning {
  border-color: #faad14 !important;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-outlined.ant-input-status-error {
  border-color: #ED4C5C !important;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-affix-wrapper {
  height: 64px;
  width: 100%;
  border-radius: 20px;
  padding-left: 55px;
  font-size: 18px;
  padding-right: 20px;
}
.login-page .login-page-wrapper .rightside .center .single-item .ant-input-affix-wrapper input {
  height: 100%;
  padding-left: 0;
}
.login-page .login-page-wrapper .rightside .center .single-item .icon {
  position: absolute;
  z-index: 5;
  left: 20px;
  top: 55px;
}
.login-page .login-page-wrapper .rightside .center .ant-form-item-explain-error {
  margin-top: 10px;
}
.login-page .login-page-wrapper .rightside .center .remember {
  display: flex;
  margin-top: 40px;
  position: static;
  height: 24px;
}
.login-page .login-page-wrapper .rightside .center .remember input {
  width: 24px !important;
  height: 24px !important;
}
.login-page .login-page-wrapper .rightside .center .remember .ant-checkbox-inner {
  width: 24px !important;
  height: 24px !important;
  border-radius: 8px;
  border: 1px solid #9c9c9c;
}
.login-page .login-page-wrapper .rightside .center .remember .ant-checkbox-inner .ant-checkbox-checked {
  border: 1px solid transparent !important;
}
.login-page .login-page-wrapper .rightside .center .remember .ant-checkbox-inner::after {
  width: 8px;
  height: 14px;
}
.login-page .login-page-wrapper .rightside .center button {
  margin-top: 75px;
  width: 100%;
  height: 57px;
  font-size: 18px;
  font-weight: 600;
  background-color: #1953E9;
  border-radius: 20px;
}

@media (max-width: 700px) {
  .login-page {
    overflow: hidden;
    margin-right: auto;
    margin-left: auto;
    position: absolute;
    top: 0;
    left: 0;
    max-width: 100dvw !important;
    max-height: 100dvh !important;
    display: flex;
    justify-content: center;
  }
  .login-page .login-page-wrapper .leftside {
    display: none;
  }
  .login-page .login-page-wrapper .rightside {
    width: 100%;
  }
  .login-page .login-page-wrapper .rightside .center {
    max-width: 100vw;
  }
}
.projects {
  padding: 40px;
  transition: opacity 0.3s ease;
  position: relative;
}
.projects .upper-section {
  display: flex;
  justify-content: space-between;
}
.projects .upper-section .download-btn {
  display: flex;
  gap: 30px;
}
.projects .upper-section .download-btn button {
  border-radius: 20px;
}
.projects .upper-section .download-btn .ant-btn-primary {
  background-color: #1953E9;
}
.projects .upper-section .upper_filter {
  display: flex;
  gap: 20px;
}
.projects .upper-section .upper_filter .ant-select {
  height: 40px;
  width: 180px;
}
.projects .upper-section .upper_filter .ant-select .ant-select-selector {
  border-radius: 20px !important;
  background-color: transparent;
}
.projects .upper-section .search-btn {
  width: 330px;
}
.projects .upper-section .search-btn .ant-btn-default {
  border: none;
  border-top-right-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  height: 38px;
  width: 47px;
  position: absolute;
  top: 1px;
  right: 1px;
  z-index: 2;
  background-color: transparent;
}
.projects .upper-section .search-btn input {
  border-radius: 20px !important;
  width: 330px;
  height: 40px;
  padding-left: 20px;
  padding-right: 50px;
  background-color: transparent;
}
.projects .upper-section .add-project-btn {
  border: 2px solid #1953E9;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 50px;
  border-radius: 20px;
  height: 44px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.projects .upper-section .add-project-btn span {
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  color: #1953E9;
}
.projects .upper-section .add-project-btn .icon {
  transition: all 0.3s ease;
  color: #1953E9 !important;
}
.projects .upper-section .add-project-btn:hover {
  background-color: #1953E9;
}
.projects .upper-section .add-project-btn:hover .icon {
  color: #fff !important;
}
.projects .upper-section .add-project-btn:hover span {
  color: #fff;
}
.projects .projects-list {
  margin-top: 30px;
}
.projects .projects-list ul {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 40px;
}
.projects .projects-list ul li {
  display: flex;
  flex-direction: column;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  background-color: #fff;
}
.projects .projects-list ul li .item .project-title {
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.projects .projects-list ul li .item .project-title h2 {
  font-size: 28px;
  font-weight: 600;
  color: #1953E9;
  text-transform: uppercase;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.projects .projects-list ul li .item .project-title .icon {
  color: #1953E9 !important;
  width: 20px !important;
  height: 20px !important;
  cursor: pointer;
}
.projects .projects-list ul li .item .project-info {
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  box-shadow: 0px -1px 30px 0px rgba(0, 0, 0, 0.1);
}
.projects .projects-list ul li .item .project-info .info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 23px 12px;
}
.projects .projects-list ul li .item .project-info .info .start-date,
.projects .projects-list ul li .item .project-info .info .completion-date {
  display: flex;
  gap: 3px;
  align-items: center;
}
.projects .projects-list ul li .item .project-info .info .start-date .icon,
.projects .projects-list ul li .item .project-info .info .completion-date .icon {
  width: 14px !important;
  height: 14px !important;
  color: #686666 !important;
}
.projects .projects-list ul li .item .project-info .info .start-date span,
.projects .projects-list ul li .item .project-info .info .completion-date span {
  font-size: 12px;
  font-weight: 400;
  color: #686666;
}
.projects .projects-list ul li .item .project-info .info .status {
  font-size: 14px;
  font-weight: 500;
  color: #686666;
}
.projects .projects-list ul li .item .project-info .proccess {
  height: 22px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.projects .projects-list ul li .item .project-info .proccess .proccess-line {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transition: all 0.3s ease;
  width: 0%;
}
.projects .projects-list ul li .item .project-info .proccess span {
  font-size: 12px;
  font-weight: 600;
  position: relative;
  z-index: 3;
}

.loader {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  left: 0px;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
}

@media (max-width: 1320px) {
  .projects .projects-list ul {
    grid-template-columns: 1fr 1fr;
  }
}
.single-project {
  padding: 15px 80px;
}
.single-project .upper-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.single-project .back-home div {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #999999;
}
.single-project .back-home div .icon {
  transform: rotate(90deg);
  width: 20px !important;
  height: 20px !important;
  margin-right: 5px;
  margin-left: -5px;
}
.single-project .save-btn button {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  padding: 10px 30px !important;
  border-radius: 12px;
  background: #1953E9;
  gap: 5px;
}
.single-project .save-btn button:disabled {
  color: rgba(255, 255, 255, 0.7);
  opacity: 0.7;
}
.single-project .save-btn button .ant-btn-icon {
  margin-right: 0 !important;
}

.main {
  padding-top: 35px;
  display: flex;
  justify-content: space-between;
  gap: 100px;
}
.main .left {
  max-width: 400px;
  width: 100%;
}
.main .left h1 {
  font-size: 36px;
  font-weight: 600;
  color: #131111;
  margin-bottom: 5px;
}
.main .left p {
  font-size: 16px;
  font-weight: 400;
  color: #ACACAC;
  margin-bottom: 10px;
}
.main .left .proccess {
  height: 22px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  overflow: hidden;
}
.main .left .proccess .proccess-line {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  transition: all 1.2s ease;
  width: 0%;
  border-radius: 10px;
}
.main .left .proccess span {
  font-size: 12px;
  font-weight: 600;
  position: relative;
  z-index: 3;
}
.main .left .dates {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.main .left .dates .start-date,
.main .left .dates .completion-date {
  display: flex;
  align-items: center;
  gap: 3px;
  color: #686666 !important;
  font-size: 12px;
}
.main .left .dates .start-date .icon,
.main .left .dates .completion-date .icon {
  width: 14px !important;
  height: 14px !important;
}
.main .left .client-info {
  margin-top: 20px;
}
.main .left .client-info label {
  font-size: 20px;
  font-weight: 500;
  color: #000;
}
.main .left .client-info label input {
  border-top: none;
  border-left: none;
  border-right: none;
  padding-left: 0;
  border-bottom: 1px solid #a09f9f;
  border-radius: 0;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  background-color: transparent;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 15px;
  width: 100%;
}
.main .left .client-info label input:disabled {
  color: #777777;
}
.main .left .client-info label input:focus {
  background: transparent;
  outline: none;
  box-shadow: none;
}
.main .left .client-info label textarea {
  margin-top: 15px;
  height: auto !important;
  border-top: none;
  border-left: none;
  border-right: none;
  padding-left: 0;
  border-bottom: 1px solid #a09f9f;
  border-radius: 0;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  background-color: transparent;
  resize: none;
}
.main .left .client-info label textarea:focus {
  background: transparent;
  outline: none;
  box-shadow: none;
}
.main .left .client-info label .ant-input {
  height: auto !important;
}
.main .left .client-info label .ant-input-outlined {
  background-color: transparent;
}
.main .right {
  max-width: 533px;
  width: 100%;
}
.main .right .todo {
  border-radius: 10px;
  overflow: hidden;
  background-color: #fbfbfb;
}
.main .right .todo .top {
  height: 15px;
  transition: all 1.2s ease;
}
.main .right .todo h1 {
  font-size: 24px;
  font-weight: 500;
  color: #131111;
  padding-bottom: 32px;
  border-bottom: 1px solid #dddddd;
  margin-top: 33px;
  padding-left: 20px;
}
.main .right .todo .ant-list-empty-text {
  height: 0px;
}
.main .right .todo .ant-list-empty-text .ant-empty-normal {
  padding: 0 !important;
  display: flex;
  justify-content: center;
}
.main .right .todo .ant-list-empty-text .ant-empty-normal::after {
  content: "Any information left ?";
  position: absolute;
  top: 10px;
}
.main .right .todo .ant-list-empty-text::after {
  display: none;
}
.main .right .todo .ant-list-empty-text .ant-empty-image {
  display: none;
}
.main .right .todo .ant-list-empty-text .ant-empty-description {
  display: none;
}
.main .right .todo .ant-list {
  border: none;
}
.main .right .todo .ant-list-item {
  padding: 0;
  padding-left: 20px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  margin-top: 25px;
  border-bottom: none;
}
.main .right .todo .ant-list-item label {
  max-width: 80%;
}
.main .right .todo .ant-list-item label p {
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  color: #3b3b3b;
  word-wrap: break-word;
}
.main .right .todo .ant-list-item .custom-checkbox {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: relative;
}
.main .right .todo .ant-list-item .custom-checkbox input {
  opacity: 0;
  position: absolute;
  width: 100%;
}
.main .right .todo .ant-list-item .custom-checkbox .checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 24px;
  min-width: 24px;
  display: inline-block;
  margin-right: 10px;
  border: 1px solid #777777;
  border-radius: 5px;
  transition: all 0.3s ease;
  background-position: center;
  cursor: pointer;
}
.main .right .todo .ant-list-item .custom-checkbox .checkmark:hover {
  background-color: #fbfafa;
}
.main .right .todo .ant-list-item .custom-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.main .right .todo .ant-list-item .custom-checkbox input:checked + .checkmark {
  background-color: #d0f9d4;
  border: 1px solid #36b151;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
}
.main .right .todo .ant-list-item .icon {
  cursor: pointer;
}
.main .right .todo .ant-list-item li {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main .right .todo .field {
  display: flex;
  margin-top: 25px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top: 1px solid #dddddd;
  padding-left: 10px;
  padding-right: 10px;
  gap: 10px;
}
.main .right .todo .field textarea {
  border: none;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  resize: none;
  height: -moz-fit-content;
  height: fit-content;
  border: 1px solid #d6d6d6;
}
.main .right .todo .field button {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  color: #131111;
  font-size: 16px;
  border: 1px solid #d6d6d6;
}
.main .right .todo .field button .ant-btn-icon {
  margin-right: 0;
  margin-left: 5px;
}

.delete-pop-up {
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-pop-up .ant-modal-content {
  width: 400px !important;
  top: 0 !important;
  padding: 20px !important;
  border-radius: 20px !important;
}
.delete-pop-up .ant-modal {
  width: 500px !important;
  top: 0px !important;
  display: flex !important;
  align-items: center !important;
}
.delete-pop-up .ant-modal-root {
  width: 500px !important;
}
.delete-pop-up .ant-modal-wrap {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.projects_log {
  border-radius: 16px;
  padding: 30px 20px;
  background-color: #fff;
}
.projects_log .page-title {
  margin-bottom: 22px;
}
.projects_log .page-title h1 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 12px;
}
.projects_log .page-title p {
  font-weight: 400;
  font-size: 20px;
  color: #7A7A7A;
}
.projects_log .upper-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.projects_log .upper-section .left {
  display: flex;
  gap: 20px;
}
.projects_log .upper-section .left .search-btn {
  width: 330px;
}
.projects_log .upper-section .left .search-btn .ant-btn-default {
  border: none;
  border-top-right-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  height: 38px;
  width: 47px;
  position: absolute;
  top: 1px;
  right: 1px;
  z-index: 2;
  background-color: transparent;
}
.projects_log .upper-section .left .search-btn input {
  border-radius: 20px !important;
  width: 330px;
  height: 40px;
  padding-left: 20px;
  padding-right: 50px;
  background-color: transparent;
}
.projects_log .upper-section .left .select {
  position: relative;
  cursor: pointer;
}
.projects_log .upper-section .left .select .icon {
  width: 16px !important;
  height: 16px !important;
  position: absolute;
  right: 12px;
  top: 12px;
  pointer-events: none;
}
.projects_log .upper-section .left .select .ant-select-selector {
  height: 40px;
  width: 170px;
  border-radius: 20px;
}
.projects_log .upper-section .left .select .ant-select-selector .ant-select-selection-item {
  padding-left: 12px;
}
.projects_log .upper-section .left .select .ant-select-arrow {
  display: none !important;
  opacity: 0 !important;
}
.projects_log .upper-section .download-btn button {
  border: 1px solid #1953E9;
}
.projects_log .table {
  padding-top: 40px;
  position: relative;
}
.projects_log .table .ant-table {
  border-radius: 0px !important;
}
.projects_log .table .ant-table-header {
  border-radius: 0px;
}
.projects_log .table .ant-table-thead {
  border-radius: 0px !important;
}
.projects_log .table .ant-table-thead tr th {
  border-radius: 0px !important;
  font-size: 12px;
  color: #828B96;
  font-weight: 500;
  border-left: 0.5px solid #E8E8E8;
  border-right: 0.5px solid #E8E8E8;
}
.projects_log .table .ant-table-thead tr th:first-child {
  border-left: none !important;
}
.projects_log .table .ant-table-thead tr th:last-child {
  border-right: none !important;
}
.projects_log .table .ant-table-thead tr th::before {
  background: none !important;
}
.projects_log .table .ant-table-row td {
  border: 0.5px solid #E8E8E8 !important;
  font-size: 14px;
  font-weight: 500;
}
.projects_log .table .ant-table-row td:first-child {
  border-left: none !important;
}
.projects_log .table .ant-table-row td:last-child {
  border-right: none !important;
  padding: 0 !important;
  padding-right: 5px !important;
  padding-left: 5px !important;
}
.projects_log .table .ant-table-row td:nth-child(6) {
  padding-left: 0;
  padding-bottom: 0;
  padding: 0;
}
.projects_log .table .ant-table-row td .status {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  font-weight: 400;
  font-size: 10px;
  width: 100px;
  height: 24px;
  margin-right: auto;
  margin-left: auto;
}
.projects_log .table .ant-table-row td .date {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 400;
  margin-right: auto;
  margin-left: auto;
  max-width: 100%;
}
.projects_log .table .ant-table-row td .date .icon {
  width: 16px !important;
  height: 16px !important;
}
.projects_log .table .ant-table-row td .updated-by {
  font-size: 13px;
}
.projects_log .table .ant-table-row td .comment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
  padding-left: 10px;
  position: relative;
}
.projects_log .table .ant-table-row td .comment span {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 !important;
  justify-content: space-between;
  gap: 2px;
  width: 100%;
  padding-bottom: 16px !important;
  padding-top: 16px !important;
}
.projects_log .table .ant-table-row td .comment span p {
  white-space: nowrap;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.projects_log .table .ant-table-row td .comment .icon {
  min-width: 14px !important;
  min-height: 14px !important;
  max-width: 14px !important;
  max-height: 14px !important;
  color: rgb(203, 213, 224) !important;
  position: relative;
}
.projects_log .table .ant-table-row td .comment button {
  background: none !important;
  color: #000;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  padding: 0;
}
.projects_log .table .ant-table-row td .comment button div {
  display: none;
}
.projects_log .table .ant-pagination {
  justify-content: start;
  position: relative;
}
.projects_log .table .ant-pagination li:last-child {
  position: absolute;
  right: 0;
}
.projects_log .table .ant-pagination .ant-pagination-next, .projects_log .table .ant-pagination .ant-pagination-prev {
  border: 1px solid #F1F2F4 !important;
}
.projects_log .table .item-amout {
  position: absolute;
  right: 120px;
  bottom: 25px;
  font-size: 12px;
  font-weight: 500;
  color: #687588;
}

.ant-popover {
  max-width: 300px !important;
}

@media (max-width: 1400px) {
  .projects_log .table th {
    padding: 12px !important;
  }
  .projects_log .table td {
    padding: 8px !important;
  }
  .projects_log .table td:nth-child(6) {
    padding-left: 0;
    padding-bottom: 0;
    padding: 0;
  }
  .projects_log .table td .comment {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .projects_log .table td .comment p {
    width: 70px;
  }
}
.ina_out {
  border-radius: 16px;
  padding: 30px 20px;
  background-color: #fff;
}
.ina_out .page-title {
  margin-bottom: 22px;
}
.ina_out .page-title h1 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 12px;
}
.ina_out .page-title p {
  font-weight: 400;
  font-size: 20px;
  color: #7A7A7A;
}
.ina_out .upper-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ina_out .upper-section .left {
  display: flex;
  gap: 20px;
}
.ina_out .upper-section .left .search-btn {
  width: 330px;
}
.ina_out .upper-section .left .search-btn .ant-btn-default {
  border: none;
  border-top-right-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  height: 38px;
  width: 47px;
  position: absolute;
  top: 1px;
  right: 1px;
  z-index: 2;
  background-color: transparent;
}
.ina_out .upper-section .left .search-btn input {
  border-radius: 20px !important;
  width: 330px;
  height: 40px;
  padding-left: 20px;
  padding-right: 50px;
  background-color: transparent;
}
.ina_out .upper-section .left .select {
  width: 180px;
}
.ina_out .upper-section .left .select .ant-picker {
  height: 100%;
  width: 100%;
  border-radius: 20px;
}
.ina_out .upper-section .download-btn button {
  border: 1px solid #1953E9;
}
.ina_out .table {
  padding-top: 40px;
  position: relative;
}
.ina_out .table .ant-table {
  border-radius: 0px !important;
}
.ina_out .table .ant-table-header {
  border-radius: 0px;
}
.ina_out .table .ant-table-thead {
  border-radius: 0px !important;
}
.ina_out .table .ant-table-thead tr th {
  border-radius: 0px !important;
  font-size: 12px;
  color: #828B96;
  font-weight: 500;
  border-left: 0.5px solid #e8e8e8;
  border-right: 0.5px solid #e8e8e8;
}
.ina_out .table .ant-table-thead tr th:first-child {
  border-left: none !important;
}
.ina_out .table .ant-table-thead tr th:last-child {
  border-right: none !important;
}
.ina_out .table .ant-table-thead tr th:last-child p {
  color: hsla(0, 89%, 59%, 0.86);
}
.ina_out .table .ant-table-thead tr th:nth-child(7) {
  border-right: none !important;
}
.ina_out .table .ant-table-thead tr th:nth-child(7) p {
  color: hsla(0, 89%, 59%, 0.86);
}
.ina_out .table .ant-table-thead tr th::before {
  background: none !important;
}
.ina_out .table .ant-table-thead tr .name_employee {
  color: #828282;
}
.ina_out .table .ant-table-thead tr .column_name {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}
.ina_out .table .ant-table-thead tr .column_name span {
  color: #636363;
}
.ina_out .table .ant-table-thead tr .column_name p {
  font-size: 10px;
}
.ina_out .table .ant-table-thead tr .column_name .off {
  color: hsla(0, 89%, 59%, 0.86);
}
.ina_out .table .ant-table-row td {
  border: 0.5px solid #e8e8e8 !important;
  font-size: 14px;
  font-weight: 500;
  padding: 12px;
}
.ina_out .table .ant-table-row td .employee_name {
  max-width: 180px;
  width: 100%;
  display: flex;
}
.ina_out .table .ant-table-row td .employee_name .name_wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.ina_out .table .ant-table-row td .status {
  display: flex;
  justify-content: space-between;
  gap: 5px;
}
.ina_out .table .ant-table-row td .status .time {
  padding: 4px;
  border-radius: 6px;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ina_out .table .ant-table-row td .status .red {
  background-color: rgba(254, 67, 67, 0.597);
}
.ina_out .table .ant-table-row td .status .gray {
  background-color: rgba(164, 164, 164, 0.7019607843);
}
.ina_out .table .ant-table-row td .status .green {
  background-color: rgba(67, 254, 77, 0.597);
}
.ina_out .table .ant-pagination {
  justify-content: start;
  position: relative;
}
.ina_out .table .ant-pagination li:last-child {
  position: absolute;
  right: 0;
}
.ina_out .table .ant-pagination .ant-pagination-next,
.ina_out .table .ant-pagination .ant-pagination-prev {
  border: 1px solid #F1F2F4 !important;
}
.ina_out .table .item-amout {
  position: absolute;
  right: 120px;
  bottom: 25px;
  font-size: 12px;
  font-weight: 500;
  color: #687588;
}

.ant-popover {
  max-width: 300px !important;
}

.ant-picker-week-panel-row .ant-picker-cell-week {
  color: red !important;
  font-weight: bold !important;
}

@media (max-width: 1400px) {
  .projects_log .table th {
    padding: 12px !important;
  }
  .projects_log .table td {
    padding: 8px !important;
  }
  .projects_log .table td:nth-child(6) {
    padding-left: 0;
    padding-bottom: 0;
    padding: 0;
  }
  .projects_log .table td .comment {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .projects_log .table td .comment p {
    width: 70px;
  }
}
.employees .upper-section .download-btn {
  display: flex;
  gap: 30px;
}
.employees .upper-section .download-btn button {
  border-radius: 20px;
}
.employees .upper-section .download-btn .ant-btn-primary {
  background-color: #1953E9;
}
.employees .uppercase {
  text-transform: uppercase;
}
.employees .table .ant-table-thead tr th {
  border-left: none !important;
  border-right: none !important;
  font-size: 14px;
  color: #434343;
}
.employees .table .ant-table-thead tr th .salary-column-header {
  display: flex;
  justify-content: space-between;
}
.employees .table .ant-table-thead tr th .salary-column-header .icon {
  cursor: pointer;
  transition: all 0.3s ease;
}
.employees .table .ant-table-row:hover .hide-salary::after {
  background-color: #fafafa !important;
}
.employees .table .ant-table-row td {
  border-left: none !important;
  border-right: none !important;
}
.employees .table .ant-table-row td:nth-child(2) {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td:nth-child(7) {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td:nth-child(8) {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td:nth-child(6) {
  padding-left: 14px !important;
}
.employees .table .ant-table-row td .employee-info {
  display: flex;
  background: none !important;
  position: relative;
}
.employees .table .ant-table-row td .employee-info span {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 !important;
  width: 100%;
}
.employees .table .ant-table-row td .employee-info .employee {
  display: flex;
  align-items: center;
  gap: 10px;
  top: 0;
  width: 100%;
}
.employees .table .ant-table-row td .employee-info .employee .avatar {
  display: flex;
}
.employees .table .ant-table-row td .employee-info .employee .avatar img {
  width: 30px;
  height: 30px;
  object-fit: cover;
}
.employees .table .ant-table-row td .employee-info .employee .personal-info p {
  color: #a0aec0;
  font-size: 10px;
  font-weight: 400;
}
.employees .table .ant-table-row td .employee-info .employee .personal-info h4 {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td .employee-info .icon {
  color: #a0aec0 !important;
}
.employees .table .ant-table-row td .job span {
  font-size: 12px;
  font-weight: 400;
}
.employees .table .ant-table-row td .job p {
  font-size: 10px;
  font-weight: 400;
  color: #A0AEC0;
}
.employees .table .ant-table-row td .file .icon {
  color: #ED4C5C !important;
  cursor: pointer;
}
.employees .table .ant-table-row td .salary {
  font-size: 12px;
  font-weight: 400;
  padding: 5px;
  display: flex;
  justify-content: center;
  text-align: center;
  position: relative;
  transition: all 0.3s ease;
}
.employees .table .ant-table-row td .hide-salary {
  transition: all 0.3s ease;
}
.employees .table .ant-table-row td .hide-salary::after {
  content: "*********";
  position: absolute;
  background-color: #fff;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.employees .table .ant-table-row td .hide-salary:hover::after {
  opacity: 0;
}
.employees .table .ant-table-row td .edit {
  display: flex;
  align-items: center;
  gap: 14px;
}
.employees .table .ant-table-row td .edit .icon {
  width: 18px !important;
  cursor: pointer;
}
.employees .table .ant-table-row td .edit .icon:first-child {
  color: #624de3 !important;
}
.employees .table .ant-table-row td .edit .icon:last-child {
  color: #a30d11 !important;
}
.employees .table .total-salary {
  font-weight: bold;
  justify-content: end;
  display: flex;
  gap: 10px;
}
.employees .table .total-salary .amount-wrapper {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
}
.employees .table .total-salary .amount-wrapper .total-salary-amount {
  opacity: 0;
  transition: all 0.3s ease;
  font-weight: normal;
  cursor: pointer;
}
.employees .table .total-salary .amount-wrapper .hide-total-salary {
  position: absolute;
  padding-top: 3px;
  font-weight: normal;
  transition: all 0.3s ease;
  width: 100%;
  cursor: pointer;
  height: 100%;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  left: 0;
  top: 0;
}
.employees .table .total-salary .amount-wrapper:hover {
  opacity: 1;
}
.employees .table .total-salary .amount-wrapper:hover .hide-total-salary {
  opacity: 0;
  pointer-events: none;
}
.employees .table .total-salary .amount-wrapper:hover .total-salary-amount {
  opacity: 1;
}

.pop-over {
  display: flex;
  flex-direction: column;
  font-size: 10px;
  font-weight: 400;
  gap: 5px;
}
.pop-over .email {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  color: #A0AEC0;
}
.pop-over .icon {
  width: 12px !important;
  height: 12px !important;
  cursor: pointer;
}

.modal-backdrop2 {
  width: 100%;
  position: fixed;
  height: 100%;
  z-index: 10000;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3137254902);
}
.modal-backdrop2 .prewiev-modal2 {
  width: 85%;
  height: 85%;
  overflow: hidden;
  border-radius: 10px;
  background: #fff;
}
.modal-backdrop2 .prewiev-modal2 .modal-header {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modal-backdrop2 .prewiev-modal2 .modal-header .modal-title {
  width: 80%;
}
.modal-backdrop2 .prewiev-modal2 .modal-header button {
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
}
.modal-backdrop2 .prewiev-modal2 .file-box {
  width: 100%;
  height: 100%;
}
.modal-backdrop2 .prewiev-modal2 .file-box .content-image {
  background: #ccc;
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.ant-modal-content {
  padding: 30px 50px 60px 50px !important;
}

.ant-modal {
  height: 600px !important;
  top: 0px !important;
  display: flex !important;
  align-items: center !important;
}

.ant-modal-wrap {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.download-selected_file {
  font-size: 20px;
  transform: translateX(50px);
  color: #222;
}

.cencel-file-popup {
  cursor: pointer;
}

.form-wrapper .title h1 {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #131111;
}
.form-wrapper .title p {
  font-weight: 400;
  font-size: 14px;
  color: #848282;
}
.form-wrapper .avatar {
  height: 120px;
  width: 120px;
  position: relative;
  margin-top: 25px;
}
.form-wrapper .avatar .icon-wrapper {
  position: absolute;
  cursor: pointer;
  height: 30px;
  width: 30px;
  top: 3px;
  right: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #1953E9;
}
.form-wrapper .avatar .icon-wrapper .icon {
  width: 14px !important;
  height: 14px !important;
  color: #fff !important;
}
.form-wrapper .avatar .avatar-photo {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f2f2;
}
.form-wrapper .avatar .avatar-photo .icon {
  width: 57px !important;
  height: 57pc !important;
}
.form-wrapper .input-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 40px;
  row-gap: 33px;
  padding-top: 27px;
  padding-bottom: 30px;
}
.form-wrapper .input-wrapper .single-input-item {
  position: relative;
}
.form-wrapper .input-wrapper .single-input-item label {
  font-size: 16px;
  font-weight: 500;
  color: #131111;
}
.form-wrapper .input-wrapper .single-input-item input {
  height: 44px;
}
.form-wrapper .input-wrapper .single-input-item .ant-select {
  height: 44px !important;
  position: relative;
}
.form-wrapper .input-wrapper .single-input-item .ant-picker {
  height: 44px !important;
}
.form-wrapper .input-wrapper .single-input-item .ant-form-item {
  margin-bottom: 0;
}
.form-wrapper .input-wrapper .single-input-item .ant-form-item-has-error .PhoneInput input {
  border-color: #ff4d4f;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput {
  border: none !important;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput input {
  border-radius: 6px;
  outline: none;
  border: 1px solid #d9d9d9;
  padding: 4px 11px;
  font-size: 14px;
  transition: all 0.3s ease;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput input::placeholder {
  color: #bfbfbf;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput input:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput .PhoneInputCountry {
  display: none;
}
.form-wrapper .input-wrapper .single-input-item .PhoneInput .PhoneInput--focus {
  border: 1px solid none !important;
}
.form-wrapper .input-wrapper .salary {
  gap: 10px;
  display: flex;
  justify-content: center;
  align-items: end;
}
.form-wrapper .input-wrapper .salary .ant-form-item-control-input-content {
  display: flex !important;
  gap: 10px;
  align-items: center;
}
.form-wrapper .input-wrapper .dual {
  display: flex;
  align-items: center;
  gap: 10px;
  align-items: start;
}
.form-wrapper .input-wrapper .dual .ant-select {
  width: 180px;
}
.form-wrapper .input-wrapper .calendar {
  position: relative;
}
.form-wrapper .input-wrapper .calendar .ant-picker {
  display: flex;
  padding-right: 40px;
}
.form-wrapper .input-wrapper .calendar .ant-picker span {
  display: none;
}
.form-wrapper .input-wrapper .calendar .ant-picker input {
  border: none;
}
.form-wrapper .input-wrapper .calendar .icon {
  position: absolute;
  top: 40px !important;
  z-index: 10;
  right: 10px;
  top: 10px !important;
  pointer-events: none;
}
.form-wrapper .expenses-input-wrapper {
  grid-template-columns: 1fr 1fr 1fr;
}
.form-wrapper .salary {
  display: flex;
  justify-content: center;
}

.small-modal .min-title {
  padding: 20px;
}
.small-modal .min-title h1 {
  font-size: 24px;
  font-weight: 600;
  color: #131111;
}
.small-modal ul {
  padding-left: 20px;
  padding-right: 20px;
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}
.small-modal ul li {
  border-radius: 5px;
  height: 170px;
  background-color: #fdfdfd;
  border: 1px solid #f7f7f7;
}
.small-modal ul li .item-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.small-modal ul li .item-wrapper .file-img {
  margin-top: 20px;
}
.small-modal ul li .item-wrapper .file-img .icon {
  max-width: 85px !important;
  max-height: 113px !important;
  width: 85px !important;
  height: 113px !important;
  color: #eb1f1f !important;
}
.small-modal ul li .item-wrapper .file-name {
  display: flex;
  height: 30px;
  align-items: center;
  padding-bottom: 5px;
  padding-right: 7px;
  padding-left: 7px;
}
.small-modal ul li .item-wrapper .file-name input {
  height: 20px;
  border: none !important;
  outline: none;
  padding-right: 0;
  font-size: 12px;
}
.small-modal ul li .item-wrapper .file-name span {
  font-size: 12px;
  text-align: center;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.small-modal ul li .item-wrapper .file-name .ant-input-outlined {
  border: none;
  box-shadow: none;
  border-radius: 0px;
  padding-right: 2px;
}
.small-modal ul li .item-wrapper .file-name .icon {
  color: #36b151 !important;
  cursor: pointer;
}
.small-modal ul li .item-wrapper .delete {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.small-modal ul li .item-wrapper .delete .icon {
  width: 14px !important;
  height: 14px !important;
}
.small-modal ul .upload {
  max-width: 143px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.small-modal ul .upload label {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}
.small-modal ul .upload label input {
  display: none;
}
.small-modal ul .upload label .plus {
  border: 3px solid #eb1f1f;
  cursor: pointer;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.small-modal ul .upload label .plus span {
  font-size: 10px;
  font-weight: 500;
  color: #131111;
}
.small-modal ul .upload label .plus .icon {
  transform: rotateZ(45deg);
  width: 30px !important;
  height: 30px !important;
  color: #eb1f1f !important;
}

.password {
  height: 44px !important;
}
.password .ant-input-affix-wrapper {
  height: 44px !important;
  width: 100%;
  font-size: 18px;
  display: flex;
}
.password .ant-input-affix-wrapper .ant-input {
  max-height: 34px !important;
  display: flex;
}
.password .ant-input-affix-wrapper input {
  height: 44px !important;
  padding-top: 0 !important;
  padding-left: 0;
  font-size: 14px;
}
.password .ant-input-affix-wrapper input::placeholder {
  font-size: 14px;
}

.min-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.min-modal .ant-modal-content {
  width: 773px !important;
  top: 0 !important;
  padding: 0px !important;
  border-radius: 20px !important;
}
.min-modal .ant-modal {
  width: 773px !important;
  top: 0px !important;
  display: flex !important;
  align-items: center !important;
}
.min-modal .ant-modal-root {
  width: 773px !important;
}
.min-modal .ant-modal-wrap {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.min-modal .ant-modal-footer {
  padding-bottom: 30px !important;
  padding-right: 30px !important;
}
.min-modal .ant-modal-footer button {
  border-radius: 12px;
}
.min-modal .ant-modal-footer button:last-child {
  background-color: #1953E9;
  color: #fff;
}
.min-modal .form-wrapper .title {
  padding: 30px 30px 20px 30px;
  border-bottom: 1px solid #c2c0c0;
  justify-content: space-between;
}
.min-modal .form-wrapper .title h1 {
  font-size: 24px;
  font-weight: 500;
  color: #131111;
  margin-bottom: 5px;
}
.min-modal .form-wrapper .title p {
  font-size: 14px;
  font-weight: 400;
  color: #848282;
}
.min-modal .form-wrapper .upper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  padding: 30px;
}
.min-modal .form-wrapper .upper .single-item input {
  width: 100%;
  height: 46px !important;
  border-radius: 10px;
  font-size: 16px;
}
.min-modal .form-wrapper .upper .single-item input::placeholder {
  font-size: 16px;
}
.min-modal .form-wrapper .upper .single-item .ant-select {
  width: 100% !important;
  height: 46px !important;
  border-radius: 10px !important;
}
.min-modal .form-wrapper .upper .single-item .ant-select .ant-select-selection-item {
  margin-bottom: 0 !important;
}
.min-modal .form-wrapper .upper .single-item .ant-select .ant-select-selector {
  border-radius: 10px !important;
  display: flex;
  align-items: center;
}
.min-modal .form-wrapper .upper .single-item .ant-select .ant-select-selection-placeholder {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  color: #c2c0c0;
}
.min-modal .form-wrapper .upper .single-item .ant-select .ant-select-suffix {
  margin-bottom: 0 !important;
}
.min-modal .form-wrapper .upper .single-item .ant-picker {
  height: 46px !important;
  border-radius: 10px;
  display: flex;
  padding-left: 40px;
}
.min-modal .form-wrapper .upper .single-item .ant-picker span {
  display: none;
}
.min-modal .form-wrapper .upper .single-item .ant-picker input {
  border: none;
}
.min-modal .form-wrapper .upper .calendar {
  position: relative;
}
.min-modal .form-wrapper .upper .calendar .icon {
  position: absolute;
  top: 40px !important;
  z-index: 100;
  left: 10px;
}
.min-modal .form-wrapper .full-width {
  grid-template-columns: 1fr;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select {
  width: 100% !important;
  height: 30px !important;
  border-radius: 10px !important;
  border: 1px solid red;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select .ant-select-selection-item {
  margin-bottom: 0 !important;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select .ant-select-selector {
  border-radius: 10px !important;
  display: flex;
  align-items: center;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select .ant-select-selection-placeholder {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  color: #c2c0c0;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select .ant-select-suffix {
  margin-bottom: 0 !important;
}
.min-modal .form-wrapper .full-width .upper .single-item .ant-select-selector {
  border: 1px solid red;
}
.min-modal .form-wrapper .ant-select-selection-overflow {
  height: 40px;
  padding-left: 5px;
}
.min-modal .form-wrapper .columns-2 {
  grid-template-columns: 1fr 1fr 1fr;
}
.min-modal .form-wrapper .textarea {
  padding-left: 30px;
  padding-right: 30px;
}
.min-modal .form-wrapper .textarea textarea {
  border-radius: 10px;
  max-height: 223px;
  height: 300px;
  padding: 10px;
  padding-left: 15px;
  min-height: 100px;
}
.min-modal .form-wrapper .textarea textarea::placeholder {
  font-size: 16px;
}

.small-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.small-modal .ant-modal-content {
  width: 500px !important;
  top: 0 !important;
  padding: 0px !important;
  border-radius: 20px !important;
}
.small-modal .ant-modal {
  width: 500px !important;
  top: 0px !important;
  display: flex !important;
  align-items: center !important;
}
.small-modal .ant-modal-root {
  width: 500px !important;
}
.small-modal .ant-modal-wrap {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.small-modal .ant-modal-footer {
  padding-bottom: 30px !important;
  padding-right: 30px !important;
}
.small-modal .ant-modal-footer button {
  border-radius: 12px;
}
.small-modal .ant-modal-footer button:last-child {
  background-color: #1953E9;
  color: #fff;
}
.small-modal .form-wrapper .title {
  padding: 30px 30px 20px 30px;
  border-bottom: 1px solid #c2c0c0;
  justify-content: space-between;
}
.small-modal .form-wrapper .title h1 {
  font-size: 24px;
  font-weight: 500;
  color: #131111;
  margin-bottom: 5px;
}
.small-modal .form-wrapper .single-item {
  padding-left: 30px;
  margin-top: 30px;
  max-width: 240px;
}
.small-modal .form-wrapper .single-item p {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #131111;
}
.small-modal .form-wrapper .single-item input {
  width: 100%;
  height: 46px !important;
  border-radius: 10px;
  font-size: 16px;
}
.small-modal .form-wrapper .single-item input::placeholder {
  font-size: 16px;
}
.small-modal .form-wrapper .single-item .ant-switch-checked {
  background: #34c759;
}
.small-modal .form-wrapper .single-item .ant-switch-checked:hover {
  background: #34c759 !important;
}
.small-modal .form-wrapper .integration {
  display: flex !important;
  max-width: 100%;
  padding-right: 30px;
  align-items: center;
  gap: 10px;
}
.small-modal .form-wrapper .integration .percentage-icon {
  border: 1px solid #d9d9d9;
  height: 46px;
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-size: 20px;
  transform: translateY(3px);
}

.company-wage {
  display: flex;
  gap: 10px;
  align-items: center;
}
.company-wage .percentage-icon {
  border: 1px solid #d9d9d9;
  height: 46px;
  min-width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-size: 20px;
  transform: translateY(3px);
}

.settings-table {
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid transparent;
}
.settings-table .ant-table-thead {
  border-radius: 0px !important;
}
.settings-table .ant-table-thead tr th:last-child {
  display: flex;
  align-items: center;
  justify-content: center;
}
.settings-table .ant-table-thead tr th .percentage {
  width: 100%;
  display: flex;
  justify-content: center;
}
.settings-table .ant-table-thead tr th:first-child {
  padding-left: 20px !important;
}
.settings-table .status {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.settings-table .status span {
  display: flex;
  align-items: center;
  gap: 30px;
}
.settings-table .switch {
  display: flex;
  justify-content: center;
}
.settings-table .ant-switch-checked {
  background: #34c759;
}
.settings-table .ant-switch-checked:hover {
  background: #34c759 !important;
}
.settings-table .ant-table-row td:last-child {
  display: flex;
  align-items: center;
  justify-content: center;
}
.settings-table .ant-table-row td .percentage {
  width: 100%;
  display: flex;
  justify-content: center;
}
.settings-table .ant-table-row td:first-child {
  padding-left: 20px !important;
}
.settings-table .edit .icon {
  color: #624de3 !important;
  cursor: pointer;
}
.settings-table .bottom-side {
  display: flex;
  justify-content: end;
  margin-top: 22px;
  margin-bottom: 23px;
  padding-right: 22px;
}
.settings-table .bottom-side button {
  border-radius: 20px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  background-color: #1953E9;
}
.settings-table .bottom-side button span {
  margin-right: 0 !important;
  margin-left: 5px;
}

.filter-checkbox {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: relative;
  margin: 5px;
}
.filter-checkbox input {
  opacity: 0;
  position: absolute;
  width: 100%;
}
.filter-checkbox .checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 24px;
  min-width: 24px;
  display: inline-block;
  margin-right: 10px;
  border: 1px solid #777777;
  border-radius: 5px;
  transition: all 0.3s ease;
  background-position: center;
  cursor: pointer;
}
.filter-checkbox .checkmark:hover {
  background-color: #fbfafa;
}
.filter-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.filter-checkbox input:checked + .checkmark {
  background-color: #d0f9d4;
  border: 1px solid #36b151;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
}

.sales {
  border-radius: 16px;
  background-color: #fff;
  min-height: 100%;
}
.sales .page-title {
  display: flex;
  padding: 30px;
  align-items: center;
  justify-content: space-between;
}
.sales .page-title .title-wrapper h1 {
  font-size: 32px;
  font-weight: 500;
  margin-bottom: 11px;
}
.sales .page-title .title-wrapper p {
  font-size: 20px;
  font-weight: 400;
  color: #7a7a7a;
}
.sales .page-title .calculation-btns {
  display: flex;
  gap: 40px;
  align-items: center;
}
.sales .page-title .calculate-btn {
  display: flex;
  height: 40px;
  align-items: center;
  padding-right: 30px;
  padding-left: 33px;
  border-radius: 20px;
  flex-direction: row-reverse;
  gap: 10px;
  background-color: #1953E9;
}
.sales .page-title .calculate-btn .ant-btn-icon {
  margin-right: 0;
}
.sales .page-title .clear-btn {
  background-color: transparent;
  border: 1px solid #1953E9;
  color: #1953E9;
}
.sales .page-title .clear-btn:hover {
  background-color: transparent;
  color: #1953E9;
}
.sales .form-wrapper .client-info {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
  gap: 60px;
  padding: 0 30px 20px 30px;
}
.sales .form-wrapper .client-info .single-input-item {
  max-width: 282px;
  width: 100%;
}
.sales .form-wrapper .client-info .single-input-item label {
  font-size: 16px;
  font-weight: 500;
  color: #131111;
}
.sales .form-wrapper .client-info .single-input-item input {
  height: 44px;
}
.sales .form-wrapper .client-info .single-input-item .ant-select {
  height: 44px !important;
  position: relative;
}
.sales .form-wrapper .project-info {
  display: flex;
  gap: 60px;
  padding: 30px 30px 30px 30px;
}
.sales .form-wrapper .project-info .single-input-item {
  max-width: 282px;
  width: 100%;
}
.sales .form-wrapper .project-info .single-input-item label {
  font-size: 16px;
  font-weight: 500;
  color: #131111;
}
.sales .form-wrapper .project-info .single-input-item input {
  height: 44px;
}
.sales .form-wrapper .project-info .multiple .ant-select {
  min-height: 44px;
  position: relative;
}
.sales .form-wrapper .project-info .multiple .ant-select .ant-select-selection-overflow-item {
  width: 100%;
}
.sales .form-wrapper .project-info .multiple .ant-select .ant-select-selection-item {
  min-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e3e9f9;
  width: 100%;
}
.sales .form-wrapper .project-info .multiple .ant-select .ant-select-selection-item .ant-select-selection-item-content {
  font-size: 14px;
  font-weight: 400;
}
.sales .form-wrapper .project-info .ant-space-compact {
  height: 48px;
}
.sales .form-wrapper .project-info .twin-input {
  max-width: 408px !important;
  width: 100% !important;
}
.sales .form-wrapper .project-info .twin-input .ant-select {
  width: 100%;
  height: 48px;
  width: 270px;
}
.sales .form-wrapper .project-info .twin-input input {
  height: 48px;
  width: 80px !important;
}
.sales .form-wrapper .project-info .twin-input button {
  height: 48px;
  background-color: #1953E9;
}
.sales .form-wrapper .project-info .twin-input button:disabled {
  color: rgba(255, 255, 255, 0.5);
  background-color: #739BFF;
}
.sales .form-wrapper .project-info .team-list {
  padding-top: 10px;
  width: 100%;
  padding-top: 20px;
}
.sales .form-wrapper .project-info .team-list ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sales .form-wrapper .project-info .team-list ul li {
  border: 1px solid #dcdce4;
  border-radius: 10px;
}
.sales .form-wrapper .project-info .team-list ul li .item {
  display: flex;
  padding: 4px;
  gap: 8px;
  padding-right: 14px;
}
.sales .form-wrapper .project-info .team-list ul li .item .fullname {
  padding: 4px 16px;
  background-color: #e3e9f9;
  width: 100%;
  border-radius: 6px;
}
.sales .form-wrapper .project-info .team-list ul li .item .fullname h4 {
  font-size: 12px;
  font-weight: 400;
}
.sales .form-wrapper .project-info .team-list ul li .item .fullname span {
  font-size: 10px;
  font-weight: 400;
  color: #8e8ea9;
}
.sales .form-wrapper .project-info .team-list ul li .item .duration {
  display: flex;
  align-items: center;
  padding-right: 12px;
  background-color: #e3e9f9;
  border-radius: 6px;
  margin-right: 4px;
  font-size: 12px;
}
.sales .form-wrapper .project-info .team-list ul li .item .duration input {
  border: none;
  font-size: 12px;
  width: 45px !important;
  background-color: transparent;
}
.sales .form-wrapper .project-info .team-list ul li .item .duration input:focus {
  box-shadow: none;
}
.sales .form-wrapper .project-info .team-list ul li .item .anticon {
  cursor: pointer;
}

.small-modal .ant-modal-content {
  position: relative;
  overflow: hidden;
}
.small-modal .ant-modal-content .min-title {
  padding-top: 15px;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
}
.small-modal .ant-modal-content .confirm-content {
  padding: 20px 30px 0 30px;
}
.small-modal .ant-modal-content .modal-loader {
  width: 100%;
  background-color: rgb(255, 255, 255);
  height: 100%;
  position: absolute;
  opacity: 1;
  z-index: 9999;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: all 0.3s ease;
}
.small-modal .ant-modal-content .modal-loader .loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
}
.small-modal .ant-modal-content .modal-loader .loader-wrapper span {
  font-size: 32px;
  font-weight: 400;
  color: rgb(122, 122, 122);
}
.small-modal .ant-modal-content .modal-loader .lds-roller,
.small-modal .ant-modal-content .modal-loader .lds-roller div,
.small-modal .ant-modal-content .modal-loader .lds-roller div:after {
  box-sizing: border-box;
}
.small-modal .ant-modal-content .modal-loader .lds-roller {
  display: inline-block;
  position: relative;
  transform: scale(1.5);
  width: 80px;
  height: 80px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7.2px;
  height: 7.2px;
  border-radius: 50%;
  background: #1953E9;
  margin: -3.6px 0 0 -3.6px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(1):after {
  top: 62.62742px;
  left: 62.62742px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(2):after {
  top: 67.71281px;
  left: 56px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(3):after {
  top: 70.90963px;
  left: 48.28221px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(5):after {
  top: 70.90963px;
  left: 31.71779px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(6):after {
  top: 67.71281px;
  left: 24px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(7):after {
  top: 62.62742px;
  left: 17.37258px;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.small-modal .ant-modal-content .modal-loader .lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12.28719px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.small-modal .ant-modal-content .hide-modal-loader {
  opacity: 0;
  pointer-events: none;
}
.small-modal .result {
  transition: all 0.3s ease;
  padding: 20px 30px;
}
.small-modal .result .result-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.small-modal .result .result-wrapper .item {
  border: 1px solid rgb(243, 243, 243);
  min-width: 185px;
  padding: 0px 20px;
  height: 100px;
  background-color: rgba(240, 240, 240, 0.589);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  gap: 12px;
}
.small-modal .result .result-wrapper .item span {
  display: flex;
  font-size: 14px;
  font-weight: 600;
  color: #8c87a8;
}
.small-modal .result .result-wrapper .item h3 {
  display: flex;
  font-size: 20px;
  font-weight: 600;
  color: #624de3;
}
.small-modal .result .totel {
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(240, 240, 240, 0.589);
}
.small-modal .result .totel p {
  font-size: 18px;
  font-weight: 500;
  color: rgb(19, 17, 17);
}

.finance-dashboard .chart-wrapper {
  width: 100%;
  overflow: hidden;
}
.finance-dashboard .page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.finance-dashboard .page-title .ant-select {
  width: 170px;
  border-radius: 20px !important;
  height: 40px;
}
.finance-dashboard .page-title .ant-select .ant-select-selector {
  border-radius: 20px;
  border: 1px solid #1953E9;
}

.twin_inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
.twin_inputs .currency_input .ant-select {
  width: 100% !important;
}

.balance_wrapper {
  margin-top: 20px;
}
.balance_wrapper span {
  color: #1953e9;
}

.down_icon_wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 20px;
}
.down_icon_wrapper .down_icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1953E9;
  color: #fff;
}

.balance-chart-box .page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.balance-chart-box .page-title .action_side {
  display: flex;
  gap: 24px;
}
.balance-chart-box .page-title .action_side .ant-btn {
  display: flex;
  border-radius: 20px;
  background-color: transparent;
  color: #000;
  border: 1px solid #1953E9;
}
.balance-chart-box .page-title .action_side .ant-picker {
  color: #000;
  border-radius: 20px;
  border: 1px solid #1953E9;
  color: #000;
}
.balance-chart-box .page-title .action_side .ant-picker .ant-picker-input input::placeholder {
  color: #000;
}
.balance-chart-box .page-title .action_side .ant-picker .ant-picker-suffix {
  color: #000 !important;
}
.balance-chart-box .chart-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Creates 3 equal columns */
  gap: 50px;
}
.balance-chart-box .chart-wrapper .chart-area {
  display: flex;
  align-items: center;
}
.balance-chart-box .chart-wrapper .chart-area .apexcharts-legend-text {
  text-transform: capitalize;
  transition: color 0.3s ease;
}
.balance-chart-box .chart-wrapper .chart-area .label-lists {
  list-style-type: none;
  text-transform: capitalize;
}

.expenses .page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.designed-sum {
  padding: 21px;
  border-radius: 8px;
  background-color: #739bff;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
}

.expense-type-raw {
  font-weight: 600 !important;
}

.method-raw {
  text-transform: uppercase;
}

.expense-comment {
  height: 40px;
}

.date-filter {
  border: 1px solid #1953E9;
  border-radius: 20px;
}
.date-filter .ant-picker-input {
  width: 90px;
}
.date-filter .ant-picker-suffix {
  color: #000 !important;
}

.single-input-item-payment {
  display: flex;
}

.payment-wrapper .currency .ant-select {
  height: 44px;
}
.payment-wrapper .currency label {
  opacity: 0; /* Set the desired opacity value */
  pointer-events: none;
}
.payment-wrapper .currency label .ant-form-item-required::before {
  content: "ppp";
  color: #fff !important;
}

.message-text-wrapper {
  border: 1px solid #a1a3ab;
  border-radius: 6px;
  padding: 14px;
}

.total-salary .amount-wrapper {
  padding: 10px;
  border-radius: 8px;
  background-color: #739BFF;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.total-salary .amount-wrapper span {
  display: flex;
}

.canban {
  padding: 0 30px 30px 30px;
  height: calc(100% - 160px);
}

.sales-performance-box {
  box-shadow: 0px 2px 6px 0px rgba(13, 10, 44, 0.0784313725);
  margin: 30px;
  margin-bottom: 40px;
  border-radius: 20px;
  padding: 30px;
}
.sales-performance-box .title-wrapper {
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
}

.canban_list_wrapper {
  height: 100%;
}
.canban_list_wrapper .canban_list {
  list-style: none;
  display: flex;
  gap: 20px;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.canban_list_wrapper .canban_list::-webkit-scrollbar {
  display: none;
}
.canban_list_wrapper .canban_list .canban_list_item {
  transition: all 0.3s ease;
  background-color: #fff;
  min-height: 500px;
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
  overflow-y: auto;
  min-width: 240px;
}
.canban_list_wrapper .canban_list .canban_list_item::-webkit-scrollbar {
  display: none;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info {
  margin-bottom: 10px;
  background-color: #fff;
  z-index: 999;
  position: sticky;
  top: 0;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info .column_name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #a4a4a4;
  margin-bottom: 10px;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info .column_name h3 {
  font-weight: 600;
  font-size: 14px;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info .column_name span {
  font-size: 12px;
  font-weight: 400;
  color: #595959;
  padding: 5px 20px;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
}
.canban_list_wrapper .canban_list .canban_list_item .column_info .add_card_btn {
  border: 1px solid #a4a4a4;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #a4a4a4;
  padding: 7px 70px;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  width: 100%;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column {
  list-style: none;
  height: -moz-fit-content;
  height: fit-content;
  min-height: calc(100% - 94px);
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item {
  padding: 10px 8px;
  box-shadow: 0px 3px 9px 0px rgba(255, 92, 0, 0.1411764706);
  width: 239px;
  height: 138px;
  border: 1px solid #ff5c00;
  border-radius: 5px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item:hover {
  cursor: grab;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .action {
  display: flex;
  gap: 10px;
  justify-content: end;
  margin-bottom: 10px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .action .trash {
  color: #a30d11 !important;
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .action .edit {
  color: #624de3 !important;
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .info_raw {
  display: flex;
  margin-bottom: 8px;
  gap: 8px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .info_raw strong {
  cursor: pointer !important;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .info_raw span {
  font-weight: 400;
  font-size: 12px;
  color: #888888;
  width: 79px;
}
.canban_list_wrapper .canban_list .canban_list_item .canban_column .canban_column_item .info_raw p {
  font-size: 12px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 130px;
}

.dragging-overlay {
  padding: 10px 8px;
  box-shadow: 0px 3px 9px 0px rgba(255, 92, 0, 0.1411764706);
  background-color: #fff;
  transition: all 0.3s ease;
  list-style: none;
  width: 239px;
  height: 138px;
  border: 1px solid #000000;
  border-radius: 5px;
}
.dragging-overlay:hover {
  cursor: grabbing;
}
.dragging-overlay .action {
  display: flex;
  gap: 10px;
  justify-content: end;
  margin-bottom: 10px;
}
.dragging-overlay .action .trash {
  color: #a30d11 !important;
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
}
.dragging-overlay .action .edit {
  color: #624de3 !important;
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
}
.dragging-overlay .info_raw {
  display: flex;
  margin-bottom: 8px;
  gap: 8px;
}
.dragging-overlay .info_raw span {
  font-weight: 400;
  font-size: 12px;
  color: #888888;
  width: 70px;
}
.dragging-overlay .info_raw p {
  font-size: 12px;
  font-weight: 400;
}

.empty-column-placeholder {
  text-align: center;
  padding-top: 30px;
}

.kanban-board {
  display: flex;
  justify-content: space-around;
  padding: 20px;
  height: 100vh;
}

.column {
  background-color: #e2e4e6;
  border-radius: 8px;
  width: 30%;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.column-title {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: center;
}

.task-list {
  background-color: #f4f5f7;
  border-radius: 4px;
  flex-grow: 1;
  min-height: 100px;
  padding: 8px;
  transition: background-color 0.2s ease;
}

.task {
  background-color: #ffffff;
  border-radius: 2px;
  padding: 8px;
  margin-bottom: 8px;
  box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
  transition: background-color 0.2s ease;
}

.canban_mobile {
  display: none;
}

.select_status {
  margin-top: 20px;
}
.select_status h3 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
}
.select_status ul {
  list-style: none;
  display: flex;
  gap: 40px;
}
.select_status ul li {
  padding: 4px 10px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.textarea_input {
  width: 100%;
}
.textarea_input .ant-form-item-required {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #131111;
}
.textarea_input .single-input-item .ant-input {
  height: 100px;
}

.card_item {
  padding: 28px;
}
.card_item .column_name {
  padding: 4px 10px;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 6px;
}
.card_item h2 {
  font-size: 32px;
  font-weight: 500;
}
.card_item .date {
  font-size: 14px;
  font-weight: 400;
  color: #404040;
  margin-bottom: 20px;
}
.card_item span {
  font-size: 12px;
  font-weight: 400;
  display: flex;
  margin-bottom: 10px;
}
.card_item span p {
  color: #888888;
  font-size: 12px;
  font-weight: 400;
  width: 100px;
}
.card_item h4 {
  margin-top: 20px;
}
.card_item .description {
  border: 1px solid #a1a3ab;
  border-radius: 6px;
  padding: 14px;
  font-size: 14px;
  font-weight: 400;
  margin-top: 10px;
}
.card_item .agent {
  width: 100%;
  padding-top: 14px;
  border-top: 1px solid #dee2e6;
  margin-top: 20px;
}

@media (max-width: 700px) {
  .canban {
    padding: 0 30px 30px 30px;
    height: calc(100% - 160px);
  }
  .ant-modal-confirm .ant-modal-content {
    width: 310px !important;
  }
  .expenses-modal {
    display: flex;
    justify-content: center;
    max-width: 322px !important;
  }
  .expenses-modal .ant-modal-content {
    padding: 15px !important;
  }
  .expenses-modal .form-wrapper {
    overflow: auto;
    max-width: 322px;
    max-height: calc(100dvh - 150px);
  }
  .expenses-modal .form-wrapper ul {
    overflow: auto;
  }
  .expenses-modal .form-wrapper ul::-webkit-scrollbar {
    display: none;
  }
  .expenses-modal .form-wrapper .expenses-input-wrapper {
    display: grid;
    grid-template-columns: 1fr;
  }
  .expenses-modal .form-wrapper .expenses-input-wrapper .salary .salary-inner {
    width: 100%;
  }
  .sales .page-title {
    padding: 10px;
  }
  .sales .page-title .title-wrapper h1 {
    font-size: 18px;
  }
  .sales .page-title .title-wrapper p {
    font-size: 14px;
  }
  .sales .canban_desktop {
    display: none;
  }
  .ant-select-item-option-content span {
    color: #000 !important;
  }
  .mobile_modal .ant-modal-content {
    width: 322px !important;
  }
  .canban_mobile {
    display: block;
    width: 100%;
    padding-bottom: 50px;
  }
  .canban_mobile .select_status .ant-select-selector {
    border-radius: 10px;
    border: none !important;
  }
  .canban_mobile .select_status .ant-select {
    width: 100%;
    border-radius: 10px;
    height: 46px;
    border: 1px solid #acacac;
  }
  .canban_mobile .add_card_btn {
    padding-top: 16px;
  }
  .canban_mobile .add_card_btn .add_btn_wrapper {
    border: 1px solid #a4a4a4;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    color: #a4a4a4;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  .canban_mobile .canban_items ul {
    list-style: none;
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .canban_mobile .canban_items ul li .item_wrapper {
    border-radius: 5px;
    padding: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-shadow: 0px 3px 9px 0px rgba(255, 92, 0, 0.1411764706);
  }
  .canban_mobile .canban_items ul li .item_wrapper .action {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    gap: 5px;
  }
  .canban_mobile .canban_items ul li .item_wrapper .action .edit {
    color: #624de3 !important;
  }
  .canban_mobile .canban_items ul li .item_wrapper .action .trash {
    color: #a30d11 !important;
  }
  .canban_mobile .canban_items ul li .item_wrapper .info_raw {
    display: flex;
  }
  .canban_mobile .canban_items ul li .item_wrapper .info_raw span {
    font-size: 12px;
    color: #888888;
    font-weight: 400;
    min-width: 80px;
  }
  .canban_mobile .canban_items ul li .item_wrapper .info_raw p {
    font-size: 12px;
    font-weight: 400;
  }
  .content {
    padding: 10px;
    background-color: #fff;
  }
  .sales-performance-box {
    box-shadow: none;
    margin: 0px;
    margin-bottom: 40px;
    border-radius: 20px;
    padding: 10px;
  }
  .sales-performance-box .title-wrapper {
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
    flex-direction: column;
    gap: 16px;
  }
  .sales-performance-box .title-wrapper * {
    display: none;
  }
  .sales-performance-box .title-wrapper h2 {
    display: flex;
    font-size: 14px;
  }
}
.task_playground {
  border-radius: 16px;
  padding: 30px 20px;
  background-color: #fff;
  min-height: calc(100dvh - 120px);
}
.task_playground .page-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.task_playground .page-heading .page-title {
  margin-bottom: 22px;
}
.task_playground .page-heading .page-title h1 {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 12px;
}
.task_playground .page-heading .page-title p {
  font-weight: 400;
  font-size: 20px;
  color: #7A7A7A;
}
.task_playground .page-heading .upper-section .ant-btn {
  border-radius: 20px;
  background-color: #1953E9;
}
.task_playground .playground_list {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
}
.task_playground .playground_list .list_item {
  padding: 16px;
  border: 1px solid #ededed;
  border-radius: 12px;
  background-color: #f6f6f6;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.task_playground .playground_list .list_item .up_side {
  display: flex;
  justify-content: space-between;
}
.task_playground .playground_list .list_item .up_side .title {
  font-size: 24px;
  font-weight: 600;
  color: #1953E9;
  cursor: pointer;
  max-width: 290px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.task_playground .playground_list .list_item .up_side .icon {
  cursor: pointer;
}
.task_playground .playground_list .list_item .low_side {
  padding-top: 10px;
  border-top: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.task_playground .playground_list .list_item .low_side .author {
  display: flex;
}
.task_playground .playground_list .list_item .low_side .author span {
  display: flex;
  margin-right: 5px;
}
.task_playground .playground_list .list_item .low_side .author p {
  display: flex;
}

.popover_content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.popover_content span {
  display: flex;
  width: 100px;
  cursor: pointer;
}
.popover_content span p {
  font-size: 16px;
  font-weight: 500;
  color: #686666;
}
.popover_content span .icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  color: #686666 !important;
}

.canban_page_wrapper {
  height: calc(100dvh - 120px) !important;
  overflow: hidden;
}

.priority_high {
  color: #dd2f2f !important;
}

.trello_title_wrapper {
  display: flex;
  flex-direction: column;
}

.trello_back_btn {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  width: 100%;
}
.trello_back_btn * {
  color: #7A7A7A !important;
}
.trello_back_btn div {
  display: flex;
  align-items: center;
}
.trello_back_btn div .icon {
  transform: rotateZ(90deg);
}

.priority_medium {
  color: #ff9900 !important;
}

.priority_low {
  color: #1953e9 !important;
}

.trello_column_item {
  border: 1px solid #a4a4a4;
  padding: 16px;
  border-radius: 10px;
}
.trello_column_item:hover {
  cursor: grab;
}
.trello_column_item .item_wrapper .prpject_title h2 {
  font-size: 16px;
  font-weight: 600;
  max-width: 205px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
}
.trello_column_item .item_wrapper .priority {
  display: flex;
  align-items: center;
  margin-top: 4px;
  gap: 20px;
  margin-bottom: 12px;
  justify-content: space-between;
}
.trello_column_item .item_wrapper .priority span {
  display: block;
  font-size: 14px;
  color: #54577a;
  max-width: 160px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.trello_column_item .item_wrapper .priority .icon {
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
}
.trello_column_item .item_wrapper .date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.trello_column_item .item_wrapper .date .date_wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.trello_column_item .item_wrapper .date .date_wrapper .icon {
  width: 22px;
  height: 22px;
  color: #00c853 !important;
}
.trello_column_item .item_wrapper .date .action {
  cursor: pointer;
}
.trello_column_item .item_wrapper .members {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.trello_column_item .item_wrapper .members .mine {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 5px;
  border-radius: 4px;
  background-color: #edf8fe;
  color: #517a9a;
  text-transform: uppercase;
  box-sizing: border-box;
  border: 1px solid #32b4fd;
}
.trello_column_item .item_wrapper .creators {
  cursor: pointer !important;
  width: -moz-fit-content;
  width: fit-content;
}

.trello_btn_wrapper {
  height: 70vh;
  align-items: center;
  display: flex;
  padding-left: 20px;
}

.add_column_trello {
  display: flex;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: #1953E9;
  cursor: pointer;
}
.add_column_trello * {
  color: #fff;
}

.status .icon {
  cursor: pointer;
}

.page_title_wrapper_trello {
  width: 100%;
}

.upper_section_trello {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.upper_section_trello .add-btn .ant-btn {
  background-color: #1953E9 !important;
  border-radius: 20px !important;
}

.colors_for_playground {
  display: flex;
  gap: 14px;
  justify-content: space-between;
}
.colors_for_playground span {
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.color_label {
  font-size: 14px;
  display: flex;
  margin-bottom: 14px;
}

.dragging-overlay-trello {
  list-style: none;
  background-color: #fff;
}
.dragging-overlay-trello .item_wrapper:hover {
  cursor: grabbing;
}
.dragging-overlay-trello .item_wrapper .prpject_title h2 {
  font-size: 16px;
  font-weight: 600;
}
.dragging-overlay-trello .item_wrapper .priority {
  display: flex;
  align-items: center;
  margin-top: 4px;
  gap: 20px;
  margin-bottom: 12px;
}
.dragging-overlay-trello .item_wrapper .priority span {
  font-size: 14px;
  color: #54577a;
}
.dragging-overlay-trello .item_wrapper .priority .icon {
  width: 20px;
  height: 20px;
}
.dragging-overlay-trello .item_wrapper .date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.dragging-overlay-trello .item_wrapper .date .date_wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dragging-overlay-trello .item_wrapper .date .date_wrapper .icon {
  width: 22px;
  height: 22px;
}
.dragging-overlay-trello .item_wrapper .date .action .icon {
  cursor: pointer;
}

.file_upload_trello .ant-upload-list {
  display: flex;
  flex-wrap: wrap;
}
.file_upload_trello .ant-upload-list .ant-upload-list-item {
  margin-right: 10px;
}

.multiple_select_trello {
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.multiple_select_trello .ant-select-selector {
  min-height: 44px;
}
.multiple_select_trello .ant-select {
  position: relative;
}
.multiple_select_trello .ant-select .ant-select-selection-item {
  min-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e3e9f9;
}
.multiple_select_trello .ant-select .ant-select-selection-item .ant-select-selection-item-content {
  font-size: 14px;
  font-weight: 400;
}

.small-modal {
  position: relative;
  z-index: 9999999;
}

.ant-popover {
  z-index: 1000;
}

.task_create_modal_wrapper {
  padding: 30px;
  height: 100%;
}
.task_create_modal_wrapper .single-input-item {
  position: relative;
}
.task_create_modal_wrapper .single-input-item .ant-row {
  align-items: start;
  width: 100%;
}
.task_create_modal_wrapper .single-input-item .ant-row .ant-col {
  width: 100%;
}
.task_create_modal_wrapper .single-input-item label {
  font-size: 16px;
  font-weight: 500;
  color: #131111;
  text-align: start;
  display: flex;
}
.task_create_modal_wrapper .single-input-item input {
  height: 44px;
  width: 100%;
}
.task_create_modal_wrapper .single-input-item .ant-select {
  height: 44px !important;
  position: relative;
}
.task_create_modal_wrapper .single-input-item .ant-picker {
  height: 44px !important;
}
.task_create_modal_wrapper .single-input-item .ant-form-item {
  margin-bottom: 0;
}
.task_create_modal_wrapper .single-input-item .ant-form-item-has-error .PhoneInput input {
  border-color: #ff4d4f;
}
.task_create_modal_wrapper .single-input-item .PhoneInput {
  border: none !important;
}
.task_create_modal_wrapper .single-input-item .PhoneInput input {
  border-radius: 6px;
  outline: none;
  border: 1px solid #d9d9d9;
  padding: 4px 11px;
  font-size: 14px;
  transition: all 0.3s ease;
}
.task_create_modal_wrapper .single-input-item .PhoneInput input::placeholder {
  color: #bfbfbf;
}
.task_create_modal_wrapper .single-input-item .PhoneInput input:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
}
.task_create_modal_wrapper .single-input-item .PhoneInput .PhoneInputCountry {
  display: none;
}
.task_create_modal_wrapper .single-input-item .PhoneInput .PhoneInput--focus {
  border: 1px solid none !important;
}

.w-full {
  width: 100%;
}

.flex-row {
  display: flex;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/Components/Navbar/_navbar.scss","webpack://./src/styles/global.scss","webpack://./src/Build/_build.scss","webpack://./src/Build/Auth/_auth.scss","webpack://./src/styles/variables.scss","webpack://./src/Build/Pages/Projects/_projects.scss","webpack://./src/Build/Pages/Projects/Single/_single.scss","webpack://./src/Build/Pages/Log/_log.scss","webpack://./src/Build/Pages/In_out/_in_out.scss","webpack://./src/Build/Pages/Employees/_employees.scss","webpack://./src/Build/Pages/Employees/EmployeeModal/_action.scss","webpack://./src/Build/Pages/Projects/Action/_action.scss","webpack://./src/Build/Pages/Settings/Country/Action/_action.scss","webpack://./src/Build/Pages/Settings/Job/_job.scss","webpack://./src/Build/Pages/Sales/calculator/_sales.scss","webpack://./src/Build/Pages/Finance/Dashboard/_dashboard.scss","webpack://./src/Build/Pages/Finance/Expenses/_expenses.scss","webpack://./src/Build/Pages/Sales/canban/_canban.scss","webpack://./src/Build/Pages/Tasks/_task.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;ACLA;EACE,YAAA;EACA,kBAAA;EAEA,UAAA;EACA,sBAAA;ADOF;ACNE;EACE,iDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ADQJ;ACNE;EACE,aAAA;ADQJ;ACNE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ADQJ;ACPI;EAEE,YAAA;ADQN;ACJE;EACE,yBAAA;ADMJ;ACHE;EACE,aAAA;EACA,mBAAA;ADKJ;ACJI;EACE,kBAAA;EACA,eAAA;ADMN;ACJI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;ADMN;ACJQ;EACE,gBAAA;EACA,eAAA;ADMV;ACJQ;EACE,oBAAA;ADMV;ACJQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;ADMV;ACHM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ADKR;ACFM;EACE,WAAA;EACA,YAAA;ADIR;ACDI;EACE,iBAAA;EACA,eAAA;ADGN;;ACCA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;ADEF;;ACCA;EACE;IACE,0DAAA;IAKA,aAAA;IACA,mBAAA;IACA,aAAA;EDFF;ECHE;IACE,aAAA;EDKJ;ECAE;IACE,aAAA;IACA,WAAA;EDEJ;ECDI;IACE,WAAA;IACA,8BAAA;EDGN;AACF;AE1GA;EACI,oBAAA;AF4GJ;;AEzGA;EACI,kBAAA;AF4GJ;;AEzGA;;;;EAII,yDAAA;EAAA,iDAAA,EAAA,2CAAA;EACA,wCAAA,EAAA,sBAAA;EACA,6CAAA,EAAA,4DAAA;AF4GJ;;AEzGA,gBAAA;AACA;;;;EAII,wCAAA;AF4GJ;;AGpIA;EACE,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,kCAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EAKA,aAAA;AHmIF;AGtIE;EACE,aAAA;AHwIJ;;AGnIA;;;EAGE,wCAAA;AHsIF;;AGnIA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,oBAAA;AHsIF;;AGpIA;EACE,iCAAA;EAEA,sBAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;AHsIF;AGrIE;EACE,8BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AHuIJ;AGrIE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AHuIJ;AGtII;EACE,YAAA;AHwIN;AGtII;EACE,YAAA;AHwIN;AGtII;EACE,yBAAA;AHwIN;AGtII;EACE,QAAA;EACA,UAAA;EACA,oBAAA;AHwIN;AGtII;EACE,uBAAA;AHwIN;AGrIE;EACE,aAAA;AHuIJ;;AGpIA;EACE,aAAA;AHuIF;;AGrIA;EACE,wCAAA;AHwIF;AGvIE;EACE,wCAAA;AHyIJ;AGtII;EACE,yBAAA;AHwIN;;AGpIA;;EAEE,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;AHuIF;;AGrIA;EACE,4BAAA;AHwIF;;AGrIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AHwIF;;AGrIA;EACE,0BAAA;EACA,sBAAA;EACA,0BAAA;AHwIF;AGvIE;;EAEE,6BAAA;EACA,gBAAA;AHyIJ;;AGtIA;EACE,oCAAA;EACA,sBAAA;AHyIF;;AGtIA;EACE,2BAAA;AHyIF;;AGtIA;EACE,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;AHyIF;AGvIE;EACE,aAAA;AHyIJ;;AGrIA;EACE,aAAA;AHwIF;;AGrIA;EACE;IACE,aAAA;EHwIF;EGtIA;IACE,cAAA;EHwIF;EGtII;IACE,aAAA;IACA,oBAAA;EHwIN;EGvIM;IACE,eAAA;EHyIR;AACF;AIpSA;EACE,aAAA;EACA,YAAA;AJsSF;AIrSE;EACE,aAAA;EACA,YAAA;AJuSJ;AItSI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;AJwSN;AIvSM;EACE,YAAA;EACA,aAAA;EACA,4BAAA;AJySR;AIvSM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AJySR;AItSI;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJwSN;AIvSM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,4BAAA;EACA,sBAAA;AJySR;AIxSQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AJ0SV;AIvSQ;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AJySV;AItSQ;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AJwSV;AIvSU;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AJySZ;AIxSY;EACE,cC5DL;ALsWT;AItSU;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EAEA,kBAAA;EACA,eAAA;EACA,sBAAA;AJuSZ;AIpSU;EACE,qBAAA;AJsSZ;AInSU;EACE,qBC7EA;ALkXZ;AInSU;EACE,gCAAA;AJqSZ;AIlSU;EACE,gCAAA;AJoSZ;AIjSU;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AJmSZ;AIlSY;EACE,YAAA;EACA,eAAA;AJoSd;AIhSU;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;AJkSZ;AI9RQ;EACE,gBAAA;AJgSV;AI7RQ;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AJ+RV;AI9RU;EACE,sBAAA;EACA,uBAAA;AJgSZ;AI7RU;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AJ+RZ;AI9RY;EACE,wCAAA;AJgSd;AI9RY;EACE,UAAA;EACA,YAAA;AJgSd;AI3RQ;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBC/IE;EDgJF,mBAAA;AJ6RV;;AItRA;EACE;IACE,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,4BAAA;IACA,6BAAA;IACA,aAAA;IACA,uBAAA;EJyRF;EIvRI;IACE,aAAA;EJyRN;EIvRI;IACE,WAAA;EJyRN;EIxRM;IACE,gBAAA;EJ0RR;AACF;AMxcA;EACE,aAAA;EACA,6BAAA;EACA,kBAAA;AN0cF;AMzcE;EACE,aAAA;EACA,8BAAA;AN2cJ;AM1cI;EACE,aAAA;EACA,SAAA;AN4cN;AM3cM;EACE,mBAAA;AN6cR;AM3cM;EACE,yBDXI;ALwdZ;AM1cI;EACE,aAAA;EACA,SAAA;AN4cN;AM3cM;EACE,YAAA;EACA,YAAA;AN6cR;AM5cQ;EACE,8BAAA;EACA,6BAAA;AN8cV;AM1cI;EACE,YAAA;AN4cN;AM3cM;EACE,YAAA;EACA,wCAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;AN6cR;AM3cM;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AN6cR;AMzcI;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AN2cN;AM1cM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cDhEI;AL4gBZ;AM1cM;EACE,yBAAA;EACA,yBAAA;AN4cR;AMzcM;EACE,yBDxEI;ALmhBZ;AM1cQ;EACE,sBAAA;AN4cV;AM1cQ;EACE,WDrEF;ALihBR;AMtcE;EACE,gBAAA;ANwcJ;AMvcI;EACE,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;ANycN;AMxcM;EAEE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,4BAAA;EACA,sBDxFA;ALiiBR;AMvcU;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;ANycZ;AMxcY;EACE,eAAA;EACA,gBAAA;EACA,cD3GF;EC4GE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AN0cd;AMxcY;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AN0cd;AMvcU;EACE,6BAAA;EACA,4BAAA;EACA,gDAAA;ANycZ;AMxcY;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AN0cd;AMxcc;;EAEE,aAAA;EACA,QAAA;EACA,mBAAA;AN0chB;AMzcgB;;EACE,sBAAA;EACA,uBAAA;EACA,yBAAA;AN4clB;AM1cgB;;EACE,eAAA;EACA,gBAAA;EACA,cD/IX;AL4lBP;AM1cc;EACE,eAAA;EACA,gBAAA;EACA,cDrJT;ALimBP;AMxcY;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AN0cd;AMzcc;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,yBAAA;EACA,SAAA;AN2chB;AMzcc;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AN2chB;;AMjcA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,oBAAA;ANmcF;;AMhcA;EAGM;IACE,8BAAA;ENicN;AACF;AO9oBA;EACE,kBAAA;APgpBF;AO/oBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;APipBJ;AO9oBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cFNQ;ALspBd;AO/oBM;EACE,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;APipBR;AO5oBI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBF3BM;EE4BN,QAAA;AP8oBN;AO7oBM;EACE,+BAAA;EACA,YAAA;AP+oBR;AO7oBM;EACE,0BAAA;AP+oBR;;AOzoBA;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;AP4oBF;AO3oBE;EACE,gBAAA;EACA,WAAA;AP6oBJ;AO3oBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AP6oBN;AO3oBI;EACE,eAAA;EACA,gBAAA;EACA,cFnDQ;EEoDR,mBAAA;AP6oBN;AO1oBI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AP4oBN;AO3oBM;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AP6oBR;AO3oBM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AP6oBR;AOzoBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AP2oBN;AO1oBM;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;AP4oBR;AO3oBQ;;EACE,sBAAA;EACA,uBAAA;AP8oBV;AOzoBI;EACE,gBAAA;AP2oBN;AO1oBM;EACE,eAAA;EACA,gBAAA;EACA,WFtGD;ALkvBP;AO3oBQ;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AP6oBV;AO5oBU;EACE,cAAA;AP8oBZ;AO5oBU;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AP8oBZ;AO1oBQ;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,YAAA;AP4oBV;AO3oBU;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AP6oBZ;AO1oBQ;EACE,uBAAA;AP4oBV;AO1oBQ;EACE,6BAAA;AP4oBV;AOtoBE;EACE,gBAAA;EACA,WAAA;APwoBJ;AOtoBI;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;APwoBN;AOvoBM;EACE,YAAA;EACA,yBAAA;APyoBR;AOvoBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;APyoBR;AOvoBM;EACE,WAAA;APyoBR;AOvoBQ;EACE,qBAAA;EACA,aAAA;EACA,uBAAA;APyoBV;AOxoBU;EACE,iCAAA;EACA,kBAAA;EACA,SAAA;AP0oBZ;AOvoBQ;EACE,aAAA;APyoBV;AOvoBQ;EACE,aAAA;APyoBV;AOvoBQ;EACE,aAAA;APyoBV;AOtoBM;EACE,YAAA;APwoBR;AOtoBM;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;APwoBR;AOvoBQ;EACE,cAAA;APyoBV;AOxoBU;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AP0oBZ;AOtoBQ;EACE,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;APwoBV;AOvoBU;EACE,UAAA;EACA,kBAAA;EACA,WAAA;APyoBZ;AOtoBU;EACE,kBAAA;EAEA,MAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;APuoBZ;AOtoBY;EACE,yBAAA;APwoBd;AOtoBY;EACE,WAAA;EACA,kBAAA;EACA,aAAA;APwoBd;AOpoBU;EACE,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;APsoBZ;AOloBQ;EACE,eAAA;APooBV;AOjoBQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;APmoBV;AOhoBM;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;APkoBR;AOjoBQ;EACE,YAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,wBAAA;EAAA,mBAAA;EACA,yBAAA;APmoBV;AOhoBQ;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;APkoBV;AOjoBU;EACE,eAAA;EACA,gBAAA;APmoBZ;;AO3nBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AP8nBF;AO7nBE;EACE,uBAAA;EACA,iBAAA;EACA,wBAAA;EACA,8BAAA;AP+nBJ;AO5nBE;EACE,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;AP8nBJ;AO3nBE;EACE,uBAAA;AP6nBJ;AO3nBE;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AP6nBJ;;AQ79BA;EACI,mBAAA;EACA,kBAAA;EACA,sBHQI;ALw9BR;AQ/9BI;EACI,mBAAA;ARi+BR;AQh+BQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;ARk+BZ;AQh+BQ;EACI,gBAAA;EACA,eAAA;EACA,cHTK;AL2+BjB;AQ99BI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;ARg+BR;AQ/9BQ;EACI,aAAA;EACA,SAAA;ARi+BZ;AQh+BY;EACI,YAAA;ARk+BhB;AQj+BgB;EACI,YAAA;EACA,wCAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;ARm+BpB;AQj+BgB;EACI,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;ARm+BpB;AQ/9BY;EACI,kBAAA;EACA,eAAA;ARi+BhB;AQh+BgB;EACI,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;ARk+BpB;AQ/9BgB;EACI,YAAA;EACA,YAAA;EACA,mBAAA;ARi+BpB;AQh+BoB;EACI,kBAAA;ARk+BxB;AQ19BgB;EACI,wBAAA;EACA,qBAAA;AR49BpB;AQt9BY;EACI,yBAAA;ARw9BhB;AQn9BI;EACI,iBAAA;EACA,kBAAA;ARq9BR;AQp9BQ;EACI,6BAAA;ARs9BZ;AQp9BQ;EACI,kBAAA;ARs9BZ;AQp9BQ;EACI,6BAAA;ARs9BZ;AQp9BgB;EACI,6BAAA;EACA,eAAA;EACA,cHjGR;EGkGQ,gBAAA;EACA,gCAAA;EACA,iCAAA;ARs9BpB;AQr9BoB;EACI,4BAAA;ARu9BxB;AQp9BoB;EACI,6BAAA;ARs9BxB;AQp9BoB;EACI,2BAAA;ARs9BxB;AQ98BY;EACI,sCAAA;EACA,eAAA;EACA,gBAAA;ARg9BhB;AQ/8BgB;EACI,4BAAA;ARi9BpB;AQ/8BgB;EACI,6BAAA;EACA,qBAAA;EACA,6BAAA;EACA,4BAAA;ARi9BpB;AQ98BgB;EACI,eAAA;EACA,iBAAA;EACA,UAAA;ARg9BpB;AQ78BgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AR+8BpB;AQ78BgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,eAAA;AR88BpB;AQ78BoB;EACI,sBAAA;EACA,uBAAA;AR+8BxB;AQ58BgB;EACI,eAAA;AR88BpB;AQ38BgB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AR68BpB;AQ58BoB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,+BAAA;EACA,4BAAA;AR88BxB;AQ78BwB;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AR+8B5B;AQz8BoB;EACI,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,oCAAA;EACA,kBAAA;AR28BxB;AQz8BoB;EACI,2BAAA;EACA,WHvMjB;EGwMiB,uBAAA;EACA,2BAAA;EACA,wBAAA;EACA,UAAA;AR28BxB;AQ18BwB;EACI,aAAA;AR48B5B;AQp8BQ;EACI,sBAAA;EACA,kBAAA;ARs8BZ;AQp8BgB;EACI,kBAAA;EACA,QAAA;ARs8BpB;AQl8BY;EACI,oCAAA;ARo8BhB;AQh8BQ;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ARk8BZ;;AQ97BA;EACI,2BAAA;ARi8BJ;;AQ97BA;EAGY;IACI,wBAAA;ER+7Bd;EQ77BU;IACI,uBAAA;ER+7Bd;EQ97Bc;IACI,eAAA;IACA,iBAAA;IACA,UAAA;ERg8BlB;EQ97Bc;IACI,4BAAA;IACA,6BAAA;ERg8BlB;EQ/7BkB;IACI,WAAA;ERi8BtB;AACF;ASjtCA;EACE,mBAAA;EACA,kBAAA;EACA,sBJQM;AL2sCR;ASltCE;EACE,mBAAA;ATotCJ;ASntCI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;ATqtCN;ASntCI;EACE,gBAAA;EACA,eAAA;EACA,cJTW;AL8tCjB;ASjtCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ATmtCJ;ASltCI;EACE,aAAA;EACA,SAAA;ATotCN;ASntCM;EACE,YAAA;ATqtCR;ASptCQ;EACE,YAAA;EACA,wCAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;ATstCV;ASptCQ;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;ATstCV;ASntCM;EACE,YAAA;ATqtCR;ASptCQ;EACE,YAAA;EACA,WAAA;EACA,mBAAA;ATstCV;ASjtCM;EACE,yBAAA;ATmtCR;AS9sCE;EACE,iBAAA;EACA,kBAAA;ATgtCJ;AS/sCI;EACE,6BAAA;ATitCN;AS/sCI;EACE,kBAAA;ATitCN;AS/sCI;EACE,6BAAA;ATitCN;AS/sCQ;EACE,6BAAA;EACA,eAAA;EACA,cJzEE;EI0EF,gBAAA;EACA,gCAAA;EACA,iCAAA;ATitCV;AShtCU;EACE,4BAAA;ATktCZ;AShtCU;EACE,6BAAA;ATktCZ;ASjtCY;EACE,8BAAA;ATmtCd;AShtCU;EACE,6BAAA;ATktCZ;ASjtCY;EACE,8BAAA;ATmtCd;AShtCU;EACE,2BAAA;ATktCZ;AS/sCQ;EACE,cAAA;ATitCV;AS/sCQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;ATitCV;AShtCU;EACE,cAAA;ATktCZ;AShtCU;EACE,eAAA;ATktCZ;AShtCU;EACE,8BAAA;ATktCZ;AS3sCM;EACE,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AT6sCR;AS3sCQ;EACE,gBAAA;EACA,WAAA;EACA,aAAA;AT6sCV;AS5sCU;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AT8sCZ;AS1sCQ;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AT4sCV;AS3sCU;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AT6sCZ;AS1sCU;EACE,0CAAA;AT4sCZ;AS1sCU;EACE,mDAAA;AT4sCZ;AS1sCU;EACE,0CAAA;AT4sCZ;AStsCI;EACE,sBAAA;EACA,kBAAA;ATwsCN;AStsCQ;EACE,kBAAA;EACA,QAAA;ATwsCV;ASrsCM;;EAEE,oCAAA;ATusCR;ASnsCI;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ATqsCN;;ASjsCA;EACE,2BAAA;ATosCF;;ASjsCA;EACE,qBAAA;EACA,4BAAA;ATosCF;;ASlsCA;EAGM;IACE,wBAAA;ETmsCN;ESjsCI;IACE,uBAAA;ETmsCN;ESlsCM;IACE,eAAA;IACA,iBAAA;IACA,UAAA;ETosCR;ESlsCM;IACE,4BAAA;IACA,6BAAA;ETosCR;ESnsCQ;IACE,WAAA;ETqsCV;AACF;AU95CI;EACE,aAAA;EACA,SAAA;AVg6CN;AU/5CM;EACE,mBAAA;AVi6CR;AU/5CM;EACE,yBLNI;ALu6CZ;AU55CE;EACE,yBAAA;AV85CJ;AUx5CQ;EACE,4BAAA;EACA,6BAAA;EAEA,eAAA;EACA,cAAA;AVy5CV;AUv5CU;EACE,aAAA;EACA,8BAAA;AVy5CZ;AUx5CY;EACE,eAAA;EACA,yBAAA;AV05Cd;AUj5CU;EACE,oCAAA;AVm5CZ;AU/4CM;EACE,4BAAA;EACA,6BAAA;AVi5CR;AU/4CQ;EACE,eAAA;EACA,gBAAA;AVi5CV;AU94CQ;EACE,eAAA;EACA,gBAAA;AVg5CV;AU94CQ;EACE,eAAA;EACA,gBAAA;AVg5CV;AU94CQ;EACE,6BAAA;AVg5CV;AU94CQ;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;AVg5CV;AU/4CU;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AVi5CZ;AU/4CU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,MAAA;EACA,WAAA;AVi5CZ;AUh5CY;EACE,aAAA;AVk5Cd;AUj5Cc;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AVm5ChB;AU/4Cc;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AVi5ChB;AU/4Cc;EACE,eAAA;EACA,gBAAA;AVi5ChB;AU54CU;EACE,yBAAA;AV84CZ;AUz4CU;EACE,eAAA;EACA,gBAAA;AV24CZ;AUz4CU;EACE,eAAA;EACA,gBAAA;EACA,cL7GA;ALw/CZ;AUt4CU;EACE,yBAAA;EACA,eAAA;AVw4CZ;AUp4CQ;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AVs4CV;AUn4CQ;EACE,yBAAA;AVq4CV;AUn4CU;EACE,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AVq4CZ;AUl4CY;EACE,UAAA;AVo4Cd;AU/3CQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AVi4CV;AUh4CU;EACE,sBAAA;EACA,eAAA;AVk4CZ;AUj4CY;EACE,yBAAA;AVm4Cd;AUj4CY;EACE,yBAAA;AVm4Cd;AU53CI;EACE,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;AV83CN;AU73CM;EACE,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;AV+3CR;AU93CQ;EACE,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AVg4CV;AU93CQ;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EAEA,uBAAA;EACA,OAAA;EACA,MAAA;AV+3CV;AU73CQ;EACE,UAAA;AV+3CV;AU93CU;EACE,UAAA;EACA,oBAAA;AVg4CZ;AU93CU;EACE,UAAA;AVg4CZ;;AUx3CA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;AV23CF;AU13CE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,cLpOQ;ALgmDZ;AU13CE;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;AV43CJ;;AUx3CA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;AV23CF;AU13CE;EACE,UAAA;EAEA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AV23CJ;AU13CI;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AV43CN;AU33CM;EACE,UAAA;AV63CR;AU33CM;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;AV63CR;AU13CI;EACE,WAAA;EACA,YAAA;AV43CN;AU13CM;EACE,gBAAA;EAEA,WAAA;EACA,YAAA;EACA,gBAAA;AV23CR;;AW3pDA;EAGE,uCAAA;AX4pDF;;AWzpDA;EAEE,wBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,8BAAA;AX0pDF;;AW7oDA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AXgpDF;;AW5oDA;EACE,eAAA;EACA,2BAAA;EACA,WAAA;AX+oDF;;AW5oDA;EACE,eAAA;AX+oDF;;AW1oDI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AX6oDN;AW3oDI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AX6oDN;AWzoDE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AX2oDJ;AW1oDI;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBNtEM;ALktDZ;AW3oDM;EACE,sBAAA;EACA,uBAAA;EACA,sBAAA;AX6oDR;AW1oDI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AX4oDN;AW3oDM;EACE,sBAAA;EACA,uBAAA;AX6oDR;AWroDE;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AXuoDJ;AWloDI;EACE,kBAAA;AXooDN;AWnoDM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AXqoDR;AWnoDM;EACE,YAAA;AXqoDR;AWloDM;EACE,uBAAA;EACA,kBAAA;AXooDR;AWhoDM;EACE,uBAAA;AXkoDR;AWhoDM;EACE,gBAAA;AXkoDR;AW7nDU;EACE,qBAAA;AX+nDZ;AW1nDM;EAEE,uBAAA;AX2nDR;AW1nDQ;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AX4nDV;AW3nDU;EACE,cAAA;AX6nDZ;AW3nDU;EACE,qBAAA;EACA,4CAAA;AX6nDZ;AW1nDQ;EACE,aAAA;AX4nDV;AW1nDQ;EACE,iCAAA;AX4nDV;AWvnDI;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AXynDN;AWvnDM;EACE,wBAAA;EACA,SAAA;EACA,mBAAA;AXynDR;AWnnDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AXqnDN;AWpnDM;EACE,YAAA;AXsnDR;AWlnDI;EACE,kBAAA;AXonDN;AWnnDM;EACE,aAAA;EACA,mBAAA;AXqnDR;AWpnDQ;EACE,aAAA;AXsnDV;AWpnDQ;EACE,YAAA;AXsnDV;AWlnDM;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;AXonDR;AW/mDE;EACE,kCAAA;AXinDJ;AW9mDE;EACE,aAAA;EACA,uBAAA;AXgnDJ;;AW3mDE;EACE,aAAA;AX8mDJ;AW7mDI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AX+mDN;AW3mDE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;AX6mDJ;AW5mDI;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;AX8mDN;AW7mDM;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AX+mDR;AW9mDQ;EACE,gBAAA;AXgnDV;AW/mDU;EACE,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;AXinDZ;AW9mDQ;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AXgnDV;AW/mDU;EACE,YAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AXinDZ;AW9mDU;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AXgnDZ;AW9mDU;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AXgnDZ;AW7mDU;EACE,yBAAA;EACA,eAAA;AX+mDZ;AW5mDQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AX8mDV;AW7mDU;EACE,sBAAA;EACA,uBAAA;AX+mDZ;AW1mDI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AX4mDN;AW1mDM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AX4mDR;AW3mDQ;EACE,aAAA;AX6mDV;AW3mDQ;EACE,yBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AX6mDV;AW5mDU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AX8mDZ;AW5mDU;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AX8mDZ;;AWtmDA;EACE,uBAAA;AXymDF;AWxmDE;EACE,uBAAA;EACA,WAAA;EAEA,eAAA;EACA,aAAA;AXymDJ;AWxmDI;EACE,2BAAA;EACA,aAAA;AX0mDN;AWxmDI;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AX0mDN;AWzmDM;EACE,eAAA;AX2mDR;;AY59DA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AZ+9DF;AY99DE;EACE,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,8BAAA;AZg+DJ;AY79DE;EACE,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;AZ+9DJ;AY59DE;EACE,uBAAA;AZ89DJ;AY39DE;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AZ69DJ;AYz9DE;EACE,+BAAA;EACA,8BAAA;AZ29DJ;AYz9DI;EACE,mBAAA;AZ29DN;AY19DM;EACE,yBPjCI;EOkCJ,WP1BA;ALs/DR;AYt9DI;EACE,4BAAA;EACA,gCAAA;EACA,8BAAA;AZw9DN;AYv9DM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AZy9DR;AYv9DM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AZy9DR;AYr9DI;EACE,aAAA;EACA,kCAAA;EACA,SAAA;EACA,aAAA;AZu9DN;AYr9DQ;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AZu9DV;AYt9DU;EACE,eAAA;AZw9DZ;AYr9DQ;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AZu9DV;AYr9DU;EACE,2BAAA;AZu9DZ;AYr9DU;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AZu9DZ;AYr9DU;EACE,2BAAA;EACA,4BAAA;EACA,cAAA;AZu9DZ;AYr9DU;EACE,2BAAA;AZu9DZ;AYn9DQ;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AZq9DV;AYn9DU;EACE,aAAA;AZq9DZ;AYn9DU;EACE,YAAA;AZq9DZ;AYj9DM;EACE,kBAAA;AZm9DR;AYl9DQ;EACE,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,UAAA;AZo9DV;AY/8DI;EACE,0BAAA;AZi9DN;AY98DU;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,qBAAA;AZg9DZ;AY/8DY;EACE,2BAAA;AZi9Dd;AY/8DY;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AZi9Dd;AY/8DY;EACE,2BAAA;EACA,4BAAA;EACA,cAAA;AZi9Dd;AY/8DY;EACE,2BAAA;AZi9Dd;AY78DU;EACE,qBAAA;AZ+8DZ;AYt8DI;EACE,YAAA;EACA,iBAAA;AZw8DN;AYr8DI;EACE,kCAAA;AZu8DN;AYr8DI;EACE,kBAAA;EACA,mBAAA;AZu8DN;AYt8DM;EACE,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AZw8DR;AYv8DQ;EACE,eAAA;AZy8DV;;Aa5nEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;Ab+nEF;Aa9nEE;EACE,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,8BAAA;AbgoEJ;Aa7nEE;EACE,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;Ab+nEJ;Aa5nEE;EACE,uBAAA;Ab8nEJ;Aa3nEE;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;Ab6nEJ;AaznEE;EACE,+BAAA;EACA,8BAAA;Ab2nEJ;AaznEI;EACE,mBAAA;Ab2nEN;Aa1nEM;EACE,yBRjCI;EQkCJ,WR1BA;ALspER;AatnEI;EACE,4BAAA;EACA,gCAAA;EACA,8BAAA;AbwnEN;AavnEM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AbynER;AarnEI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AbunEN;AatnEM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AbwnER;AatnEM;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AbwnER;AavnEQ;EACE,eAAA;AbynEV;AarnEM;EACE,mBAAA;AbunER;AarnEM;EACE,8BAAA;AbunER;AapnEI;EACE,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AbsnEN;AarnEM;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AbunER;;AajnEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AbonEF;AannEE;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AbqnEJ;;AczuEA;EACE,sBTUM;ESTN,mBAAA;EACA,gBAAA;EACA,6BAAA;Ad4uEF;Ac3uEE;EACE,6BAAA;Ad6uEJ;Ac1uEQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;Ad4uEV;Ac1uEQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;Ad4uEV;AcruEQ;EACE,6BAAA;AduuEV;AcjuEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AdmuEJ;AcluEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AdouEN;AchuEE;EACE,aAAA;EACA,uBAAA;AdkuEJ;AchuEE;EACE,mBAAA;AdkuEJ;AchuEE;EACE,8BAAA;AdkuEJ;Ac9tEM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AdguER;Ac9tEM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AdguER;AcztEM;EACE,6BAAA;Ad2tER;AcrtEI;EACE,yBAAA;EACA,eAAA;AdutEN;AchtEE;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AdktEJ;AcjtEI;EACE,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBT9FM;ALizEZ;AcltEM;EACE,0BAAA;EACA,gBAAA;AdotER;;Ac9sEA;EACE,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AditEF;AchtEE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;AdktEJ;Ac/sEE;EACE,kBAAA;EAEA,MAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;AdgtEJ;Ac/sEI;EACE,yBAAA;AditEN;Ac/sEI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AditEN;Ac7sEE;EACE,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;Ad+sEJ;;Aep2EA;EACE,mBAAA;EACA,sBVSM;EURN,gBAAA;Afu2EF;Aer2EE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;Afu2EJ;Aer2EM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;Afu2ER;Aer2EM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;Afu2ER;Aep2EI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;Afs2EN;Aep2EI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,yBVjCM;ALu4EZ;Aer2EM;EACE,eAAA;Afu2ER;Aen2EI;EACE,6BAAA;EACA,yBAAA;EACA,cV1CM;AL+4EZ;Aep2EM;EACE,6BAAA;EACA,cV7CI;ALm5EZ;Aeh2EI;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,yBAAA;Afk2EN;Aej2EM;EACE,gBAAA;EACA,WAAA;Afm2ER;Ael2EQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;Afo2EV;Ael2EQ;EACE,YAAA;Afo2EV;Aej2EQ;EACE,uBAAA;EACA,kBAAA;Afm2EV;Ae/1EI;EACE,aAAA;EACA,SAAA;EACA,4BAAA;Afi2EN;Aeh2EM;EACE,gBAAA;EACA,WAAA;Afk2ER;Aej2EQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;Afm2EV;Aej2EQ;EACE,YAAA;Afm2EV;Ae/1EQ;EACE,gBAAA;EACA,kBAAA;Afi2EV;Aeh2EU;EACE,WAAA;Afk2EZ;Aeh2EU;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;Afk2EZ;Aej2EY;EACE,eAAA;EACA,gBAAA;Afm2Ed;Ae91EM;EACE,YAAA;Afg2ER;Ae91EM;EAEE,2BAAA;EACA,sBAAA;Af+1ER;Ae91EQ;EACE,WAAA;EACA,YAAA;EACA,YAAA;Afg2EV;Ae91EQ;EACE,YAAA;EACA,sBAAA;Afg2EV;Ae91EQ;EACE,YAAA;EACA,yBVjIE;ALi+EZ;Ae/1EU;EACE,+BAAA;EACA,yBVrIF;ALs+EV;Ae71EM;EACE,iBAAA;EAEA,WAAA;EACA,iBAAA;Af81ER;Ae71EQ;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;Af+1EV;Ae91EU;EACE,yBAAA;EACA,mBAAA;Afg2EZ;Ae/1EY;EACE,aAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;Afi2Ed;Aeh2Ec;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;Afk2EhB;Aej2EgB;EACE,eAAA;EACA,gBAAA;Afm2ElB;Aej2EgB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;Afm2ElB;Aeh2Ec;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;Afk2EhB;Aej2EgB;EACE,YAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;Afm2ElB;Ael2EkB;EACE,gBAAA;Afo2EpB;Aeh2Ec;EACE,eAAA;Afk2EhB;;Aev1EE;EACE,kBAAA;EACA,gBAAA;Af01EJ;Aez1EI;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;Af21EN;Aez1EI;EACE,yBAAA;Af21EN;Aez1EI;EACE,WAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;Af21EN;Aez1EM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;Af21ER;Ae11EQ;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;Af41EV;Aex1EM;;;EAGE,sBAAA;Af01ER;Aex1EM;EACE,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;Af01ER;Aex1EM;EACE,gEAAA;EACA,2BAAA;Af01ER;Aex1EM;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBVnQI;EUoQJ,yBAAA;Af01ER;Aex1EM;EACE,wBAAA;Af01ER;Aex1EM;EACE,eAAA;EACA,gBAAA;Af01ER;Aex1EM;EACE,wBAAA;Af01ER;Aex1EM;EACE,eAAA;EACA,UAAA;Af01ER;Aex1EM;EACE,wBAAA;Af01ER;Aex1EM;EACE,eAAA;EACA,gBAAA;Af01ER;Aex1EM;EACE,wBAAA;Af01ER;Aex1EM;EACE,SAAA;EACA,UAAA;Af01ER;Aex1EM;EACE,uBAAA;Af01ER;Aex1EM;EACE,eAAA;EACA,gBAAA;Af01ER;Aex1EM;EACE,wBAAA;Af01ER;Aex1EM;EACE,eAAA;EACA,UAAA;Af01ER;Aex1EM;EACE,wBAAA;Af01ER;Aex1EM;EACE,eAAA;EACA,gBAAA;Af01ER;Aex1EM;EACE,wBAAA;Af01ER;Aex1EM;EACE,SAAA;EACA,gBAAA;Af01ER;Aex1EM;EACE;IACE,uBAAA;Ef01ER;Eex1EM;IACE,yBAAA;Ef01ER;AACF;Aet1EI;EACE,UAAA;EACA,oBAAA;Afw1EN;Aer1EE;EAEE,yBAAA;EACA,kBAAA;Afs1EJ;Aep1EI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;Afs1EN;Aer1EM;EACE,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,SAAA;Afs1ER;Aer1EQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;Afu1EV;Aer1EQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;Afu1EV;Aen1EI;EACE,aAAA;EACA,mBAAA;EACA,4CAAA;Afq1EN;Aep1EM;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;Afs1ER;;AgBhtFE;EACE,WAAA;EACA,gBAAA;AhBmtFJ;AgBjtFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AhBmtFJ;AgBjtFI;EACE,YAAA;EACA,8BAAA;EACA,YAAA;AhBmtFN;AgBltFM;EACE,mBAAA;EACA,yBAAA;AhBotFR;;AgB9sFA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AhBitFF;AgB/sFI;EACE,sBAAA;AhBitFN;;AgB7sFA;EACE,gBAAA;AhBgtFF;AgB9sFE;EACE,cAAA;AhBgtFJ;;AgB5sFA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AhB+sFF;AgB9sFE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBXnDQ;EWoDR,WX5CI;AL4vFR;;AgB3sFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AhB8sFJ;AgB5sFI;EACE,aAAA;EACA,SAAA;AhB8sFN;AgB7sFM;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WX5DD;EW6DC,yBAAA;AhB+sFR;AgB5sFM;EACE,WXjED;EWkEC,mBAAA;EACA,yBAAA;EACA,WXpED;ALkxFP;AgB3sFY;EACE,WXxEP;ALqxFP;AgBzsFQ;EACE,sBAAA;AhB2sFV;AgBtsFE;EACE,aAAA;EACA,qCAAA,EAAA,4BAAA;EACA,SAAA;AhBwsFJ;AgBvsFI;EACE,aAAA;EACA,mBAAA;AhBysFN;AgBvsFM;EACE,0BAAA;EACA,2BAAA;AhBysFR;AgBtsFM;EACE,qBAAA;EACA,0BAAA;AhBwsFR;;AiBpzFE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AjBuzFJ;;AiBnzFA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,WZHM;ALyzFR;;AiBpzFA;EACE,2BAAA;AjBuzFF;;AiBrzFA;EACE,yBAAA;AjBwzFF;;AiBrzFA;EACE,YAAA;AjBwzFF;;AiBrzFA;EACE,yBAAA;EACA,mBAAA;AjBwzFF;AiBvzFE;EACE,WAAA;AjByzFJ;AiBvzFE;EACE,sBAAA;AjByzFJ;;AiBrzFA;EACE,aAAA;AjBwzFF;;AiBnzFI;EACE,YAAA;AjBszFN;AiBpzFI;EACE,UAAA,EAAA,kCAAA;EACA,oBAAA;AjBszFN;AiBpzFM;EACE,cAAA;EACA,sBAAA;AjBszFR;;AiBhzFA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AjBmzFF;;AiB/yFE;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AjBkzFJ;AiBjzFI;EACE,aAAA;AjBmzFN;;AkB93FA;EACE,yBAAA;EACA,0BAAA;AlBi4FF;;AkB93FA;EACE,0DAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AlBi4FF;AkBh4FE;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;AlBk4FJ;;AkB93FA;EACE,YAAA;AlBi4FF;AkBh4FE;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EAIA,cAAA;AlB+3FJ;AkBl4FI;EACE,aAAA;AlBo4FN;AkBj4FI;EACE,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AlBm4FN;AkBl4FM;EACE,aAAA;AlBo4FR;AkBl4FM;EACE,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;AlBo4FR;AkBn4FQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AlBq4FV;AkBp4FU;EACE,gBAAA;EACA,eAAA;AlBs4FZ;AkBp4FU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AlBs4FZ;AkBn4FQ;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,WAAA;AlBq4FV;AkBj4FM;EACE,gBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AlBm4FR;AkBl4FQ;EACE,iBAAA;EACA,0DAAA;EAEA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AlBm4FV;AkBl4FU;EACE,YAAA;AlBo4FZ;AkBj4FU;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;AlBm4FZ;AkBj4FY;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AlBm4Fd;AkBj4FY;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AlBm4Fd;AkBh4FU;EACE,aAAA;EACA,kBAAA;EACA,QAAA;AlBk4FZ;AkBj4FY;EACE,0BAAA;AlBm4Fd;AkBj4FY;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AlBm4Fd;AkBj4FY;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AlBm4Fd;;AkB13FA;EACE,iBAAA;EACA,0DAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AlB63FF;AkB53FE;EACE,gBAAA;AlB83FJ;AkB53FE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;AlB83FJ;AkB53FI;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AlB83FN;AkB53FI;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AlB83FN;AkB13FE;EACE,aAAA;EACA,kBAAA;EACA,QAAA;AlB43FJ;AkB13FI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AlB43FN;AkB13FI;EACE,eAAA;EACA,gBAAA;AlB43FN;;AkBv3FA;EACE,kBAAA;EACA,iBAAA;AlB03FF;;AkBr3FA;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,aAAA;AlBw3FF;;AkBr3FA;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AlBw3FF;;AkBr3FA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AlBw3FF;;AkBr3FA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sCAAA;AlBw3FF;;AkBr3FA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,sCAAA;AlBw3FF;;AkBr3FA;EACE,aAAA;AlBw3FF;;AkBr3FA;EACE,gBAAA;AlBw3FF;AkBv3FE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AlBy3FJ;AkBv3FE;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AlBy3FJ;AkBx3FI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AlB03FN;;AkBr3FA;EACE,WAAA;AlBw3FF;AkBv3FE;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;AlBy3FJ;AkBt3FI;EACE,aAAA;AlBw3FN;;AkBn3FA;EACE,aAAA;AlBs3FF;AkBr3FE;EACE,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AlBu3FJ;AkBr3FE;EACE,eAAA;EACA,gBAAA;AlBu3FJ;AkBr3FE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AlBu3FJ;AkBr3FE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AlBu3FJ;AkBt3FI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AlBw3FN;AkBr3FE;EACE,gBAAA;AlBu3FJ;AkBr3FE;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlBu3FJ;AkBr3FE;EACE,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;AlBu3FJ;;AkBn3FA;EACE;IACE,yBAAA;IACA,0BAAA;ElBs3FF;EkBl3FE;IACE,uBAAA;ElBo3FJ;EkBh3FA;IACE,aAAA;IACA,uBAAA;IACA,2BAAA;ElBk3FF;EkBj3FE;IACE,wBAAA;ElBm3FJ;EkBj3FE;IACE,cAAA;IACA,gBAAA;IACA,gCAAA;ElBm3FJ;EkBj3FI;IACE,cAAA;ElBm3FN;EkBl3FM;IACE,aAAA;ElBo3FR;EkBj3FI;IACE,aAAA;IACA,0BAAA;ElBm3FN;EkBj3FQ;IACE,WAAA;ElBm3FV;EkB32FE;IACE,aAAA;ElB62FJ;EkB32FM;IACE,eAAA;ElB62FR;EkB32FM;IACE,eAAA;ElB62FR;EkBz2FE;IACE,aAAA;ElB22FJ;EkBt2FE;IACE,sBAAA;ElBw2FJ;EkBp2FE;IACE,uBAAA;ElBs2FJ;EkBl2FA;IACE,cAAA;IACA,WAAA;IACA,oBAAA;ElBo2FF;EkBj2FI;IACE,mBAAA;IACA,uBAAA;ElBm2FN;EkBj2FI;IACE,WAAA;IACA,mBAAA;IACA,YAAA;IAEA,yBAAA;ElBk2FN;EkB91FE;IACE,iBAAA;ElBg2FJ;EkB/1FI;IACE,yBAAA;IACA,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,QAAA;ElBi2FN;EkB71FI;IACE,gBAAA;IACA,iBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;ElB+1FN;EkB71FQ;IACE,kBAAA;IACA,aAAA;IACA,kBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;IACA,0DAAA;ElB+1FV;EkB71FU;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,aAAA;IACA,QAAA;ElB+1FZ;EkB91FY;IACE,yBAAA;ElBg2Fd;EkB91FY;IACE,yBAAA;ElBg2Fd;EkB51FU;IACE,aAAA;ElB81FZ;EkB51FY;IACE,eAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;ElB81Fd;EkB51FY;IACE,eAAA;IACA,gBAAA;ElB81Fd;EkBr1FA;IACE,aAAA;IACA,sBAAA;ElBu1FF;EkBp1FA;IACE,gBAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;ElBs1FF;EkBr1FE;IACE,aAAA;IACA,8BAAA;IACA,oBAAA;IACA,sBAAA;IACA,SAAA;ElBu1FJ;EkBt1FI;IACE,aAAA;ElBw1FN;EkBt1FI;IACE,aAAA;IACA,eAAA;ElBw1FN;AACF;AmBz1GA;EACE,mBAAA;EACA,kBAAA;EACA,sBdQM;EcPN,gCAAA;AnB21GF;AmB11GE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AnB41GJ;AmB31GI;EACE,mBAAA;AnB61GN;AmB51GM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AnB81GR;AmB51GM;EACE,gBAAA;EACA,eAAA;EACA,cddS;AL42GjB;AmB11GM;EACE,mBAAA;EACA,yBdtBI;ALk3GZ;AmBv1GE;EACE,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;AnBy1GJ;AmBx1GI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AnB01GN;AmBz1GM;EACE,aAAA;EACA,8BAAA;AnB21GR;AmB11GQ;EACE,eAAA;EACA,gBAAA;EACA,cd/CE;EcgDF,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnB41GV;AmB11GQ;EACE,eAAA;AnB41GV;AmBz1GM;EACE,iBAAA;EACA,6BAAA;EAWA,aAAA;EACA,8BAAA;EACA,mBAAA;AnBi1GR;AmB71GQ;EACE,aAAA;AnB+1GV;AmB91GU;EACE,aAAA;EACA,iBAAA;AnBg2GZ;AmB91GU;EACE,aAAA;AnBg2GZ;;AmBr1GA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnBw1GF;AmBv1GE;EACE,aAAA;EACA,YAAA;EACA,eAAA;AnBy1GJ;AmBx1GI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AnB01GN;AmBx1GI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AnB01GN;;AmBr1GA;EACE,uCAAA;EACA,gBAAA;AnBw1GF;;AmBr1GA;EACE,yBAAA;AnBw1GF;;AmBt1GA;EACE,aAAA;EACA,sBAAA;AnBy1GF;;AmBv1GA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AnB01GF;AmBz1GE;EACE,yBAAA;AnB21GJ;AmBz1GE;EACE,aAAA;EACA,mBAAA;AnB21GJ;AmB11GI;EACE,yBAAA;AnB41GN;;AmBv1GA;EACE,yBAAA;AnB01GF;;AmBx1GA;EACE,yBAAA;AnB21GF;;AmBx1GA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;AnB21GF;AmB11GE;EACE,YAAA;AnB41GJ;AmBv1GM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AnBy1GR;AmBt1GI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;AnBw1GN;AmBv1GM;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnBy1GR;AmBv1GM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AnBy1GR;AmBt1GI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AnBw1GN;AmBv1GM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AnBy1GR;AmBx1GQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AnB01GV;AmBt1GM;EACE,eAAA;AnBw1GR;AmBr1GI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AnBu1GN;AmBt1GM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;AnBw1GR;AmBr1GI;EACE,0BAAA;EACA,uBAAA;EAAA,kBAAA;AnBu1GN;;AmBn1GA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AnBs1GF;;AmBp1GA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBd3OU;Ec4OV,eAAA;AnBu1GF;AmBt1GE;EACE,WdtOI;AL8jHR;;AmBn1GE;EACE,eAAA;AnBs1GJ;;AmBn1GA;EACE,WAAA;AnBs1GF;;AmBp1GA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AnBu1GF;AmBr1GI;EACE,oCAAA;EACA,8BAAA;AnBu1GN;;AmBl1GA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AnBq1GF;AmBn1GE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AnBq1GJ;;AmBl1GA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AnBq1GF;;AmBn1GA;EACE,gBAAA;EACA,sBAAA;AnBs1GF;AmBn1GI;EACE,gBAAA;AnBq1GN;AmBl1GM;EACE,eAAA;EACA,gBAAA;AnBo1GR;AmBj1GI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AnBm1GN;AmBl1GM;EACE,eAAA;EACA,cAAA;AnBo1GR;AmBl1GM;EACE,WAAA;EACA,YAAA;AnBo1GR;AmBj1GI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AnBm1GN;AmBl1GM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AnBo1GR;AmBn1GQ;EACE,WAAA;EACA,YAAA;AnBq1GV;AmBj1GQ;EACE,eAAA;AnBm1GV;;AmB30GE;EACE,aAAA;EACA,eAAA;AnB80GJ;AmB70GI;EACE,kBAAA;AnB+0GN;;AmB10GA;EACE,4BAAA;EAAA,uBAAA;AnB60GF;AmB50GE;EACE,gBAAA;AnB80GJ;AmB50GE;EACE,kBAAA;AnB80GJ;AmB50GI;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;AnB80GN;AmB70GM;EACE,eAAA;EACA,gBAAA;AnB+0GR;;AmBz0GA;EACE,kBAAA;EACA,gBAAA;AnB40GF;;AmBz0GA;EACE,aAAA;AnB40GF;;AmBz0GA;EACE,aAAA;EACA,YAAA;AnB40GF;AmB30GE;EACE,kBAAA;AnB60GJ;AmB50GI;EACE,kBAAA;EACA,WAAA;AnB80GN;AmB70GM;EACE,WAAA;AnB+0GR;AmB50GI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;AnB80GN;AmB50GI;EACE,YAAA;EACA,WAAA;AnB80GN;AmB30GI;EACE,uBAAA;EACA,kBAAA;AnB60GN;AmB30GI;EACE,uBAAA;AnB60GN;AmB30GI;EACE,gBAAA;AnB60GN;AmBx0GQ;EACE,qBAAA;AnB00GV;AmBr0GI;EACE,uBAAA;AnBu0GN;AmBt0GM;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AnBw0GR;AmBv0GQ;EACE,cAAA;AnBy0GV;AmBv0GQ;EACE,qBAAA;EACA,4CAAA;AnBy0GV;AmBt0GM;EACE,aAAA;AnBw0GR;AmBt0GM;EACE,iCAAA;AnBw0GR;;AmBj0GA;EACE,WAAA;AnBo0GF;;AmBj0GA;EACE,aAAA;EACA,SAAA;AnBo0GF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n@import '../src/styles/variables.scss';\n@import '../src/Components/Navbar/navbar';\n@import '../src/styles/global';\n@import '../src/Build/build';\n\n// Pages\n@import '../src/Build/Auth/auth';\n@import '../src/Build/Pages/pages';\n@import '../src/Build/Pages/Projects/projects';\n@import '../src/Build/Pages/Projects/Single/single';\n@import '../src/Build/Pages/Log/log';\n@import '../src/Build/Pages/In_out/in_out';\n@import '../src/Build/Pages/Employees/employees';\n@import '../src/Build/Pages/Employees/EmployeeModal/action';\n@import '../src/Build/Pages/Projects/Action/action';\n@import '../src//Build//Pages/Settings/Country/Action/action';\n@import '../src//Build/Pages/Settings/Job/job';\n@import '../src/Build/Pages/Sales/calculator/sales';\n@import '../src/Build/Pages/Finance/Dashboard/dashboard';\n@import '../src/Build/Pages/Finance/Expenses/expenses';\n@import '../src/Build/Pages/Sales/canban/canban';\n@import '../src/Build/Pages/Tasks/task';\n","nav {\n  height: 80px;\n  position: relative;\n  // border: 1px solid red;\n  z-index: 2;\n  background-color: #fff;\n  .nav-wrapper {\n    box-shadow: 0px 4px 10px -8px rgba(0, 0, 0, 0.75);\n    width: 100%;\n    height: 100%;\n    padding-left: 10px;\n    padding-right: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .mobile_nav_wrapper {\n    display: none;\n  }\n  .left-menu {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    .nav_logo {\n      // border: 1px solid red;\n      width: 200px;\n    }\n  }\n\n  .ant-avatar {\n    background-color: #f6f6f6;\n  }\n\n  .right-profile {\n    display: flex;\n    align-items: center;\n    .notifications {\n      margin-right: 40px;\n      cursor: pointer;\n    }\n    .profile {\n      display: flex;\n      gap: 7px;\n      align-items: center;\n      min-width: 150px;\n      .info {\n        h3 {\n          font-weight: 500;\n          font-size: 12px;\n        }\n        .pro_account {\n          font-family: cursive;\n        }\n        span {\n          font-size: 10px;\n          font-weight: 500;\n          padding: 2px 5px;\n          border-radius: 4px;\n          background-color: #edf8fe;\n          color: #517a9a;\n          text-transform: uppercase;\n          box-sizing: border-box;\n          border: 1px solid #32b4fd;\n        }\n      }\n      .avatar {\n        margin-top: 5px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .my_image {\n        width: 50px;\n        height: 50px;\n      }\n    }\n    .drop-down {\n      margin-left: 20px;\n      cursor: pointer;\n    }\n  }\n}\n.my_image_big {\n  width: 200px;\n  height: 200px;\n  border-radius: 5px;\n}\n\n@media (max-width: 700px) {\n  nav {\n    box-shadow: 0px 2px 6px 0px #0d0a2c14;\n\n    .nav-wrapper {\n      display: none;\n    }\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    .mobile_nav_wrapper {\n      display: flex;\n      width: 100%;\n      .left-menu {\n        width: 100%;\n        justify-content: space-between;\n      }\n    }\n  }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');\n\n*{\n    font-family: \"Inter\";\n}\n\n.ant-form-item-explain-error{\n    position: absolute;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    transition: background-color 5000s ease-in-out 0s; /* Smooth transition for background color */\n    -webkit-text-fill-color: #333 !important; /* Custom text color */\n    -webkit-box-shadow: 0 0 0px 1000px #fff inset; /* Change #fff to match your form's input background color */\n}\n\n/* For Firefox */\ninput:-moz-ui-autofill,\ninput:-moz-ui-autofill:hover,\ninput:-moz-ui-autofill:focus,\ninput:-moz-ui-autofill:active {\n    background-color: transparent !important;\n}",".ant-layout-sider-trigger {\n  position: absolute;\n  z-index: 5 !important;\n  top: 0;\n  background: transparent !important;\n  max-width: 30px;\n  height: 30px;\n  top: 20px;\n  left: 20px;\n  // border: 1px solid red;\n  svg {\n    display: none;\n  }\n  display: none;\n}\n\n.ant-layout-sider,\n.ant-layout-sider-dark,\n.ant-layout-sider-has-trigger {\n  background-color: transparent !important;\n}\n\n.ant-menu {\n  padding-bottom: 0;\n  background: #fff;\n  padding-top: 10px;\n  border: none !important;\n  padding-bottom: 20px;\n}\n.ant-layout-sider-children {\n  background-color: #fff !important;\n  // display: flex;\n  flex-direction: column;\n  justify-content: space-between !important;\n  padding-right: 5px;\n  padding-left: 5px;\n  max-height: calc(100vh);\n  overflow: auto;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  .sider_wrapper {\n    max-height: calc(100vh - 80px);\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .demo_logo {\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n    align-items: center;\n    height: 80px;\n    padding: 30px;\n    border-bottom: 1px solid #e2e2e2;\n    .nav_logo {\n      width: 140px;\n    }\n    .logo_min {\n      height: 50px;\n    }\n    img {\n      transition: all 0.3s ease;\n    }\n    .nav_logo_min {\n      width: 0;\n      opacity: 0;\n      pointer-events: none;\n    }\n    .nav_logo_mini {\n      height: 40px !important;\n    }\n  }\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n.demo-logo-vertical {\n  display: none;\n}\n.secondary-menu {\n  border-top: 1px solid #e2e2e2 !important;\n  .ant-menu-item-selected {\n    background-color: transparent !important;\n  }\n  .ant-menu-item {\n    &:last-child {\n      color: $danger !important;\n    }\n  }\n}\n.ant-layout-sider,\n.ant-layout-sider-dark {\n  max-width: 240px !important;\n  width: 240px !important;\n  position: absolute;\n  z-index: 3;\n  min-width: 240px !important;\n}\n.ant-layout-sider-has-trigger {\n  padding-bottom: 0 !important;\n}\n\n.ant-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  // padding-inline: calc(45% - 9px - 4px);\n}\n.ant-layout-sider-collapsed {\n  max-width: 64px !important;\n  width: 64px !important;\n  min-width: 64px !important;\n  .ant-menu-item,\n  .ant-menu-submenu-title {\n    padding-left: 11px !important;\n    padding-top: 5px;\n  }\n}\n.ant-menu-item-selected {\n  background-color: $primary !important;\n  color: #fff !important;\n}\n\n.ant-menu-sub {\n  background: #fff !important ;\n}\n\n.content {\n  padding: 20px;\n  position: relative;\n  height: calc(100vh - 80px);\n  overflow: auto;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.ant-drawer {\n  display: none;\n}\n\n@media (max-width: 1080px) {\n  .menu_desktop {\n    display: none;\n  }\n  .ant-drawer {\n    display: block;\n    .ant-drawer-header {\n      .ant-drawer-header-title {\n        display: flex;\n        justify-content: end;\n        button {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}\n",".login-page {\n  height: 100vh;\n  width: 100vw;\n  .login-page-wrapper {\n    display: flex;\n    height: 100%;\n    .leftside {\n      position: relative;\n      width: 50%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-image: url(../../Assets/images/login-back.png);\n      background-position: center;\n      background-size: cover;\n      background-repeat: no-repeat;\n      .header-logo {\n        width: 580px;\n        height: 200px;\n        transform: translateY(-50px);\n      }\n      .line {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n      }\n    }\n    .rightside {\n      width: 50%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .center {\n        max-width: 435px;\n        width: 100%;\n        display: flex;\n        transform: translateY(-50px);\n        flex-direction: column;\n        h1 {\n          font-size: 24px;\n          font-weight: 500;\n          color: #131111;\n        }\n\n        .ant-form-item-row {\n          display: flex;\n          flex-direction: column;\n          align-items: start;\n        }\n\n        .single-item {\n          margin-top: 40px;\n          height: 110px;\n          position: relative;\n          p {\n            font-size: 16px;\n            color: #131111;\n            margin-bottom: 10px;\n            span {\n              color: $danger;\n            }\n          }\n\n          input {\n            height: 64px;\n            width: 100%;\n            border-radius: 20px;\n            // border: 1px solid $secondary;\n            padding-left: 55px;\n            font-size: 18px;\n            background-color: #fff;\n          }\n\n          .ant-input-outlined:hover {\n            border-color: #37a141;\n          }\n\n          .ant-input-outlined {\n            border-color: $secondary;\n          }\n          .ant-input-outlined.ant-input-status-warning {\n            border-color: #faad14 !important;\n          }\n\n          .ant-input-outlined.ant-input-status-error {\n            border-color: $danger !important;\n          }\n\n          .ant-input-affix-wrapper {\n            height: 64px;\n            width: 100%;\n            border-radius: 20px;\n            padding-left: 55px;\n            font-size: 18px;\n            padding-right: 20px;\n            input {\n              height: 100%;\n              padding-left: 0;\n            }\n          }\n\n          .icon {\n            position: absolute;\n            z-index: 5;\n            left: 20px;\n            top: 55px;\n          }\n        }\n\n        .ant-form-item-explain-error {\n          margin-top: 10px;\n        }\n\n        .remember {\n          display: flex;\n          margin-top: 40px;\n          position: static;\n          height: 24px;\n          input {\n            width: 24px !important;\n            height: 24px !important;\n          }\n\n          .ant-checkbox-inner {\n            width: 24px !important;\n            height: 24px !important;\n            border-radius: 8px;\n            border: 1px solid #9c9c9c;\n            .ant-checkbox-checked {\n              border: 1px solid transparent !important;\n            }\n            &::after {\n              width: 8px;\n              height: 14px;\n            }\n          }\n        }\n\n        button {\n          margin-top: 75px;\n          width: 100%;\n          height: 57px;\n          font-size: 18px;\n          font-weight: 600;\n          background-color: $secondary;\n          border-radius: 20px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 700px) {\n  .login-page {\n    overflow: hidden;\n    margin-right: auto;\n    margin-left: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    max-width: 100dvw !important;\n    max-height: 100dvh !important;\n    display: flex;\n    justify-content: center;\n    .login-page-wrapper {\n      .leftside {\n        display: none;\n      }\n      .rightside {\n        width: 100%;\n        .center {\n          max-width: 100vw;\n        }\n      }\n    }\n  }\n}\n","// Colors\n$danger: #ED4C5C;\n$primary: #739BFF;\n$secondary: #1953E9;\n$gray: #686666;\n$secondary_gray: #7A7A7A;\n$third_gray:#828B96;\n$fourth_gray: #999999;\n$light_gray: #F1F2F4;\n$gray-blue: #A0AEC0;\n$fifth_gray:  #ACACAC;\n$light: #fff;\n$dark: #000;",".projects {\n  padding: 40px;\n  transition: opacity 0.3s ease;\n  position: relative;\n  .upper-section {\n    display: flex;\n    justify-content: space-between;\n    .download-btn {\n      display: flex;\n      gap: 30px;\n      button {\n        border-radius: 20px;\n      }\n      .ant-btn-primary {\n        background-color: $secondary;\n      }\n    }\n    .upper_filter {\n      display: flex;\n      gap: 20px;\n      .ant-select {\n        height: 40px;\n        width: 180px;\n        .ant-select-selector {\n          border-radius: 20px !important;\n          background-color: transparent;\n        }\n      }\n    }\n    .search-btn {\n      width: 330px;\n      .ant-btn-default {\n        border: none;\n        border-top-right-radius: 20px !important;\n        border-bottom-right-radius: 20px !important;\n        height: 38px;\n        width: 47px;\n        position: absolute;\n        top: 1px;\n        right: 1px;\n        z-index: 2;\n        background-color: transparent;\n      }\n      input {\n        border-radius: 20px !important;\n        width: 330px;\n        height: 40px;\n        padding-left: 20px;\n        padding-right: 50px;\n        background-color: transparent;\n      }\n    }\n\n    .add-project-btn {\n      border: 2px solid $secondary;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding: 9px 50px;\n      border-radius: 20px;\n      height: 44px;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      span {\n        font-size: 16px;\n        font-weight: 500;\n        transition: all 0.3s ease;\n        color: $secondary;\n      }\n      .icon {\n        transition: all 0.3s ease;\n        color: $secondary !important;\n      }\n\n      &:hover {\n        background-color: $secondary;\n        .icon {\n          color: $light !important;\n        }\n        span {\n          color: $light;\n        }\n      }\n    }\n  }\n\n  .projects-list {\n    margin-top: 30px;\n    ul {\n      list-style: none;\n      display: grid;\n      grid-template-columns: 1fr 1fr 1fr;\n      gap: 40px;\n      li {\n        // max-width: 400px;\n        display: flex;\n        flex-direction: column;\n        border-top-right-radius: 12px;\n        border-top-left-radius: 12px;\n        background-color: $light;\n        .item {\n          .project-title {\n            padding: 20px;\n            margin-bottom: 20px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            h2 {\n              font-size: 28px;\n              font-weight: 600;\n              color: $secondary;\n              text-transform: uppercase;\n              max-width: 250px;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n            }\n            .icon {\n              color: $secondary !important;\n              width: 20px !important;\n              height: 20px !important;\n              cursor: pointer;\n            }\n          }\n          .project-info {\n            border-top-right-radius: 12px;\n            border-top-left-radius: 12px;\n            box-shadow: 0px -1px 30px 0px rgba(0, 0, 0, 10%);\n            .info {\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              padding: 23px 12px;\n\n              .start-date,\n              .completion-date {\n                display: flex;\n                gap: 3px;\n                align-items: center;\n                .icon {\n                  width: 14px !important;\n                  height: 14px !important;\n                  color: $gray !important;\n                }\n                span {\n                  font-size: 12px;\n                  font-weight: 400;\n                  color: $gray;\n                }\n              }\n              .status {\n                font-size: 14px;\n                font-weight: 500;\n                color: $gray;\n              }\n            }\n\n            .proccess {\n              height: 22px;\n              display: flex;\n              position: relative;\n              justify-content: center;\n              align-items: center;\n              .proccess-line {\n                height: 100%;\n                position: absolute;\n                left: 0;\n                top: 0;\n                transition: all 0.3s ease;\n                width: 0%;\n              }\n              span {\n                font-size: 12px;\n                font-weight: 600;\n                position: relative;\n                z-index: 3;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.loader {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  // top: 0px;\n  transition: all 0.3s ease;\n  left: 0px;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgb(255, 255, 255, 0.5);\n  pointer-events: none;\n}\n\n@media (max-width: 1320px) {\n  .projects {\n    .projects-list {\n      ul {\n        grid-template-columns: 1fr 1fr;\n      }\n    }\n  }\n}\n",".single-project {\n  padding: 15px 80px;\n  .upper-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .back-home {\n    div {\n      display: flex;\n      align-items: center;\n      font-size: 16px;\n      font-weight: 500;\n      color: $fourth_gray;\n      .icon {\n        transform: rotate(90deg);\n        width: 20px !important;\n        height: 20px !important;\n        margin-right: 5px;\n        margin-left: -5px;\n      }\n    }\n  }\n  .save-btn {\n    button {\n      display: flex;\n      align-items: center;\n      flex-direction: row-reverse;\n      padding: 10px 30px !important;\n      border-radius: 12px;\n      background: $secondary;\n      gap: 5px;\n      &:disabled {\n        color: rgb(255, 255, 255, 0.7);\n        opacity: 0.7;\n      }\n      .ant-btn-icon {\n        margin-right: 0 !important;\n      }\n    }\n  }\n}\n\n.main {\n  padding-top: 35px;\n  display: flex;\n  justify-content: space-between;\n  gap: 100px;\n  .left {\n    max-width: 400px;\n    width: 100%;\n\n    h1 {\n      font-size: 36px;\n      font-weight: 600;\n      color: #131111;\n      margin-bottom: 5px;\n    }\n    p {\n      font-size: 16px;\n      font-weight: 400;\n      color: $fifth_gray;\n      margin-bottom: 10px;\n    }\n\n    .proccess {\n      height: 22px;\n      display: flex;\n      position: relative;\n      justify-content: center;\n      align-items: center;\n      border-radius: 10px;\n      overflow: hidden;\n      .proccess-line {\n        height: 100%;\n        position: absolute;\n        left: 0;\n        top: 0;\n        transition: all 1.2s ease;\n        width: 0%;\n        border-radius: 10px;\n      }\n      span {\n        font-size: 12px;\n        font-weight: 600;\n        position: relative;\n        z-index: 3;\n      }\n    }\n\n    .dates {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-top: 20px;\n      .start-date,\n      .completion-date {\n        display: flex;\n        align-items: center;\n        gap: 3px;\n        color: $gray !important;\n        font-size: 12px;\n        .icon {\n          width: 14px !important;\n          height: 14px !important;\n        }\n      }\n    }\n\n    .client-info {\n      margin-top: 20px;\n      label {\n        font-size: 20px;\n        font-weight: 500;\n        color: $dark;\n        input {\n          border-top: none;\n          border-left: none;\n          border-right: none;\n          padding-left: 0;\n          border-bottom: 1px solid #a09f9f;\n          border-radius: 0;\n          font-size: 16px;\n          font-weight: 400;\n          outline: none;\n          background-color: transparent;\n          padding-bottom: 10px;\n          margin-bottom: 20px;\n          margin-top: 15px;\n          width: 100%;\n          &:disabled {\n            color: #777777;\n          }\n          &:focus {\n            background: transparent;\n            outline: none;\n            box-shadow: none;\n          }\n        }\n\n        textarea {\n          margin-top: 15px;\n          height: auto !important;\n          border-top: none;\n          border-left: none;\n          border-right: none;\n          padding-left: 0;\n          border-bottom: 1px solid #a09f9f;\n          border-radius: 0;\n          font-size: 16px;\n          font-weight: 400;\n          outline: none;\n          background-color: transparent;\n          resize: none;\n          &:focus {\n            background: transparent;\n            outline: none;\n            box-shadow: none;\n          }\n        }\n        .ant-input {\n          height: auto !important;\n        }\n        .ant-input-outlined {\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .right {\n    max-width: 533px;\n    width: 100%;\n\n    .todo {\n      border-radius: 10px;\n      overflow: hidden;\n      background-color: #fbfbfb;\n      .top {\n        height: 15px;\n        transition: all 1.2s ease;\n      }\n      h1 {\n        font-size: 24px;\n        font-weight: 500;\n        color: #131111;\n        padding-bottom: 32px;\n        border-bottom: 1px solid #dddddd;\n        margin-top: 33px;\n        padding-left: 20px;\n      }\n      .ant-list-empty-text {\n        height: 0px;\n        // display: none;\n        .ant-empty-normal {\n          padding: 0 !important;\n          display: flex;\n          justify-content: center;\n          &::after {\n            content: 'Any information left ?';\n            position: absolute;\n            top: 10px;\n          }\n        }\n        &::after {\n          display: none;\n        }\n        .ant-empty-image {\n          display: none;\n        }\n        .ant-empty-description {\n          display: none;\n        }\n      }\n      .ant-list {\n        border: none;\n      }\n      .ant-list-item {\n        padding: 0;\n        padding-left: 20px;\n        padding-right: 12px;\n        display: flex;\n        align-items: center;\n        margin-top: 25px;\n        border-bottom: none;\n        label {\n          max-width: 80%;\n          p {\n            width: 100%;\n            font-size: 16px;\n            font-weight: 400;\n            color: #3b3b3b;\n            word-wrap: break-word;\n          }\n        }\n\n        .custom-checkbox {\n          display: flex !important;\n          flex-direction: row;\n          align-items: center;\n          width: 100%;\n          position: relative;\n          input {\n            opacity: 0;\n            position: absolute;\n            width: 100%;\n          }\n\n          .checkmark {\n            position: relative;\n\n            top: 0;\n            left: 0;\n            height: 24px;\n            min-width: 24px;\n            display: inline-block;\n            margin-right: 10px;\n            border: 1px solid #777777;\n            border-radius: 5px;\n            transition: all 0.3s ease;\n            background-position: center;\n            cursor: pointer;\n            &:hover {\n              background-color: #fbfafa;\n            }\n            &:after {\n              content: '';\n              position: absolute;\n              display: none;\n            }\n          }\n\n          input:checked + .checkmark {\n            background-color: #d0f9d4;\n            border: 1px solid #36b151;\n            background-image: url(../../../../Assets/icons/checked.svg);\n            background-repeat: no-repeat;\n            background-position: center;\n            background-size: 16px;\n          }\n        }\n\n        .icon {\n          cursor: pointer;\n        }\n\n        li {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n      .field {\n        display: flex;\n        margin-top: 25px;\n        padding-top: 12px;\n        padding-bottom: 12px;\n        border-top: 1px solid #dddddd;\n        padding-left: 10px;\n        padding-right: 10px;\n        gap: 10px;\n        textarea {\n          border: none;\n          background-color: transparent;\n          outline: none;\n          box-shadow: none;\n          resize: none;\n          height: fit-content;\n          border: 1px solid #d6d6d6;\n        }\n\n        button {\n          display: flex;\n          align-items: center;\n          flex-direction: row-reverse;\n          color: #131111;\n          font-size: 16px;\n          border: 1px solid #d6d6d6;\n          .ant-btn-icon {\n            margin-right: 0;\n            margin-left: 5px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.delete-pop-up {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .ant-modal-content {\n    width: 400px !important;\n    top: 0 !important;\n    padding: 20px !important;\n    border-radius: 20px !important;\n  }\n\n  .ant-modal {\n    width: 500px !important;\n    top: 0px !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n\n  .ant-modal-root {\n    width: 500px !important;\n  }\n  .ant-modal-wrap {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n}\n",".projects_log{\n    border-radius: 16px;\n    padding: 30px 20px;\n    background-color: $light;\n    .page-title{\n        margin-bottom: 22px;\n        h1{\n            font-size: 32px;\n            font-weight: 600;\n            margin-bottom: 12px;\n        }\n        p{\n            font-weight: 400;\n            font-size: 20px;\n            color: $secondary_gray;\n        }\n    }\n\n    .upper-section{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        .left{\n            display: flex;\n            gap: 20px;\n            .search-btn{\n                width: 330px;\n                .ant-btn-default{\n                    border: none;\n                    border-top-right-radius: 20px !important;\n                    border-bottom-right-radius: 20px !important;\n                    height: 38px;\n                    width: 47px;\n                    position: absolute;\n                    top: 1px;\n                    right: 1px;\n                    z-index: 2;\n                    background-color: transparent;\n                }\n                input{\n                    border-radius: 20px !important;\n                    width: 330px;\n                    height: 40px;\n                    padding-left: 20px;\n                    padding-right: 50px;\n                    background-color: transparent;\n                    \n                }\n            }\n            .select{\n                position: relative;\n                cursor: pointer;\n                .icon{\n                    width: 16px !important;\n                    height: 16px !important;\n                    position: absolute;\n                    right: 12px;\n                    top: 12px;\n                    pointer-events: none;\n                    \n                }\n                .ant-select-selector{\n                    height: 40px;\n                    width: 170px;\n                    border-radius: 20px;\n                    .ant-select-selection-item{\n                        padding-left: 12px;\n\n                        \n                    }\n                    \n                    \n                }\n\n                .ant-select-arrow{\n                    display: none !important;\n                    opacity: 0 !important;\n                }\n                \n            }\n        }\n        .download-btn{\n            button{\n                border: 1px solid $secondary;\n            }\n        }\n    }\n\n    .table{\n        padding-top: 40px;\n        position: relative;\n        .ant-table{\n            border-radius: 0px !important;\n        }\n        .ant-table-header{\n            border-radius: 0px;\n        }\n        .ant-table-thead{\n            border-radius: 0px !important;\n            tr{\n                th{\n                    border-radius: 0px !important;\n                    font-size: 12px;\n                    color: $third_gray;\n                    font-weight: 500;\n                    border-left: 0.5px solid #E8E8E8;\n                    border-right: 0.5px solid #E8E8E8;\n                    &:first-child{\n                        border-left: none !important;\n\n                    }\n                    &:last-child{\n                        border-right: none !important;\n                    }\n                    &::before{\n                        background: none !important;\n                    }\n                }\n                \n            }\n        }\n\n        .ant-table-row{\n            td{\n                border: 0.5px solid #E8E8E8 !important;\n                font-size: 14px;\n                font-weight: 500;\n                &:first-child{\n                    border-left: none !important;\n                }\n                &:last-child{\n                    border-right: none !important;\n                    padding: 0 !important;\n                    padding-right: 5px !important;\n                    padding-left: 5px !important;\n                    \n                }\n                &:nth-child(6){\n                    padding-left: 0;\n                    padding-bottom: 0;\n                    padding: 0;\n\n                }\n                .status{\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    border-radius: 30px;\n                    font-weight: 400;\n                    font-size: 10px;\n                    width: 100px;\n                    height: 24px;\n                    margin-right: auto;\n                    margin-left: auto;\n                }\n                .date{\n                    display: flex;\n                    align-items: center;\n                    gap: 5px;\n                    font-size: 13px;\n                    font-weight: 400;\n\n                    margin-right: auto;\n                    margin-left: auto;\n                    max-width: 100%;\n                    .icon{\n                        width: 16px !important;\n                        height: 16px !important;\n                    }\n                }\n                .updated-by{\n                    font-size: 13px;\n                }\n                \n                .comment{\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n                    padding-right: 10px;\n                    padding-left: 10px;\n                    position: relative;\n                    span{\n                        display: flex;\n                        align-items: center;\n                        cursor: pointer;\n                        padding: 0 !important; \n                        justify-content: space-between;\n                        gap: 2px;\n                        width: 100%;\n                        padding-bottom: 16px !important;\n                        padding-top: 16px !important;\n                        p{\n                            white-space: nowrap;\n                            max-width: 110px;\n                            overflow: hidden;\n                            text-overflow: ellipsis;\n                        }\n                        \n                    }\n                    \n                    \n                    .icon{\n                        min-width: 14px !important;\n                        min-height: 14px !important;\n                        max-width: 14px !important;\n                        max-height: 14px !important;\n                        color: rgba(203, 213, 224, 1) !important;\n                        position: relative;\n                    }\n                    button{\n                        background: none !important;\n                        color: $dark;\n                        border: none !important;\n                        box-shadow: none !important;\n                        outline: none !important;\n                        padding: 0;\n                        div{\n                            display: none;\n                        }\n                    }\n                    \n                }\n            }\n        }\n\n        .ant-pagination{\n            justify-content: start;\n            position: relative;\n            li{\n                &:last-child{\n                    position: absolute;\n                    right: 0;\n                }\n                \n            }\n            .ant-pagination-next, .ant-pagination-prev{\n                border: 1px solid $light_gray !important;\n            }\n        }\n\n        .item-amout{\n            position: absolute;\n            right: 120px;\n            bottom: 25px;\n            font-size: 12px;\n            font-weight: 500;\n            color: #687588;\n        }\n    }\n}\n.ant-popover{\n    max-width: 300px !important;\n}\n\n@media(max-width:1400px){\n    .projects_log{\n        .table{\n            th{\n                padding: 12px !important;\n            }\n            td{\n                padding: 8px !important;\n                &:nth-child(6){\n                    padding-left: 0;\n                    padding-bottom: 0;\n                    padding: 0;\n                }\n                .comment{\n                    padding-left: 8px !important;\n                    padding-right: 8px !important;\n                    p{\n                        width: 70px;\n                    }\n                }\n            }\n\n        }\n    }\n}",".ina_out {\n  border-radius: 16px;\n  padding: 30px 20px;\n  background-color: $light;\n  .page-title {\n    margin-bottom: 22px;\n    h1 {\n      font-size: 32px;\n      font-weight: 600;\n      margin-bottom: 12px;\n    }\n    p {\n      font-weight: 400;\n      font-size: 20px;\n      color: $secondary_gray;\n    }\n  }\n\n  .upper-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .left {\n      display: flex;\n      gap: 20px;\n      .search-btn {\n        width: 330px;\n        .ant-btn-default {\n          border: none;\n          border-top-right-radius: 20px !important;\n          border-bottom-right-radius: 20px !important;\n          height: 38px;\n          width: 47px;\n          position: absolute;\n          top: 1px;\n          right: 1px;\n          z-index: 2;\n          background-color: transparent;\n        }\n        input {\n          border-radius: 20px !important;\n          width: 330px;\n          height: 40px;\n          padding-left: 20px;\n          padding-right: 50px;\n          background-color: transparent;\n        }\n      }\n      .select {\n        width: 180px;\n        .ant-picker {\n          height: 100%;\n          width: 100%;\n          border-radius: 20px;\n        }\n      }\n    }\n    .download-btn {\n      button {\n        border: 1px solid $secondary;\n      }\n    }\n  }\n\n  .table {\n    padding-top: 40px;\n    position: relative;\n    .ant-table {\n      border-radius: 0px !important;\n    }\n    .ant-table-header {\n      border-radius: 0px;\n    }\n    .ant-table-thead {\n      border-radius: 0px !important;\n      tr {\n        th {\n          border-radius: 0px !important;\n          font-size: 12px;\n          color: $third_gray;\n          font-weight: 500;\n          border-left: 0.5px solid #e8e8e8;\n          border-right: 0.5px solid #e8e8e8;\n          &:first-child {\n            border-left: none !important;\n          }\n          &:last-child {\n            border-right: none !important;\n            p {\n              color: hsla(0, 89%, 59%, 0.86);\n            }\n          }\n          &:nth-child(7) {\n            border-right: none !important;\n            p {\n              color: hsla(0, 89%, 59%, 0.86);\n            }\n          }\n          &::before {\n            background: none !important;\n          }\n        }\n        .name_employee {\n          color: #828282;\n        }\n        .column_name {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 5px;\n          span {\n            color: #636363;\n          }\n          p {\n            font-size: 10px;\n          }\n          .off {\n            color: hsla(0, 89%, 59%, 0.86);\n          }\n        }\n      }\n    }\n\n    .ant-table-row {\n      td {\n        border: 0.5px solid #e8e8e8 !important;\n        font-size: 14px;\n        font-weight: 500;\n        padding: 12px;\n\n        .employee_name {\n          max-width: 180px;\n          width: 100%;\n          display: flex;\n          .name_wrapper {\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            width: 100%;\n          }\n        }\n\n        .status {\n          display: flex;\n          justify-content: space-between;\n          gap: 5px;\n          .time {\n            padding: 4px;\n            border-radius: 6px;\n            min-width: 48px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n\n          .red {\n            background-color: rgba(254, 67, 67, 0.597);\n          }\n          .gray {\n            background-color: #a4a4a4b3;\n          }\n          .green {\n            background-color: rgba(67, 254, 77, 0.597);\n          }\n        }\n      }\n    }\n\n    .ant-pagination {\n      justify-content: start;\n      position: relative;\n      li {\n        &:last-child {\n          position: absolute;\n          right: 0;\n        }\n      }\n      .ant-pagination-next,\n      .ant-pagination-prev {\n        border: 1px solid $light_gray !important;\n      }\n    }\n\n    .item-amout {\n      position: absolute;\n      right: 120px;\n      bottom: 25px;\n      font-size: 12px;\n      font-weight: 500;\n      color: #687588;\n    }\n  }\n}\n.ant-popover {\n  max-width: 300px !important;\n}\n\n.ant-picker-week-panel-row .ant-picker-cell-week {\n  color: red !important;\n  font-weight: bold !important;\n}\n@media (max-width: 1400px) {\n  .projects_log {\n    .table {\n      th {\n        padding: 12px !important;\n      }\n      td {\n        padding: 8px !important;\n        &:nth-child(6) {\n          padding-left: 0;\n          padding-bottom: 0;\n          padding: 0;\n        }\n        .comment {\n          padding-left: 8px !important;\n          padding-right: 8px !important;\n          p {\n            width: 70px;\n          }\n        }\n      }\n    }\n  }\n}\n",".employees {\n  .upper-section {\n    .download-btn {\n      display: flex;\n      gap: 30px;\n      button {\n        border-radius: 20px;\n      }\n      .ant-btn-primary {\n        background-color: $secondary;\n      }\n    }\n  }\n\n  .uppercase {\n    text-transform: uppercase;\n  }\n\n  .table {\n    .ant-table-thead {\n      tr {\n        th {\n          border-left: none !important;\n          border-right: none !important;\n\n          font-size: 14px;\n          color: #434343;\n\n          .salary-column-header {\n            display: flex;\n            justify-content: space-between;\n            .icon {\n              cursor: pointer;\n              transition: all 0.3s ease;\n            }\n          }\n        }\n      }\n    }\n    .ant-table-row {\n      &:hover {\n        .hide-salary {\n          &::after {\n            background-color: #fafafa !important;\n          }\n        }\n      }\n      td {\n        border-left: none !important;\n        border-right: none !important;\n\n        &:nth-child(2) {\n          font-size: 12px;\n          font-weight: 400;\n        }\n\n        &:nth-child(7) {\n          font-size: 12px;\n          font-weight: 400;\n        }\n        &:nth-child(8) {\n          font-size: 12px;\n          font-weight: 400;\n        }\n        &:nth-child(6) {\n          padding-left: 14px !important;\n        }\n        .employee-info {\n          display: flex;\n          background: none !important;\n          position: relative;\n          span {\n            display: flex;\n            align-items: center;\n            cursor: pointer;\n            padding: 0 !important;\n            width: 100%;\n          }\n          .employee {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            top: 0;\n            width: 100%;\n            .avatar {\n              display: flex;\n              img {\n                width: 30px;\n                height: 30px;\n                object-fit: cover;\n              }\n            }\n            .personal-info {\n              p {\n                color: #a0aec0;\n                font-size: 10px;\n                font-weight: 400;\n              }\n              h4 {\n                font-size: 12px;\n                font-weight: 400;\n              }\n            }\n          }\n\n          .icon {\n            color: #a0aec0 !important;\n          }\n        }\n\n        .job {\n          span {\n            font-size: 12px;\n            font-weight: 400;\n          }\n          p {\n            font-size: 10px;\n            font-weight: 400;\n            color: $gray-blue;\n          }\n        }\n\n        .file {\n          .icon {\n            color: $danger !important;\n            cursor: pointer;\n          }\n        }\n\n        .salary {\n          font-size: 12px;\n          font-weight: 400;\n          padding: 5px;\n          display: flex;\n          justify-content: center;\n          text-align: center;\n          position: relative;\n          transition: all 0.3s ease;\n        }\n\n        .hide-salary {\n          transition: all 0.3s ease;\n\n          &::after {\n            content: '*********';\n            position: absolute;\n            background-color: #fff;\n            width: 100%;\n            height: 100%;\n            top: 0;\n            left: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: all 0.3s ease;\n          }\n          &:hover {\n            &::after {\n              opacity: 0;\n            }\n          }\n        }\n\n        .edit {\n          display: flex;\n          align-items: center;\n          gap: 14px;\n          .icon {\n            width: 18px !important;\n            cursor: pointer;\n            &:first-child {\n              color: #624de3 !important;\n            }\n            &:last-child {\n              color: #a30d11 !important;\n            }\n          }\n        }\n      }\n    }\n\n    .total-salary {\n      font-weight: bold;\n      justify-content: end;\n      display: flex;\n      gap: 10px;\n      .amount-wrapper {\n        display: flex;\n        width: fit-content;\n        position: relative;\n        .total-salary-amount {\n          opacity: 0;\n          transition: all 0.3s ease;\n          font-weight: normal;\n          cursor: pointer;\n        }\n        .hide-total-salary {\n          position: absolute;\n          padding-top: 3px;\n          font-weight: normal;\n          transition: all 0.3s ease;\n          width: 100%;\n          cursor: pointer;\n          height: 100%;\n          background-color: #fafafa;\n          display: flex;\n          //   align-items: center;\n          justify-content: center;\n          left: 0;\n          top: 0;\n        }\n        &:hover {\n          opacity: 1;\n          .hide-total-salary {\n            opacity: 0;\n            pointer-events: none;\n          }\n          .total-salary-amount {\n            opacity: 1;\n          }\n        }\n      }\n    }\n  }\n}\n\n.pop-over {\n  display: flex;\n  flex-direction: column;\n  font-size: 10px;\n  font-weight: 400;\n  gap: 5px;\n  .email {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 4px;\n    color: $gray-blue;\n  }\n  .icon {\n    width: 12px !important;\n    height: 12px !important;\n    cursor: pointer;\n  }\n}\n\n.modal-backdrop2 {\n  width: 100%;\n  position: fixed;\n  height: 100%;\n  z-index: 10000;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #00000050;\n  .prewiev-modal2 {\n    width: 85%;\n\n    height: 85%;\n    overflow: hidden;\n    border-radius: 10px;\n    background: #fff;\n    .modal-header {\n      padding: 10px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      .modal-title {\n        width: 80%;\n      }\n      button {\n        width: 30px;\n        height: 30px;\n        background: transparent;\n        border: none;\n      }\n    }\n    .file-box {\n      width: 100%;\n      height: 100%;\n\n      .content-image {\n        background: #ccc;\n\n        width: 100%;\n        height: 100%;\n        object-fit: fill;\n      }\n    }\n  }\n}\n",".ant-modal-content {\n  //   width: 1287px !important;\n  // top: 0 !important;/\n  padding: 30px 50px 60px 50px !important;\n}\n\n.ant-modal {\n  //   width: 1287px !important;\n  height: 600px !important;\n  top: 0px !important;\n  // padding-bottom: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n// .expenses-modal {\n//   border: 1px solid red;\n//   .ant-modal {\n//     border: 1px solid blue !important;\n//   }\n// }\n\n.ant-modal-root {\n  //   width: 1287px !important;\n  // margin-top: 0 !important;\n}\n.ant-modal-wrap {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  // margin-top: 0 !important;/\n}\n\n.download-selected_file {\n  font-size: 20px;\n  transform: translateX(50px);\n  color: #222;\n}\n\n.cencel-file-popup {\n  cursor: pointer;\n}\n\n.form-wrapper {\n  .title {\n    h1 {\n      font-size: 24px;\n      font-weight: 500;\n      margin-bottom: 5px;\n      color: #131111;\n    }\n    p {\n      font-weight: 400;\n      font-size: 14px;\n      color: #848282;\n    }\n  }\n\n  .avatar {\n    height: 120px;\n    width: 120px;\n    position: relative;\n    margin-top: 25px;\n    .icon-wrapper {\n      position: absolute;\n      cursor: pointer;\n      height: 30px;\n      width: 30px;\n      top: 3px;\n      right: 3px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      background-color: $secondary;\n      .icon {\n        width: 14px !important;\n        height: 14px !important;\n        color: $light !important;\n      }\n    }\n    .avatar-photo {\n      border-radius: 50%;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #f2f2f2;\n      .icon {\n        width: 57px !important;\n        height: 57pc !important;\n      }\n    }\n  }\n  .ant-select {\n    // border-color: #d9d9d9 !important;\n  }\n\n  .input-wrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    column-gap: 40px;\n    row-gap: 33px;\n    padding-top: 27px;\n    padding-bottom: 30px;\n    .ant-input-status-error {\n      // border-color: #d9d9d9 !important;\n    }\n\n    .single-input-item {\n      position: relative;\n      label {\n        font-size: 16px;\n        font-weight: 500;\n        color: #131111;\n      }\n      input {\n        height: 44px;\n      }\n\n      .ant-select {\n        height: 44px !important;\n        position: relative;\n        span {\n        }\n      }\n      .ant-picker {\n        height: 44px !important;\n      }\n      .ant-form-item {\n        margin-bottom: 0;\n      }\n\n      .ant-form-item-has-error {\n        .PhoneInput {\n          input {\n            border-color: #ff4d4f;\n          }\n        }\n      }\n\n      .PhoneInput {\n        // border: 1px solid red;\n        border: none !important;\n        input {\n          border-radius: 6px;\n          outline: none;\n          border: 1px solid #d9d9d9;\n          padding: 4px 11px;\n          font-size: 14px;\n          transition: all 0.3s ease;\n          &::placeholder {\n            color: #bfbfbf;\n          }\n          &:focus {\n            border-color: #1677ff;\n            box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);\n          }\n        }\n        .PhoneInputCountry {\n          display: none;\n        }\n        .PhoneInput--focus {\n          border: 1px solid none !important;\n        }\n      }\n    }\n\n    .salary {\n      gap: 10px;\n      display: flex;\n      justify-content: center;\n      align-items: end;\n\n      .ant-form-item-control-input-content {\n        display: flex !important;\n        gap: 10px;\n        align-items: center;\n      }\n      .ant-form-item-control-input-content {\n      }\n    }\n\n    .dual {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      align-items: start;\n      .ant-select {\n        width: 180px;\n      }\n    }\n\n    .calendar {\n      position: relative;\n      .ant-picker {\n        display: flex;\n        padding-right: 40px;\n        span {\n          display: none;\n        }\n        input {\n          border: none;\n        }\n      }\n\n      .icon {\n        position: absolute;\n        top: 40px !important;\n        z-index: 10;\n        right: 10px;\n        top: 10px !important;\n        pointer-events: none;\n      }\n    }\n  }\n\n  .expenses-input-wrapper {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  .salary {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.small-modal {\n  .min-title {\n    padding: 20px;\n    h1 {\n      font-size: 24px;\n      font-weight: 600;\n      color: #131111;\n    }\n  }\n\n  ul {\n    padding-left: 20px;\n    padding-right: 20px;\n    list-style: none;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 20px;\n    li {\n      border-radius: 5px;\n      height: 170px;\n      background-color: #fdfdfd;\n      border: 1px solid #f7f7f7;\n      .item-wrapper {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        .file-img {\n          margin-top: 20px;\n          .icon {\n            max-width: 85px !important;\n            max-height: 113px !important;\n            width: 85px !important;\n            height: 113px !important;\n            color: #eb1f1f !important;\n          }\n        }\n        .file-name {\n          display: flex;\n          height: 30px;\n          align-items: center;\n          padding-bottom: 5px;\n          padding-right: 7px;\n          padding-left: 7px;\n          input {\n            height: 20px;\n            border: none !important;\n            outline: none;\n            padding-right: 0;\n            font-size: 12px;\n          }\n\n          span {\n            font-size: 12px;\n            text-align: center;\n            max-width: 120px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n          .ant-input-outlined {\n            border: none;\n            box-shadow: none;\n            border-radius: 0px;\n            padding-right: 2px;\n          }\n\n          .icon {\n            color: #36b151 !important;\n            cursor: pointer;\n          }\n        }\n        .delete {\n          position: absolute;\n          top: 10px;\n          right: 10px;\n          cursor: pointer;\n          .icon {\n            width: 14px !important;\n            height: 14px !important;\n          }\n        }\n      }\n    }\n    .upload {\n      max-width: 143px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      label {\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n        align-items: center;\n        input {\n          display: none;\n        }\n        .plus {\n          border: 3px solid #eb1f1f;\n          cursor: pointer;\n          width: 60px;\n          height: 60px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border-radius: 10px;\n          span {\n            font-size: 10px;\n            font-weight: 500;\n            color: #131111;\n          }\n          .icon {\n            transform: rotateZ(45deg);\n            width: 30px !important;\n            height: 30px !important;\n            color: #eb1f1f !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n.password {\n  height: 44px !important;\n  .ant-input-affix-wrapper {\n    height: 44px !important;\n    width: 100%;\n    // border: 1px solid $secondary;\n    font-size: 18px;\n    display: flex;\n    .ant-input {\n      max-height: 34px !important;\n      display: flex;\n    }\n    input {\n      height: 44px !important;\n      padding-top: 0 !important;\n      padding-left: 0;\n      font-size: 14px;\n      &::placeholder {\n        font-size: 14px;\n      }\n    }\n  }\n}\n",".min-modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .ant-modal-content {\n    width: 773px !important;\n    top: 0 !important;\n    padding: 0px !important;\n    border-radius: 20px !important;\n  }\n\n  .ant-modal {\n    width: 773px !important;\n    top: 0px !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n\n  .ant-modal-root {\n    width: 773px !important;\n    // margin-top: 0 !important;\n  }\n  .ant-modal-wrap {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    // margin-top: 0 !important;/\n  }\n\n  .ant-modal-footer {\n    padding-bottom: 30px !important;\n    padding-right: 30px !important;\n\n    button {\n      border-radius: 12px;\n      &:last-child {\n        background-color: $secondary;\n        color: $light;\n      }\n    }\n  }\n\n  .form-wrapper {\n    .title {\n      padding: 30px 30px 20px 30px;\n      border-bottom: 1px solid #c2c0c0;\n      justify-content: space-between;\n      h1 {\n        font-size: 24px;\n        font-weight: 500;\n        color: #131111;\n        margin-bottom: 5px;\n      }\n      p {\n        font-size: 14px;\n        font-weight: 400;\n        color: #848282;\n      }\n    }\n\n    .upper {\n      display: grid;\n      grid-template-columns: 1fr 1fr 1fr;\n      gap: 20px;\n      padding: 30px;\n      .single-item {\n        input {\n          width: 100%;\n          height: 46px !important;\n          border-radius: 10px;\n          font-size: 16px;\n          &::placeholder {\n            font-size: 16px;\n          }\n        }\n        .ant-select {\n          width: 100% !important;\n          height: 46px !important;\n          border-radius: 10px !important;\n\n          .ant-select-selection-item {\n            margin-bottom: 0 !important;\n          }\n          .ant-select-selector {\n            border-radius: 10px !important;\n            display: flex;\n            align-items: center;\n          }\n          .ant-select-selection-placeholder {\n            margin-bottom: 0 !important;\n            padding-bottom: 0 !important;\n            color: #c2c0c0;\n          }\n          .ant-select-suffix {\n            margin-bottom: 0 !important;\n          }\n        }\n\n        .ant-picker {\n          height: 46px !important;\n          border-radius: 10px;\n          display: flex;\n          padding-left: 40px;\n\n          span {\n            display: none;\n          }\n          input {\n            border: none;\n          }\n        }\n      }\n      .calendar {\n        position: relative;\n        .icon {\n          position: absolute;\n          top: 40px !important;\n          z-index: 100;\n          left: 10px;\n        }\n      }\n    }\n\n    .full-width {\n      grid-template-columns: 1fr;\n      .upper {\n        .single-item {\n          .ant-select {\n            width: 100% !important;\n            height: 30px !important;\n            border-radius: 10px !important;\n            border: 1px solid red;\n            .ant-select-selection-item {\n              margin-bottom: 0 !important;\n            }\n            .ant-select-selector {\n              border-radius: 10px !important;\n              display: flex;\n              align-items: center;\n            }\n            .ant-select-selection-placeholder {\n              margin-bottom: 0 !important;\n              padding-bottom: 0 !important;\n              color: #c2c0c0;\n            }\n            .ant-select-suffix {\n              margin-bottom: 0 !important;\n            }\n          }\n\n          .ant-select-selector {\n            border: 1px solid red;\n          }\n        }\n      }\n    }\n\n    .ant-select-selection-item {\n    }\n\n    .ant-select-selection-overflow {\n      height: 40px;\n      padding-left: 5px;\n    }\n\n    .columns-2 {\n      grid-template-columns: 1fr 1fr 1fr;\n    }\n    .textarea {\n      padding-left: 30px;\n      padding-right: 30px;\n      textarea {\n        border-radius: 10px;\n        max-height: 223px;\n        height: 300px;\n        padding: 10px;\n        padding-left: 15px;\n        min-height: 100px;\n        &::placeholder {\n          font-size: 16px;\n        }\n      }\n    }\n  }\n}\n",".small-modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .ant-modal-content {\n    width: 500px !important;\n    top: 0 !important;\n    padding: 0px !important;\n    border-radius: 20px !important;\n  }\n\n  .ant-modal {\n    width: 500px !important;\n    top: 0px !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n\n  .ant-modal-root {\n    width: 500px !important;\n    // margin-top: 0 !important;\n  }\n  .ant-modal-wrap {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    // margin-top: 0 !important;/\n  }\n\n  .ant-modal-footer {\n    padding-bottom: 30px !important;\n    padding-right: 30px !important;\n\n    button {\n      border-radius: 12px;\n      &:last-child {\n        background-color: $secondary;\n        color: $light;\n      }\n    }\n  }\n\n  .form-wrapper {\n    .title {\n      padding: 30px 30px 20px 30px;\n      border-bottom: 1px solid #c2c0c0;\n      justify-content: space-between;\n      h1 {\n        font-size: 24px;\n        font-weight: 500;\n        color: #131111;\n        margin-bottom: 5px;\n      }\n    }\n\n    .single-item {\n      padding-left: 30px;\n      margin-top: 30px;\n      max-width: 240px;\n      p {\n        margin-bottom: 10px;\n        font-size: 16px;\n        font-weight: 400;\n        color: #131111;\n      }\n      input {\n        width: 100%;\n        height: 46px !important;\n        border-radius: 10px;\n        font-size: 16px;\n        &::placeholder {\n          font-size: 16px;\n        }\n      }\n\n      .ant-switch-checked {\n        background: #34c759;\n      }\n      .ant-switch-checked:hover {\n        background: #34c759 !important;\n      }\n    }\n    .integration {\n      display: flex !important;\n      max-width: 100%;\n      padding-right: 30px;\n      align-items: center;\n      gap: 10px;\n      .percentage-icon {\n        border: 1px solid #d9d9d9;\n        height: 46px;\n        width: 46px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 10px;\n        font-size: 20px;\n        transform: translateY(3px);\n      }\n    }\n  }\n}\n\n.company-wage {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  .percentage-icon {\n    border: 1px solid #d9d9d9;\n    height: 46px;\n    min-width: 46px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n    font-size: 20px;\n    transform: translateY(3px);\n  }\n}\n",".settings-table {\n  background-color: $light;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid transparent;\n  .ant-table-thead {\n    border-radius: 0px !important;\n    tr {\n      th {\n        &:last-child {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n        .percentage {\n          width: 100%;\n          display: flex;\n          justify-content: center;\n        }\n        // &:nth-child(2) {\n        //   display: flex;\n        //   align-items: center;\n        //   justify-content: center;\n        // }\n        &:first-child {\n          padding-left: 20px !important;\n        }\n      }\n    }\n  }\n\n  .status {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    span {\n      display: flex;\n      align-items: center;\n      gap: 30px;\n    }\n  }\n\n  .switch {\n    display: flex;\n    justify-content: center;\n  }\n  .ant-switch-checked {\n    background: #34c759;\n  }\n  .ant-switch-checked:hover {\n    background: #34c759 !important;\n  }\n  .ant-table-row {\n    td {\n      &:last-child {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      .percentage {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n      }\n      //   &:nth-child(2) {\n      //     display: flex;\n      //     align-items: center;\n      //     justify-content: center;\n      //   }\n      &:first-child {\n        padding-left: 20px !important;\n      }\n    }\n  }\n\n  .edit {\n    .icon {\n      color: #624de3 !important;\n      cursor: pointer;\n    }\n  }\n\n  .wage-edit {\n  }\n\n  .bottom-side {\n    display: flex;\n    justify-content: end;\n    margin-top: 22px;\n    margin-bottom: 23px;\n    padding-right: 22px;\n    button {\n      border-radius: 20px;\n      display: flex;\n      flex-direction: row-reverse;\n      align-items: center;\n      background-color: $secondary;\n      span {\n        margin-right: 0 !important;\n        margin-left: 5px;\n      }\n    }\n  }\n}\n\n.filter-checkbox {\n  display: flex !important;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  margin: 5px;\n  input {\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n  }\n\n  .checkmark {\n    position: relative;\n\n    top: 0;\n    left: 0;\n    height: 24px;\n    min-width: 24px;\n    display: inline-block;\n    margin-right: 10px;\n    border: 1px solid #777777;\n    border-radius: 5px;\n    transition: all 0.3s ease;\n    background-position: center;\n    cursor: pointer;\n    &:hover {\n      background-color: #fbfafa;\n    }\n    &:after {\n      content: \"\";\n      position: absolute;\n      display: none;\n    }\n  }\n\n  input:checked + .checkmark {\n    background-color: #d0f9d4;\n    border: 1px solid #36b151;\n    background-image: url(../../../../Assets/icons/checked.svg);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 16px;\n  }\n}\n",".sales {\n  border-radius: 16px;\n  background-color: $light;\n  min-height: 100%;\n\n  .page-title {\n    display: flex;\n    padding: 30px;\n    align-items: center;\n    justify-content: space-between;\n    .title-wrapper {\n      h1 {\n        font-size: 32px;\n        font-weight: 500;\n        margin-bottom: 11px;\n      }\n      p {\n        font-size: 20px;\n        font-weight: 400;\n        color: #7a7a7a;\n      }\n    }\n    .calculation-btns {\n      display: flex;\n      gap: 40px;\n      align-items: center;\n    }\n    .calculate-btn {\n      display: flex;\n      height: 40px;\n      align-items: center;\n      padding-right: 30px;\n      padding-left: 33px;\n      border-radius: 20px;\n      flex-direction: row-reverse;\n      gap: 10px;\n      background-color: $secondary;\n      .ant-btn-icon {\n        margin-right: 0;\n      }\n    }\n\n    .clear-btn {\n      background-color: transparent;\n      border: 1px solid $secondary;\n      color: $secondary;\n      &:hover {\n        background-color: transparent;\n        color: $secondary;\n      }\n    }\n  }\n\n  .form-wrapper {\n    .client-info {\n      display: flex;\n      border-bottom: 1px solid #e8e8e8;\n      gap: 60px;\n      padding: 0 30px 20px 30px;\n      .single-input-item {\n        max-width: 282px;\n        width: 100%;\n        label {\n          font-size: 16px;\n          font-weight: 500;\n          color: #131111;\n        }\n        input {\n          height: 44px;\n        }\n\n        .ant-select {\n          height: 44px !important;\n          position: relative;\n        }\n      }\n    }\n    .project-info {\n      display: flex;\n      gap: 60px;\n      padding: 30px 30px 30px 30px;\n      .single-input-item {\n        max-width: 282px;\n        width: 100%;\n        label {\n          font-size: 16px;\n          font-weight: 500;\n          color: #131111;\n        }\n        input {\n          height: 44px;\n        }\n      }\n      .multiple {\n        .ant-select {\n          min-height: 44px;\n          position: relative;\n          .ant-select-selection-overflow-item {\n            width: 100%;\n          }\n          .ant-select-selection-item {\n            min-height: 40px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            background-color: #e3e9f9;\n            width: 100%;\n            .ant-select-selection-item-content {\n              font-size: 14px;\n              font-weight: 400;\n            }\n          }\n        }\n      }\n      .ant-space-compact {\n        height: 48px;\n      }\n      .twin-input {\n        // width: 100% !important;\n        max-width: 408px !important;\n        width: 100% !important;\n        .ant-select {\n          width: 100%;\n          height: 48px;\n          width: 270px;\n        }\n        input {\n          height: 48px;\n          width: 80px !important;\n        }\n        button {\n          height: 48px;\n          background-color: $secondary;\n          &:disabled {\n            color: rgba(255, 255, 255, 0.5);\n            background-color: $primary;\n          }\n        }\n      }\n      .team-list {\n        padding-top: 10px;\n        // max-width: 300px;\n        width: 100%;\n        padding-top: 20px;\n        ul {\n          list-style: none;\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          li {\n            border: 1px solid #dcdce4;\n            border-radius: 10px;\n            .item {\n              display: flex;\n              padding: 4px;\n              gap: 8px;\n              padding-right: 14px;\n              .fullname {\n                padding: 4px 16px;\n                background-color: #e3e9f9;\n                width: 100%;\n                border-radius: 6px;\n                h4 {\n                  font-size: 12px;\n                  font-weight: 400;\n                }\n                span {\n                  font-size: 10px;\n                  font-weight: 400;\n                  color: #8e8ea9;\n                }\n              }\n              .duration {\n                display: flex;\n                align-items: center;\n                padding-right: 12px;\n                background-color: #e3e9f9;\n                border-radius: 6px;\n                margin-right: 4px;\n                font-size: 12px;\n                input {\n                  border: none;\n                  font-size: 12px;\n                  width: 45px !important;\n                  background-color: transparent;\n                  &:focus {\n                    box-shadow: none;\n                  }\n                }\n              }\n              .anticon {\n                cursor: pointer;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.small-modal {\n  .ant-modal-content {\n    position: relative;\n    overflow: hidden;\n    .min-title {\n      padding-top: 15px;\n      padding-bottom: 8px;\n      display: flex;\n      align-items: center;\n    }\n    .confirm-content {\n      padding: 20px 30px 0 30px;\n    }\n    .modal-loader {\n      width: 100%;\n      background-color: rgba(255, 255, 255, 1);\n      height: 100%;\n      position: absolute;\n      opacity: 1;\n      z-index: 9999;\n      top: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transform: all 0.3s ease;\n\n      .loader-wrapper {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 60px;\n        span {\n          font-size: 32px;\n          font-weight: 400;\n          color: rgba(122, 122, 122, 1);\n        }\n      }\n\n      .lds-roller,\n      .lds-roller div,\n      .lds-roller div:after {\n        box-sizing: border-box;\n      }\n      .lds-roller {\n        display: inline-block;\n        position: relative;\n        transform: scale(1.5);\n        width: 80px;\n        height: 80px;\n      }\n      .lds-roller div {\n        animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n        transform-origin: 40px 40px;\n      }\n      .lds-roller div:after {\n        content: \" \";\n        display: block;\n        position: absolute;\n        width: 7.2px;\n        height: 7.2px;\n        border-radius: 50%;\n        background: $secondary;\n        margin: -3.6px 0 0 -3.6px;\n      }\n      .lds-roller div:nth-child(1) {\n        animation-delay: -0.036s;\n      }\n      .lds-roller div:nth-child(1):after {\n        top: 62.62742px;\n        left: 62.62742px;\n      }\n      .lds-roller div:nth-child(2) {\n        animation-delay: -0.072s;\n      }\n      .lds-roller div:nth-child(2):after {\n        top: 67.71281px;\n        left: 56px;\n      }\n      .lds-roller div:nth-child(3) {\n        animation-delay: -0.108s;\n      }\n      .lds-roller div:nth-child(3):after {\n        top: 70.90963px;\n        left: 48.28221px;\n      }\n      .lds-roller div:nth-child(4) {\n        animation-delay: -0.144s;\n      }\n      .lds-roller div:nth-child(4):after {\n        top: 72px;\n        left: 40px;\n      }\n      .lds-roller div:nth-child(5) {\n        animation-delay: -0.18s;\n      }\n      .lds-roller div:nth-child(5):after {\n        top: 70.90963px;\n        left: 31.71779px;\n      }\n      .lds-roller div:nth-child(6) {\n        animation-delay: -0.216s;\n      }\n      .lds-roller div:nth-child(6):after {\n        top: 67.71281px;\n        left: 24px;\n      }\n      .lds-roller div:nth-child(7) {\n        animation-delay: -0.252s;\n      }\n      .lds-roller div:nth-child(7):after {\n        top: 62.62742px;\n        left: 17.37258px;\n      }\n      .lds-roller div:nth-child(8) {\n        animation-delay: -0.288s;\n      }\n      .lds-roller div:nth-child(8):after {\n        top: 56px;\n        left: 12.28719px;\n      }\n      @keyframes lds-roller {\n        0% {\n          transform: rotate(0deg);\n        }\n        100% {\n          transform: rotate(360deg);\n        }\n      }\n    }\n\n    .hide-modal-loader {\n      opacity: 0;\n      pointer-events: none;\n    }\n  }\n  .result {\n    // background-color: rgba(243, 243, 243, 1);\n    transition: all 0.3s ease;\n    padding: 20px 30px;\n\n    .result-wrapper {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 20px;\n      .item {\n        border: 1px solid rgba(243, 243, 243, 1);\n        min-width: 185px;\n        padding: 0px 20px;\n        height: 100px;\n        background-color: rgba(240, 240, 240, 0.589);\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        border-radius: 20px;\n\n        gap: 12px;\n        span {\n          display: flex;\n          font-size: 14px;\n          font-weight: 600;\n          color: #8c87a8;\n        }\n        h3 {\n          display: flex;\n          font-size: 20px;\n          font-weight: 600;\n          color: #624de3;\n        }\n      }\n    }\n    .totel {\n      padding: 20px;\n      border-radius: 20px;\n      background-color: rgba(240, 240, 240, 0.589);\n      p {\n        font-size: 18px;\n        font-weight: 500;\n        color: rgba(19, 17, 17, 1);\n      }\n    }\n  }\n}\n",".finance-dashboard {\n  .chart-wrapper {\n    width: 100%;\n    overflow: hidden;\n  }\n  .page-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .ant-select {\n      width: 170px;\n      border-radius: 20px !important;\n      height: 40px;\n      .ant-select-selector {\n        border-radius: 20px;\n        border: 1px solid $secondary;\n      }\n    }\n  }\n}\n\n.twin_inputs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  .currency_input {\n    .ant-select {\n      width: 100% !important;\n    }\n  }\n}\n.balance_wrapper {\n  margin-top: 20px;\n\n  span {\n    color: #1953e9;\n  }\n}\n\n.down_icon_wrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 10px;\n  padding-bottom: 20px;\n  .down_icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: $secondary;\n    color: $light;\n  }\n}\n\n.balance-chart-box {\n  .page-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .action_side {\n      display: flex;\n      gap: 24px;\n      .ant-btn {\n        display: flex;\n        border-radius: 20px;\n        background-color: transparent;\n        color: $dark;\n        border: 1px solid $secondary;\n      }\n\n      .ant-picker {\n        color: $dark;\n        border-radius: 20px;\n        border: 1px solid $secondary;\n        color: $dark;\n        .ant-picker-input {\n          input {\n            &::placeholder {\n              color: $dark;\n            }\n          }\n        }\n        .ant-picker-suffix {\n          color: $dark !important;\n        }\n      }\n    }\n  }\n  .chart-wrapper {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); /* Creates 3 equal columns */\n    gap: 50px;\n    .chart-area {\n      display: flex;\n      align-items: center;\n\n      .apexcharts-legend-text {\n        text-transform: capitalize;\n        transition: color 0.3s ease;\n      }\n\n      .label-lists {\n        list-style-type: none;\n        text-transform: capitalize;\n      }\n    }\n  }\n}\n",".expenses {\n  .page-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.designed-sum {\n  padding: 21px;\n  border-radius: 8px;\n  background-color: #739bff;\n  font-size: 14px;\n  font-weight: 400;\n  color: $light;\n}\n.expense-type-raw {\n  font-weight: 600 !important;\n}\n.method-raw {\n  text-transform: uppercase;\n}\n\n.expense-comment {\n  height: 40px;\n}\n\n.date-filter {\n  border: 1px solid $secondary;\n  border-radius: 20px;\n  .ant-picker-input {\n    width: 90px;\n  }\n  .ant-picker-suffix {\n    color: $dark !important;\n  }\n}\n\n.single-input-item-payment {\n  display: flex;\n}\n\n.payment-wrapper {\n  .currency {\n    .ant-select {\n      height: 44px;\n    }\n    label {\n      opacity: 0; /* Set the desired opacity value */\n      pointer-events: none;\n\n      .ant-form-item-required::before {\n        content: \"ppp\";\n        color: #fff !important;\n      }\n    }\n  }\n}\n\n.message-text-wrapper {\n  border: 1px solid #a1a3ab;\n  border-radius: 6px;\n  padding: 14px;\n}\n\n.total-salary{\n  .amount-wrapper{\n    padding: 10px;\n    border-radius: 8px;\n    background-color: #739BFF;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    span{\n      display: flex;\n    }\n  }\n}",".canban {\n  padding: 0 30px 30px 30px;\n  height: calc(100% - 160px);\n}\n\n.sales-performance-box {\n  box-shadow: 0px 2px 6px 0px #0d0a2c14;\n  margin: 30px;\n  margin-bottom: 40px;\n  border-radius: 20px;\n  padding: 30px;\n  .title-wrapper {\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 30px;\n  }\n}\n\n.canban_list_wrapper {\n  height: 100%;\n  .canban_list {\n    list-style: none;\n    display: flex;\n    gap: 20px;\n    height: 100%;\n    width: 100%;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n    overflow: auto;\n    .canban_list_item {\n      transition: all 0.3s ease;\n      background-color: #fff;\n      min-height: 500px;\n      height: 100%;\n      transition: all 0.3s ease;\n      position: relative;\n      overflow-y: auto;\n      min-width: 240px;\n      &::-webkit-scrollbar {\n        display: none;\n      }\n      .column_info {\n        margin-bottom: 10px;\n        background-color: #fff;\n        z-index: 999;\n        position: sticky;\n        top: 0;\n        .column_name {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          padding-bottom: 10px;\n          border-bottom: 1px solid #a4a4a4;\n          margin-bottom: 10px;\n          h3 {\n            font-weight: 600;\n            font-size: 14px;\n          }\n          span {\n            font-size: 12px;\n            font-weight: 400;\n            color: #595959;\n            padding: 5px 20px;\n            border-radius: 10px;\n            border: 1px solid #d9d9d9;\n          }\n        }\n        .add_card_btn {\n          border: 1px solid #a4a4a4;\n          border-radius: 5px;\n          font-size: 14px;\n          font-weight: 500;\n          color: #a4a4a4;\n          padding: 7px 70px;\n          outline: none;\n          cursor: pointer;\n          background-color: transparent;\n          width: 100%;\n        }\n      }\n\n      .canban_column {\n        list-style: none;\n        height: fit-content;\n        min-height: calc(100% - 94px);\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        .canban_column_item {\n          padding: 10px 8px;\n          box-shadow: 0px 3px 9px 0px #ff5c0024;\n\n          width: 239px;\n          height: 138px;\n          border: 1px solid #ff5c00;\n          border-radius: 5px;\n          &:hover {\n            cursor: grab;\n          }\n\n          .action {\n            display: flex;\n            gap: 10px;\n            justify-content: end;\n            margin-bottom: 10px;\n\n            .trash {\n              color: #a30d11 !important;\n              width: 14px !important;\n              height: 14px !important;\n              cursor: pointer;\n            }\n            .edit {\n              color: #624de3 !important;\n              width: 14px !important;\n              height: 14px !important;\n              cursor: pointer;\n            }\n          }\n          .info_raw {\n            display: flex;\n            margin-bottom: 8px;\n            gap: 8px;\n            strong {\n              cursor: pointer !important;\n            }\n            span {\n              font-weight: 400;\n              font-size: 12px;\n              color: #888888;\n              width: 79px;\n            }\n            p {\n              font-size: 12px;\n              font-weight: 400;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              width: 130px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.dragging-overlay {\n  padding: 10px 8px;\n  box-shadow: 0px 3px 9px 0px #ff5c0024;\n  background-color: #fff;\n  transition: all 0.3s ease;\n  list-style: none;\n  width: 239px;\n  height: 138px;\n  border: 1px solid #000000;\n  border-radius: 5px;\n  &:hover {\n    cursor: grabbing;\n  }\n  .action {\n    display: flex;\n    gap: 10px;\n    justify-content: end;\n    margin-bottom: 10px;\n\n    .trash {\n      color: #a30d11 !important;\n      width: 14px !important;\n      height: 14px !important;\n      cursor: pointer;\n    }\n    .edit {\n      color: #624de3 !important;\n      width: 14px !important;\n      height: 14px !important;\n      cursor: pointer;\n    }\n  }\n\n  .info_raw {\n    display: flex;\n    margin-bottom: 8px;\n    gap: 8px;\n\n    span {\n      font-weight: 400;\n      font-size: 12px;\n      color: #888888;\n      width: 70px;\n    }\n    p {\n      font-size: 12px;\n      font-weight: 400;\n    }\n  }\n}\n\n.empty-column-placeholder {\n  text-align: center;\n  padding-top: 30px;\n}\n\n////////////////////////////\n\n.kanban-board {\n  display: flex;\n  justify-content: space-around;\n  padding: 20px;\n  height: 100vh;\n}\n\n.column {\n  background-color: #e2e4e6;\n  border-radius: 8px;\n  width: 30%;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.column-title {\n  font-size: 18px;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.task-list {\n  background-color: #f4f5f7;\n  border-radius: 4px;\n  flex-grow: 1;\n  min-height: 100px;\n  padding: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.task {\n  background-color: #ffffff;\n  border-radius: 2px;\n  padding: 8px;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);\n  transition: background-color 0.2s ease;\n}\n\n.canban_mobile {\n  display: none;\n}\n\n.select_status {\n  margin-top: 20px;\n  h3 {\n    margin-bottom: 10px;\n    font-size: 16px;\n    font-weight: 500;\n  }\n  ul {\n    list-style: none;\n    display: flex;\n    gap: 40px;\n    li {\n      padding: 4px 10px;\n      border-radius: 4px;\n      font-weight: 600;\n      font-size: 12px;\n      cursor: pointer;\n    }\n  }\n}\n\n.textarea_input {\n  width: 100%;\n  .ant-form-item-required {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    color: #131111;\n  }\n  .single-input-item {\n    .ant-input {\n      height: 100px;\n    }\n  }\n}\n\n.card_item {\n  padding: 28px;\n  .column_name {\n    padding: 4px 10px;\n    width: fit-content;\n    border-radius: 4px;\n    font-size: 12px;\n    margin-bottom: 6px;\n  }\n  h2 {\n    font-size: 32px;\n    font-weight: 500;\n  }\n  .date {\n    font-size: 14px;\n    font-weight: 400;\n    color: #404040;\n    margin-bottom: 20px;\n  }\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    display: flex;\n    margin-bottom: 10px;\n    p {\n      color: #888888;\n      font-size: 12px;\n      font-weight: 400;\n      width: 100px;\n    }\n  }\n  h4 {\n    margin-top: 20px;\n  }\n  .description {\n    border: 1px solid #a1a3ab;\n    border-radius: 6px;\n    padding: 14px;\n    font-size: 14px;\n    font-weight: 400;\n    margin-top: 10px;\n  }\n  .agent {\n    width: 100%;\n    padding-top: 14px;\n    border-top: 1px solid #dee2e6;\n    margin-top: 20px;\n  }\n}\n\n@media (max-width: 700px) {\n  .canban {\n    padding: 0 30px 30px 30px;\n    height: calc(100% - 160px);\n  }\n\n  .ant-modal-confirm {\n    .ant-modal-content {\n      width: 310px !important;\n    }\n  }\n\n  .expenses-modal {\n    display: flex;\n    justify-content: center;\n    max-width: 322px !important;\n    .ant-modal-content {\n      padding: 15px !important;\n    }\n    .form-wrapper {\n      overflow: auto;\n      max-width: 322px;\n      max-height: calc(100dvh - 150px);\n\n      ul {\n        overflow: auto;\n        &::-webkit-scrollbar {\n          display: none;\n        }\n      }\n      .expenses-input-wrapper {\n        display: grid;\n        grid-template-columns: 1fr;\n        .salary {\n          .salary-inner {\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  .sales {\n    .page-title {\n      padding: 10px;\n      .title-wrapper {\n        h1 {\n          font-size: 18px;\n        }\n        p {\n          font-size: 14px;\n        }\n      }\n    }\n    .canban_desktop {\n      display: none;\n    }\n  }\n\n  .ant-select-item-option-content {\n    span {\n      color: #000 !important;\n    }\n  }\n  .mobile_modal {\n    .ant-modal-content {\n      width: 322px !important;\n    }\n  }\n\n  .canban_mobile {\n    display: block;\n    width: 100%;\n    padding-bottom: 50px;\n\n    .select_status {\n      .ant-select-selector {\n        border-radius: 10px;\n        border: none !important;\n      }\n      .ant-select {\n        width: 100%;\n        border-radius: 10px;\n        height: 46px;\n        // border-color: #acacac !important;\n        border: 1px solid #acacac;\n      }\n    }\n\n    .add_card_btn {\n      padding-top: 16px;\n      .add_btn_wrapper {\n        border: 1px solid #a4a4a4;\n        border-radius: 5px;\n        font-size: 14px;\n        font-weight: 500;\n        color: #a4a4a4;\n        padding: 7px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 5px;\n      }\n    }\n    .canban_items {\n      ul {\n        list-style: none;\n        padding-top: 16px;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n        li {\n          .item_wrapper {\n            border-radius: 5px;\n            padding: 10px;\n            position: relative;\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            box-shadow: 0px 3px 9px 0px #ff5c0024;\n\n            .action {\n              position: absolute;\n              right: 10px;\n              top: 10px;\n              display: flex;\n              gap: 5px;\n              .edit {\n                color: #624de3 !important;\n              }\n              .trash {\n                color: #a30d11 !important;\n              }\n            }\n\n            .info_raw {\n              display: flex;\n\n              span {\n                font-size: 12px;\n                color: #888888;\n                font-weight: 400;\n                min-width: 80px;\n              }\n              p {\n                font-size: 12px;\n                font-weight: 400;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .content {\n    padding: 10px;\n    background-color: #fff;\n  }\n\n  .sales-performance-box {\n    box-shadow: none;\n    margin: 0px;\n    margin-bottom: 40px;\n    border-radius: 20px;\n    padding: 10px;\n    .title-wrapper {\n      display: flex;\n      justify-content: space-between;\n      padding-bottom: 30px;\n      flex-direction: column;\n      gap: 16px;\n      * {\n        display: none;\n      }\n      h2 {\n        display: flex;\n        font-size: 14px;\n      }\n    }\n  }\n}\n",".task_playground {\n  border-radius: 16px;\n  padding: 30px 20px;\n  background-color: $light;\n  min-height: calc(100dvh - 120px);\n  .page-heading {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .page-title {\n      margin-bottom: 22px;\n      h1 {\n        font-size: 32px;\n        font-weight: 600;\n        margin-bottom: 12px;\n      }\n      p {\n        font-weight: 400;\n        font-size: 20px;\n        color: $secondary_gray;\n      }\n    }\n    .upper-section {\n      .ant-btn {\n        border-radius: 20px;\n        background-color: $secondary;\n      }\n    }\n  }\n\n  .playground_list {\n    list-style: none;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 24px;\n    .list_item {\n      padding: 16px;\n      border: 1px solid #ededed;\n      border-radius: 12px;\n      background-color: #f6f6f6;\n      height: 150px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      .up_side {\n        display: flex;\n        justify-content: space-between;\n        .title {\n          font-size: 24px;\n          font-weight: 600;\n          color: $secondary;\n          cursor: pointer;\n          max-width: 290px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n        .icon {\n          cursor: pointer;\n        }\n      }\n      .low_side {\n        padding-top: 10px;\n        border-top: 1px solid #ededed;\n        .author {\n          display: flex;\n          span {\n            display: flex;\n            margin-right: 5px;\n          }\n          p {\n            display: flex;\n          }\n        }\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n      }\n    }\n  }\n}\n\n.popover_content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  span {\n    display: flex;\n    width: 100px;\n    cursor: pointer;\n    p {\n      font-size: 16px;\n      font-weight: 500;\n      color: #686666;\n    }\n    .icon {\n      width: 20px;\n      height: 20px;\n      margin-right: 8px;\n      color: #686666 !important;\n    }\n  }\n}\n\n.canban_page_wrapper {\n  height: calc(100dvh - 120px) !important;\n  overflow: hidden;\n}\n\n.priority_high {\n  color: #dd2f2f !important;\n}\n.trello_title_wrapper {\n  display: flex;\n  flex-direction: column;\n}\n.trello_back_btn {\n  display: flex;\n  align-items: center;\n  padding-bottom: 20px;\n  width: 100%;\n  * {\n    color: $secondary_gray !important;\n  }\n  div {\n    display: flex;\n    align-items: center;\n    .icon {\n      transform: rotateZ(90deg);\n    }\n  }\n}\n\n.priority_medium {\n  color: #ff9900 !important;\n}\n.priority_low {\n  color: #1953e9 !important;\n}\n\n.trello_column_item {\n  border: 1px solid #a4a4a4;\n  padding: 16px;\n  border-radius: 10px;\n  &:hover {\n    cursor: grab;\n  }\n\n  .item_wrapper {\n    .prpject_title {\n      h2 {\n        font-size: 16px;\n        font-weight: 600;\n        max-width: 205px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: fit-content;\n      }\n    }\n    .priority {\n      display: flex;\n      align-items: center;\n      margin-top: 4px;\n      gap: 20px;\n      margin-bottom: 12px;\n      justify-content: space-between;\n      span {\n        display: block;\n        font-size: 14px;\n        color: #54577a;\n        max-width: 160px !important;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      .icon {\n        min-width: 20px;\n        min-height: 20px;\n        max-width: 20px;\n        max-height: 20px;\n      }\n    }\n    .date {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 12px;\n      .date_wrapper {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        .icon {\n          width: 22px;\n          height: 22px;\n          color: #00c853 !important;\n        }\n      }\n\n      .action {\n        cursor: pointer;\n      }\n    }\n    .members {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      .mine {\n        font-size: 10px;\n        font-weight: 500;\n        padding: 2px 5px;\n        border-radius: 4px;\n        background-color: #edf8fe;\n        color: #517a9a;\n        text-transform: uppercase;\n        box-sizing: border-box;\n        border: 1px solid #32b4fd;\n      }\n    }\n    .creators {\n      cursor: pointer !important;\n      width: fit-content;\n    }\n  }\n}\n.trello_btn_wrapper {\n  height: 70vh;\n  align-items: center;\n  display: flex;\n  padding-left: 20px;\n}\n.add_column_trello {\n  display: flex;\n  min-width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  background-color: $secondary;\n  cursor: pointer;\n  * {\n    color: $light;\n  }\n}\n\n.status {\n  .icon {\n    cursor: pointer;\n  }\n}\n.page_title_wrapper_trello {\n  width: 100%;\n}\n.upper_section_trello {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  .add-btn {\n    .ant-btn {\n      background-color: $secondary !important;\n      border-radius: 20px !important;\n    }\n  }\n}\n\n.colors_for_playground {\n  display: flex;\n  gap: 14px;\n  justify-content: space-between;\n\n  span {\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n}\n.color_label {\n  font-size: 14px;\n  display: flex;\n  margin-bottom: 14px;\n}\n.dragging-overlay-trello {\n  list-style: none;\n  background-color: #fff;\n\n  .item_wrapper {\n    &:hover {\n      cursor: grabbing;\n    }\n    .prpject_title {\n      h2 {\n        font-size: 16px;\n        font-weight: 600;\n      }\n    }\n    .priority {\n      display: flex;\n      align-items: center;\n      margin-top: 4px;\n      gap: 20px;\n      margin-bottom: 12px;\n      span {\n        font-size: 14px;\n        color: #54577a;\n      }\n      .icon {\n        width: 20px;\n        height: 20px;\n      }\n    }\n    .date {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 12px;\n      .date_wrapper {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        .icon {\n          width: 22px;\n          height: 22px;\n        }\n      }\n      .action {\n        .icon {\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n\n.file_upload_trello {\n  .ant-upload-list {\n    display: flex;\n    flex-wrap: wrap;\n    .ant-upload-list-item {\n      margin-right: 10px;\n    }\n  }\n}\n\n.multiple_select_trello {\n  min-height: fit-content;\n  .ant-select-selector {\n    min-height: 44px;\n  }\n  .ant-select {\n    position: relative;\n\n    .ant-select-selection-item {\n      min-height: 40px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      background-color: #e3e9f9;\n      .ant-select-selection-item-content {\n        font-size: 14px;\n        font-weight: 400;\n      }\n    }\n  }\n}\n\n.small-modal {\n  position: relative;\n  z-index: 9999999;\n}\n\n.ant-popover {\n  z-index: 1000;\n}\n\n.task_create_modal_wrapper {\n  padding: 30px;\n  height: 100%;\n  .single-input-item {\n    position: relative;\n    .ant-row {\n      align-items: start;\n      width: 100%;\n      .ant-col {\n        width: 100%;\n      }\n    }\n    label {\n      font-size: 16px;\n      font-weight: 500;\n      color: #131111;\n      text-align: start;\n      display: flex;\n    }\n    input {\n      height: 44px;\n      width: 100%;\n    }\n\n    .ant-select {\n      height: 44px !important;\n      position: relative;\n    }\n    .ant-picker {\n      height: 44px !important;\n    }\n    .ant-form-item {\n      margin-bottom: 0;\n    }\n\n    .ant-form-item-has-error {\n      .PhoneInput {\n        input {\n          border-color: #ff4d4f;\n        }\n      }\n    }\n\n    .PhoneInput {\n      border: none !important;\n      input {\n        border-radius: 6px;\n        outline: none;\n        border: 1px solid #d9d9d9;\n        padding: 4px 11px;\n        font-size: 14px;\n        transition: all 0.3s ease;\n        &::placeholder {\n          color: #bfbfbf;\n        }\n        &:focus {\n          border-color: #1677ff;\n          box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);\n        }\n      }\n      .PhoneInputCountry {\n        display: none;\n      }\n      .PhoneInput--focus {\n        border: 1px solid none !important;\n      }\n    }\n  }\n}\n\n\n.w-full {\n  width: 100%;\n}\n\n.flex-row {\n  display: flex;\n  gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
